import * as FA6 from 'react-icons/fa6';

export { FA6 };

const iconList = [
  {
    name: 'Fa42Group',
    searchTerms: ['42Group', 'Programmieren', 'Schule', 'Ausbildung'],
  },
  {
    name: 'Fa500Px',
    searchTerms: ['500px', 'Fotografie', 'Foto', 'Bild'],
  },
  {
    name: 'FaAccessibleIcon',
    searchTerms: [
      'Barrierefreiheit',
      'Zugänglichkeit',
      'Rollstuhl',
      'Behinderung',
    ],
  },
  {
    name: 'FaAccusoft',
    searchTerms: ['Accusoft', 'Software', 'Bildverarbeitung', 'Technologie'],
  },
  {
    name: 'FaAdn',
    searchTerms: ['ADN', 'Nachrichten', 'Agentur', 'Information'],
  },
  {
    name: 'FaAdversal',
    searchTerms: ['Adversal', 'Werbung', 'Marketing', 'Anzeigen'],
  },
  {
    name: 'FaAffiliatetheme',
    searchTerms: ['Affiliate-Thema', 'WordPress', 'Marketing', 'Thema'],
  },
  {
    name: 'FaAirbnb',
    searchTerms: ['Airbnb', 'Unterkunft', 'Reisen', 'Ferienwohnung'],
  },
  {
    name: 'FaAlgolia',
    searchTerms: ['Algolia', 'Suche', 'API', 'Entwicklung'],
  },
  {
    name: 'FaAlipay',
    searchTerms: ['Alipay', 'Zahlung', 'China', 'Online-Bezahlung'],
  },
  {
    name: 'FaAmazonPay',
    searchTerms: ['Amazon Pay', 'Zahlung', 'Online', 'Einkaufen'],
  },
  {
    name: 'FaAmazon',
    searchTerms: ['Amazon', 'Online-Shop', 'Einkaufen', 'E-Commerce'],
  },
  {
    name: 'FaAmilia',
    searchTerms: ['Amilia', 'Software', 'Management', 'Registrierung'],
  },
  {
    name: 'FaAndroid',
    searchTerms: ['Android', 'Smartphone', 'Handy', 'Betriebssystem'],
  },
  {
    name: 'FaAngellist',
    searchTerms: ['AngelList', 'Startups', 'Investition', 'Unternehmen'],
  },
  {
    name: 'FaAngrycreative',
    searchTerms: ['Angry Creative', 'WordPress', 'Agentur', 'Webdesign'],
  },
  {
    name: 'FaAngular',
    searchTerms: ['Angular', 'JavaScript', 'Framework', 'Webentwicklung'],
  },
  {
    name: 'FaAppStoreIos',
    searchTerms: ['App Store iOS', 'Apple', 'Apps', 'Download'],
  },
  {
    name: 'FaAppStore',
    searchTerms: ['App Store', 'Apple', 'Apps', 'Download'],
  },
  {
    name: 'FaApper',
    searchTerms: ['Apper', 'App', 'Entwicklung', 'Plattform'],
  },
  {
    name: 'FaApplePay',
    searchTerms: ['Apple Pay', 'Zahlung', 'Apple', 'Online-Bezahlung'],
  },
  {
    name: 'FaApple',
    searchTerms: ['Apple', 'Mac', 'iPhone', 'Technologie'],
  },
  {
    name: 'FaArtstation',
    searchTerms: ['ArtStation', 'Kunst', 'Portfolio', 'Designer'],
  },
  {
    name: 'FaAsymmetrik',
    searchTerms: ['Asymmetrik', 'Software', 'Entwicklung', 'Technologie'],
  },
  {
    name: 'FaAtlassian',
    searchTerms: ['Atlassian', 'Jira', 'Software', 'Entwicklung'],
  },
  {
    name: 'FaAudible',
    searchTerms: ['Audible', 'Hörbuch', 'Audio', 'Amazon'],
  },
  {
    name: 'FaAutoprefixer',
    searchTerms: ['Autoprefixer', 'CSS', 'Stylesheet', 'Webentwicklung'],
  },
  {
    name: 'FaAvianex',
    searchTerms: ['Avianex', 'Flug', 'Luftfahrt', 'Vogel'],
  },
  {
    name: 'FaAviato',
    searchTerms: ['Aviato', 'Startup', 'Silicon Valley', 'Flug'],
  },
  {
    name: 'FaAws',
    searchTerms: ['AWS', 'Amazon Web Services', 'Cloud', 'Hosting'],
  },
  {
    name: 'FaBandcamp',
    searchTerms: ['Bandcamp', 'Musik', 'Streaming', 'Audio'],
  },
  {
    name: 'FaBattleNet',
    searchTerms: ['Battle.net', 'Gaming', 'Blizzard', 'Online'],
  },
  {
    name: 'FaBehance',
    searchTerms: ['Behance', 'Portfolio', 'Design', 'Kunst'],
  },
  {
    name: 'FaBilibili',
    searchTerms: ['Bilibili', 'Video', 'China', 'Anime'],
  },
  {
    name: 'FaBimobject',
    searchTerms: ['BIMobject', 'Bau', '3D', 'Modelle'],
  },
  {
    name: 'FaBitbucket',
    searchTerms: ['Bitbucket', 'Code', 'Repository', 'Atlassian'],
  },
  {
    name: 'FaBitcoin',
    searchTerms: ['Bitcoin', 'Kryptowährung', 'BTC', 'Blockchain'],
  },
  {
    name: 'FaBity',
    searchTerms: ['Bity', 'Krypto', 'Wechsel', 'Schweiz'],
  },
  {
    name: 'FaBlackTie',
    searchTerms: ['Black Tie', 'Anzug', 'Krawatte', 'Eleganz'],
  },
  {
    name: 'FaBlackberry',
    searchTerms: ['BlackBerry', 'Smartphone', 'Handy', 'Technologie'],
  },
  {
    name: 'FaBloggerB',
    searchTerms: ['Blogger B', 'Blog', 'Schreiben', 'Google'],
  },
  {
    name: 'FaBlogger',
    searchTerms: ['Blogger', 'Blog', 'Schreiben', 'Google'],
  },
  {
    name: 'FaBluetoothB',
    searchTerms: ['Bluetooth B', 'Funk', 'Verbindung', 'Drahtlos'],
  },
  {
    name: 'FaBluetooth',
    searchTerms: ['Bluetooth', 'Funk', 'Verbindung', 'Drahtlos'],
  },
  {
    name: 'FaBootstrap',
    searchTerms: ['Bootstrap', 'CSS', 'Framework', 'Webdesign'],
  },
  {
    name: 'FaBots',
    searchTerms: ['Bots', 'Roboter', 'Automatisierung', 'KI'],
  },
  {
    name: 'FaBtc',
    searchTerms: ['BTC', 'Bitcoin', 'Kryptowährung', 'Blockchain'],
  },
  {
    name: 'FaBuffer',
    searchTerms: ['Buffer', 'Social Media', 'Planung', 'Beiträge'],
  },
  {
    name: 'FaBuromobelexperte',
    searchTerms: ['Büromöbelexperte', 'Möbel', 'Büro', 'Einrichtung'],
  },
  {
    name: 'FaBuyNLarge',
    searchTerms: ['Buy n Large', 'Kaufhaus', 'Wall-E', 'Film'],
  },
  {
    name: 'FaBuysellads',
    searchTerms: ['BuySellAds', 'Werbung', 'Marketing', 'Anzeigen'],
  },
  {
    name: 'FaCanadianMapleLeaf',
    searchTerms: ['Kanada', 'Ahornblatt', 'Natur', 'Blatt'],
  },
  {
    name: 'FaCcAmazonPay',
    searchTerms: ['Kreditkarte Amazon Pay', 'Zahlung', 'Amazon', 'Karte'],
  },
  {
    name: 'FaCcAmex',
    searchTerms: ['Kreditkarte Amex', 'American Express', 'Zahlung', 'Karte'],
  },
  {
    name: 'FaCcApplePay',
    searchTerms: ['Kreditkarte Apple Pay', 'Zahlung', 'Apple', 'Karte'],
  },
  {
    name: 'FaCcDinersClub',
    searchTerms: ['Kreditkarte Diners Club', 'Zahlung', 'Karte', 'Bank'],
  },
  {
    name: 'FaCcDiscover',
    searchTerms: ['Kreditkarte Discover', 'Zahlung', 'Karte', 'Bank'],
  },
  {
    name: 'FaCcJcb',
    searchTerms: ['Kreditkarte JCB', 'Zahlung', 'Karte', 'Bank'],
  },
  {
    name: 'FaCcMastercard',
    searchTerms: ['Kreditkarte Mastercard', 'Zahlung', 'Karte', 'Bank'],
  },
  {
    name: 'FaCcPaypal',
    searchTerms: ['Kreditkarte PayPal', 'Zahlung', 'Karte', 'Online'],
  },
  {
    name: 'FaCcStripe',
    searchTerms: ['Kreditkarte Stripe', 'Zahlung', 'Karte', 'Online'],
  },
  {
    name: 'FaCcVisa',
    searchTerms: ['Kreditkarte Visa', 'Zahlung', 'Karte', 'Bank'],
  },
  {
    name: 'FaCentercode',
    searchTerms: ['Centercode', 'Beta-Test', 'Software', 'Feedback'],
  },
  {
    name: 'FaCentos',
    searchTerms: ['CentOS', 'Linux', 'Betriebssystem', 'Server'],
  },
  {
    name: 'FaChrome',
    searchTerms: ['Chrome', 'Browser', 'Google', 'Internet'],
  },
  {
    name: 'FaChromecast',
    searchTerms: ['Chromecast', 'Streaming', 'Google', 'TV'],
  },
  {
    name: 'FaCloudflare',
    searchTerms: ['Cloudflare', 'CDN', 'Sicherheit', 'DNS'],
  },
  {
    name: 'FaCloudscale',
    searchTerms: ['Cloudscale', 'Cloud', 'Schweiz', 'Hosting'],
  },
  {
    name: 'FaCloudsmith',
    searchTerms: ['Cloudsmith', 'Paketverwaltung', 'Repository', 'Cloud'],
  },
  {
    name: 'FaCloudversify',
    searchTerms: ['Cloudversify', 'Cloud', 'Automatisierung', 'Integration'],
  },
  {
    name: 'FaCmplid',
    searchTerms: ['CMPLID', 'Compliance', 'Datenschutz', 'GDPR'],
  },
  {
    name: 'FaCodepen',
    searchTerms: ['CodePen', 'Code', 'Entwicklung', 'Snippet'],
  },
  {
    name: 'FaCodiepie',
    searchTerms: ['Codie Pie', 'Logo', 'Design', 'Marke'],
  },
  {
    name: 'FaConfluence',
    searchTerms: ['Confluence', 'Atlassian', 'Wiki', 'Zusammenarbeit'],
  },
  {
    name: 'FaConnectdevelop',
    searchTerms: ['Connect Develop', 'Entwicklung', 'API', 'Verbindung'],
  },
  {
    name: 'FaContao',
    searchTerms: ['Contao', 'CMS', 'Webseite', 'Content-Management'],
  },
  {
    name: 'FaCottonBureau',
    searchTerms: ['Cotton Bureau', 'Kleidung', 'T-Shirts', 'Design'],
  },
  {
    name: 'FaCpanel',
    searchTerms: ['cPanel', 'Hosting', 'Server', 'Verwaltung'],
  },
  {
    name: 'FaCreativeCommonsBy',
    searchTerms: ['Creative Commons BY', 'Lizenz', 'Urheberrecht', 'Freigabe'],
  },
  {
    name: 'FaCreativeCommonsNcEu',
    searchTerms: [
      'Creative Commons NC EU',
      'Lizenz',
      'Nicht kommerziell',
      'Europa',
    ],
  },
  {
    name: 'FaCreativeCommonsNcJp',
    searchTerms: [
      'Creative Commons NC JP',
      'Lizenz',
      'Nicht kommerziell',
      'Japan',
    ],
  },
  {
    name: 'FaCreativeCommonsNc',
    searchTerms: [
      'Creative Commons NC',
      'Lizenz',
      'Nicht kommerziell',
      'Urheberrecht',
    ],
  },
  {
    name: 'FaCreativeCommonsNd',
    searchTerms: [
      'Creative Commons ND',
      'Lizenz',
      'Keine Bearbeitung',
      'Urheberrecht',
    ],
  },
  {
    name: 'FaCreativeCommonsPdAlt',
    searchTerms: [
      'Creative Commons PD Alt',
      'Lizenz',
      'Public Domain',
      'Alternative',
    ],
  },
  {
    name: 'FaCreativeCommonsPd',
    searchTerms: [
      'Creative Commons PD',
      'Lizenz',
      'Public Domain',
      'Gemeinfrei',
    ],
  },
  {
    name: 'FaCreativeCommonsRemix',
    searchTerms: [
      'Creative Commons Remix',
      'Lizenz',
      'Bearbeitung',
      'Urheberrecht',
    ],
  },
  {
    name: 'FaCreativeCommonsSa',
    searchTerms: [
      'Creative Commons SA',
      'Lizenz',
      'Weitergabe unter gleichen Bedingungen',
      'Urheberrecht',
    ],
  },
  {
    name: 'FaCreativeCommonsSamplingPlus',
    searchTerms: [
      'Creative Commons Sampling Plus',
      'Lizenz',
      'Sampling',
      'Urheberrecht',
    ],
  },
  {
    name: 'FaCreativeCommonsSampling',
    searchTerms: [
      'Creative Commons Sampling',
      'Lizenz',
      'Sampling',
      'Urheberrecht',
    ],
  },
  {
    name: 'FaCreativeCommonsShare',
    searchTerms: ['Creative Commons Share', 'Lizenz', 'Teilen', 'Urheberrecht'],
  },
  {
    name: 'FaCreativeCommonsZero',
    searchTerms: [
      'Creative Commons Zero',
      'Lizenz',
      'Gemeinfrei',
      'Urheberrecht',
    ],
  },
  {
    name: 'FaCreativeCommons',
    searchTerms: ['Creative Commons', 'Lizenz', 'Urheberrecht', 'Freigabe'],
  },
  {
    name: 'FaCriticalRole',
    searchTerms: [
      'Critical Role',
      'Rollenspiel',
      'Dungeons & Dragons',
      'Podcast',
    ],
  },
  {
    name: 'FaCss3Alt',
    searchTerms: ['CSS3 Alt', 'Stylesheet', 'Webdesign', 'Layout'],
  },
  {
    name: 'FaCss3',
    searchTerms: ['CSS3', 'Stylesheet', 'Webdesign', 'Layout'],
  },
  {
    name: 'FaCuttlefish',
    searchTerms: ['Cuttlefish', 'Tintenfisch', 'Meer', 'Tier'],
  },
  {
    name: 'FaDAndDBeyond',
    searchTerms: ['D&D Beyond', 'Rollenspiel', 'Dungeons & Dragons', 'Online'],
  },
  {
    name: 'FaDAndD',
    searchTerms: ['Dungeons & Dragons', 'Rollenspiel', 'Fantasy', 'Spiel'],
  },
  {
    name: 'FaDailymotion',
    searchTerms: ['Dailymotion', 'Video', 'Streaming', 'Medien'],
  },
  {
    name: 'FaDashcube',
    searchTerms: ['Dashcube', 'Projektmanagement', 'Team', 'Zusammenarbeit'],
  },
  {
    name: 'FaDebian',
    searchTerms: ['Debian', 'Linux', 'Betriebssystem', 'Open Source'],
  },
  {
    name: 'FaDeezer',
    searchTerms: ['Deezer', 'Musik', 'Streaming', 'Audio'],
  },
  {
    name: 'FaDelicious',
    searchTerms: ['Delicious', 'Lesezeichen', 'Teilen', 'Bookmarking'],
  },
  {
    name: 'FaDeploydog',
    searchTerms: ['Deploydog', 'Deployment', 'DevOps', 'Software'],
  },
  {
    name: 'FaDeskpro',
    searchTerms: ['Deskpro', 'Helpdesk', 'Support', 'Ticketing'],
  },
  {
    name: 'FaDev',
    searchTerms: ['Dev', 'Entwicklung', 'Programmierung', 'Community'],
  },
  {
    name: 'FaDeviantart',
    searchTerms: ['DeviantArt', 'Kunst', 'Community', 'Design'],
  },
  {
    name: 'FaDhl',
    searchTerms: ['DHL', 'Logistik', 'Versand', 'Paket'],
  },
  {
    name: 'FaDiaspora',
    searchTerms: [
      'Diaspora',
      'Soziales Netzwerk',
      'Datenschutz',
      'Open Source',
    ],
  },
  {
    name: 'FaDigg',
    searchTerms: ['Digg', 'Nachrichten', 'Artikel', 'Social News'],
  },
  {
    name: 'FaDigitalOcean',
    searchTerms: ['DigitalOcean', 'Cloud', 'Hosting', 'Server'],
  },
  {
    name: 'FaDiscord',
    searchTerms: ['Discord', 'Chat', 'Gaming', 'Community'],
  },
  {
    name: 'FaDiscourse',
    searchTerms: ['Discourse', 'Forum', 'Diskussion', 'Community'],
  },
  {
    name: 'FaDochub',
    searchTerms: ['DocHub', 'Dokumente', 'PDF', 'Bearbeiten'],
  },
  {
    name: 'FaDocker',
    searchTerms: ['Docker', 'Container', 'Virtualisierung', 'DevOps'],
  },
  {
    name: 'FaDraft2Digital',
    searchTerms: ['Draft2Digital', 'E-Books', 'Veröffentlichung', 'Autoren'],
  },
  {
    name: 'FaDribbble',
    searchTerms: ['Dribbble', 'Design', 'Portfolio', 'Kreativität'],
  },
  {
    name: 'FaDropbox',
    searchTerms: ['Dropbox', 'Cloud', 'Speicher', 'Dateien'],
  },
  {
    name: 'FaDrupal',
    searchTerms: ['Drupal', 'CMS', 'Webseite', 'Content Management'],
  },
  {
    name: 'FaDyalog',
    searchTerms: ['Dyalog', 'APL', 'Programmiersprache', 'Software'],
  },
  {
    name: 'FaEarlybirds',
    searchTerms: ['Earlybirds', 'Startup', 'Investition', 'Innovation'],
  },
  {
    name: 'FaEbay',
    searchTerms: ['eBay', 'Auktion', 'Einkaufen', 'Online Shop'],
  },
  {
    name: 'FaEdgeLegacy',
    searchTerms: ['Edge Legacy', 'Browser', 'Microsoft', 'Internet'],
  },
  {
    name: 'FaEdge',
    searchTerms: ['Edge', 'Browser', 'Microsoft', 'Internet'],
  },
  {
    name: 'FaElementor',
    searchTerms: ['Elementor', 'WordPress', 'Page Builder', 'Webdesign'],
  },
  {
    name: 'FaEllo',
    searchTerms: ['Ello', 'Soziales Netzwerk', 'Kreative', 'Kunst'],
  },
  {
    name: 'FaEmber',
    searchTerms: ['Ember.js', 'JavaScript', 'Framework', 'Webentwicklung'],
  },
  {
    name: 'FaEmpire',
    searchTerms: ['Empire', 'Imperium', 'Star Wars', 'Sci-Fi'],
  },
  {
    name: 'FaEnvira',
    searchTerms: ['Envira', 'Galerie', 'WordPress', 'Bilder'],
  },
  {
    name: 'FaErlang',
    searchTerms: ['Erlang', 'Programmiersprache', 'Concurrent', 'Backend'],
  },
  {
    name: 'FaEthereum',
    searchTerms: ['Ethereum', 'Kryptowährung', 'Blockchain', 'ETH'],
  },
  {
    name: 'FaEtsy',
    searchTerms: ['Etsy', 'Handgemacht', 'Kunst', 'Online Shop'],
  },
  {
    name: 'FaEvernote',
    searchTerms: ['Evernote', 'Notizen', 'Produktivität', 'Organisieren'],
  },
  {
    name: 'FaExpeditedssl',
    searchTerms: ['ExpeditedSSL', 'Sicherheit', 'SSL', 'Verschlüsselung'],
  },
  {
    name: 'FaFacebookF',
    searchTerms: ['Facebook', 'Soziales Netzwerk', 'Medien', 'Kommunikation'],
  },
  {
    name: 'FaFacebookMessenger',
    searchTerms: ['Messenger', 'Chat', 'Nachrichten', 'Facebook'],
  },
  {
    name: 'FaFacebook',
    searchTerms: ['Facebook', 'Soziales Netzwerk', 'Medien', 'Kommunikation'],
  },
  {
    name: 'FaFantasyFlightGames',
    searchTerms: [
      'Fantasy Flight Games',
      'Spiele',
      'Brettspiele',
      'Rollenspiele',
    ],
  },
  {
    name: 'FaFedex',
    searchTerms: ['FedEx', 'Versand', 'Logistik', 'Paket'],
  },
  {
    name: 'FaFedora',
    searchTerms: ['Fedora', 'Linux', 'Betriebssystem', 'Open Source'],
  },
  {
    name: 'FaFigma',
    searchTerms: ['Figma', 'Design', 'UI', 'Prototyping'],
  },
  {
    name: 'FaFirefoxBrowser',
    searchTerms: ['Firefox Browser', 'Mozilla', 'Internet', 'Browser'],
  },
  {
    name: 'FaFirefox',
    searchTerms: ['Firefox', 'Mozilla', 'Internet', 'Browser'],
  },
  {
    name: 'FaFirstOrderAlt',
    searchTerms: ['First Order Alt', 'Star Wars', 'Imperium', 'Sci-Fi'],
  },
  {
    name: 'FaFirstOrder',
    searchTerms: ['First Order', 'Star Wars', 'Imperium', 'Sci-Fi'],
  },
  {
    name: 'FaFirstdraft',
    searchTerms: ['First Draft', 'Journalismus', 'Medien', 'Nachrichten'],
  },
  {
    name: 'FaFlickr',
    searchTerms: ['Flickr', 'Fotos', 'Bilder', 'Community'],
  },
  {
    name: 'FaFlipboard',
    searchTerms: ['Flipboard', 'Nachrichten', 'Magazine', 'Lesen'],
  },
  {
    name: 'FaFly',
    searchTerms: ['Fly.io', 'Cloud', 'Hosting', 'Edge Computing'],
  },
  {
    name: 'FaFontAwesome',
    searchTerms: ['Font Awesome', 'Icons', 'Schriftart', 'Design'],
  },
  {
    name: 'FaFonticonsFi',
    searchTerms: ['Fonticons FI', 'Icons', 'Schriftart', 'Design'],
  },
  {
    name: 'FaFonticons',
    searchTerms: ['Fonticons', 'Icons', 'Schriftart', 'Design'],
  },
  {
    name: 'FaFortAwesomeAlt',
    searchTerms: ['Fort Awesome Alt', 'Icons', 'Schriftart', 'Design'],
  },
  {
    name: 'FaFortAwesome',
    searchTerms: ['Fort Awesome', 'Icons', 'Schriftart', 'Design'],
  },
  {
    name: 'FaForumbee',
    searchTerms: ['Forumbee', 'Forum', 'Community', 'Diskussion'],
  },
  {
    name: 'FaFoursquare',
    searchTerms: ['Foursquare', 'Orte', 'Check-in', 'Soziales Netzwerk'],
  },
  {
    name: 'FaFreeCodeCamp',
    searchTerms: ['freeCodeCamp', 'Programmierung', 'Lernen', 'Code'],
  },
  {
    name: 'FaFreebsd',
    searchTerms: ['FreeBSD', 'Betriebssystem', 'Unix', 'Open Source'],
  },
  {
    name: 'FaFulcrum',
    searchTerms: ['Fulcrum', 'Datenerfassung', 'Mobil', 'Feldarbeit'],
  },
  {
    name: 'FaGalacticRepublic',
    searchTerms: ['Galaktische Republik', 'Star Wars', 'Sci-Fi', 'Republik'],
  },
  {
    name: 'FaGalacticSenate',
    searchTerms: ['Galaktischer Senat', 'Star Wars', 'Sci-Fi', 'Senat'],
  },
  {
    name: 'FaGetPocket',
    searchTerms: ['Pocket', 'Lesen', 'Später', 'Speichern'],
  },
  {
    name: 'FaGgCircle',
    searchTerms: ['GG Circle', 'Spiel', 'Gewinnen', 'Gratulation'],
  },
  {
    name: 'FaGg',
    searchTerms: ['GG', 'Gut gespielt', 'Spiel', 'Gratulation'],
  },
  {
    name: 'FaGitAlt',
    searchTerms: ['Git Alt', 'Versionskontrolle', 'Code', 'Software'],
  },
  {
    name: 'FaGit',
    searchTerms: ['Git', 'Versionskontrolle', 'Code', 'Software'],
  },
  {
    name: 'FaGithubAlt',
    searchTerms: ['GitHub Alt', 'Code', 'Repository', 'Entwicklung'],
  },
  {
    name: 'FaGithub',
    searchTerms: ['GitHub', 'Code', 'Repository', 'Entwicklung'],
  },
  {
    name: 'FaGitkraken',
    searchTerms: ['GitKraken', 'Git', 'Versionskontrolle', 'Software'],
  },
  {
    name: 'FaGitlab',
    searchTerms: ['GitLab', 'Code', 'Repository', 'Entwicklung'],
  },
  {
    name: 'FaGitter',
    searchTerms: ['Gitter', 'Chat', 'Entwicklung', 'Community'],
  },
  {
    name: 'FaGlideG',
    searchTerms: ['Glide G', 'App', 'Entwicklung', 'Mobile'],
  },
  {
    name: 'FaGlide',
    searchTerms: ['Glide', 'App', 'Entwicklung', 'Mobile'],
  },
  {
    name: 'FaGofore',
    searchTerms: ['Gofore', 'Beratung', 'IT', 'Technologie'],
  },
  {
    name: 'FaGolang',
    searchTerms: ['Go', 'Programmiersprache', 'Google', 'Backend'],
  },
  {
    name: 'FaGoodreadsG',
    searchTerms: ['Goodreads G', 'Bücher', 'Lesen', 'Community'],
  },
  {
    name: 'FaGoodreads',
    searchTerms: ['Goodreads', 'Bücher', 'Lesen', 'Community'],
  },
  {
    name: 'FaGoogleDrive',
    searchTerms: ['Google Drive', 'Cloud', 'Speicher', 'Dateien'],
  },
  {
    name: 'FaGooglePay',
    searchTerms: ['Google Pay', 'Zahlung', 'Bezahlen', 'Online'],
  },
  {
    name: 'FaGooglePlay',
    searchTerms: ['Google Play', 'Apps', 'Android', 'Download'],
  },
  {
    name: 'FaGooglePlusG',
    searchTerms: ['Google Plus G', 'Soziales Netzwerk', 'Google', 'Medien'],
  },
  {
    name: 'FaGooglePlus',
    searchTerms: ['Google Plus', 'Soziales Netzwerk', 'Google', 'Medien'],
  },
  {
    name: 'FaGoogleWallet',
    searchTerms: ['Google Wallet', 'Zahlung', 'Bezahlen', 'Online'],
  },
  {
    name: 'FaGoogle',
    searchTerms: ['Google', 'Suche', 'Internet', 'Technologie'],
  },
  {
    name: 'FaGratipay',
    searchTerms: ['Gratipay', 'Spenden', 'Unterstützung', 'Community'],
  },
  {
    name: 'FaGrav',
    searchTerms: ['Grav', 'CMS', 'Webseite', 'Content Management'],
  },
  {
    name: 'FaGripfire',
    searchTerms: ['Gripfire', 'Hosting', 'Cloud', 'Server'],
  },
  {
    name: 'FaGrunt',
    searchTerms: ['Grunt', 'JavaScript', 'Task Runner', 'Automatisierung'],
  },
  {
    name: 'FaGuilded',
    searchTerms: ['Guilded', 'Gaming', 'Community', 'Chat'],
  },
  {
    name: 'FaGulp',
    searchTerms: ['Gulp', 'JavaScript', 'Task Runner', 'Automatisierung'],
  },
  {
    name: 'FaHackerNews',
    searchTerms: ['Hacker News', 'Technologie', 'Nachrichten', 'Community'],
  },
  {
    name: 'FaHackerrank',
    searchTerms: ['HackerRank', 'Programmierung', 'Code', 'Übungen'],
  },
  {
    name: 'FaHashnode',
    searchTerms: ['Hashnode', 'Blog', 'Entwicklung', 'Community'],
  },
  {
    name: 'FaHips',
    searchTerms: ['HIPS', 'Sicherheit', 'Schutz', 'Intrusion Prevention'],
  },
  {
    name: 'FaHireAHelper',
    searchTerms: ['HireAHelper', 'Umzug', 'Dienstleistung', 'Helfer'],
  },
  {
    name: 'FaHive',
    searchTerms: ['Hive', 'Big Data', 'Datenbank', 'Apache'],
  },
  {
    name: 'FaHooli',
    searchTerms: ['Hooli', 'Silicon Valley', 'Technologie', 'Fiktional'],
  },
  {
    name: 'FaHornbill',
    searchTerms: ['Hornbill', 'Service Management', 'IT', 'Software'],
  },
  {
    name: 'FaHotjar',
    searchTerms: ['Hotjar', 'Analyse', 'Heatmap', 'Benutzerverhalten'],
  },
  {
    name: 'FaHouzz',
    searchTerms: ['Houzz', 'Innenarchitektur', 'Haus', 'Design'],
  },
  {
    name: 'FaHtml5',
    searchTerms: ['HTML5', 'Webentwicklung', 'Markup', 'Sprache'],
  },
  {
    name: 'FaHubspot',
    searchTerms: ['HubSpot', 'Marketing', 'CRM', 'Sales'],
  },
  {
    name: 'FaIdeal',
    searchTerms: ['iDEAL', 'Zahlung', 'Online-Banking', 'Niederlande'],
  },
  {
    name: 'FaImdb',
    searchTerms: ['IMDb', 'Filme', 'Bewertungen', 'Kino'],
  },
  {
    name: 'FaInstagram',
    searchTerms: ['Instagram', 'Foto', 'Soziales Netzwerk', 'Medien'],
  },
  {
    name: 'FaInstalod',
    searchTerms: ['Instalod', '3D', 'Optimierung', 'Grafik'],
  },
  {
    name: 'FaIntercom',
    searchTerms: ['Intercom', 'Kundenservice', 'Chat', 'Support'],
  },
  {
    name: 'FaInternetExplorer',
    searchTerms: ['Internet Explorer', 'Browser', 'Microsoft', 'Internet'],
  },
  {
    name: 'FaInvision',
    searchTerms: ['InVision', 'Design', 'Prototyping', 'Kollaboration'],
  },
  {
    name: 'FaIoxhost',
    searchTerms: ['Ioxhost', 'Hosting', 'Server', 'Web'],
  },
  {
    name: 'FaItchIo',
    searchTerms: ['itch.io', 'Spiele', 'Indie', 'Plattform'],
  },
  {
    name: 'FaItunesNote',
    searchTerms: ['iTunes Note', 'Musik', 'Apple', 'Medien'],
  },
  {
    name: 'FaItunes',
    searchTerms: ['iTunes', 'Musik', 'Apple', 'Medien'],
  },
  {
    name: 'FaJava',
    searchTerms: ['Java', 'Programmierung', 'Sprache', 'Software'],
  },
  {
    name: 'FaJediOrder',
    searchTerms: ['Jedi-Orden', 'Star Wars', 'Sci-Fi', 'Film'],
  },
  {
    name: 'FaJenkins',
    searchTerms: ['Jenkins', 'CI/CD', 'Automatisierung', 'Software'],
  },
  {
    name: 'FaJira',
    searchTerms: ['Jira', 'Projektmanagement', 'Atlassian', 'Software'],
  },
  {
    name: 'FaJoget',
    searchTerms: ['Joget', 'Workflow', 'Automatisierung', 'Anwendungen'],
  },
  {
    name: 'FaJoomla',
    searchTerms: ['Joomla', 'CMS', 'Webseite', 'Content-Management'],
  },
  {
    name: 'FaJs',
    searchTerms: ['JavaScript', 'JS', 'Programmierung', 'Webentwicklung'],
  },
  {
    name: 'FaJsfiddle',
    searchTerms: ['JSFiddle', 'Code', 'Sandbox', 'Entwicklung'],
  },
  {
    name: 'FaKaggle',
    searchTerms: ['Kaggle', 'Daten', 'Machine Learning', 'Wettbewerb'],
  },
  {
    name: 'FaKeybase',
    searchTerms: ['Keybase', 'Verschlüsselung', 'Sicherheit', 'Chat'],
  },
  {
    name: 'FaKeycdn',
    searchTerms: ['KeyCDN', 'CDN', 'Content Delivery', 'Hosting'],
  },
  {
    name: 'FaKickstarterK',
    searchTerms: ['Kickstarter K', 'Crowdfunding', 'Projekte', 'Finanzierung'],
  },
  {
    name: 'FaKickstarter',
    searchTerms: ['Kickstarter', 'Crowdfunding', 'Projekte', 'Finanzierung'],
  },
  {
    name: 'FaKorvue',
    searchTerms: ['Korvue', 'Salon', 'Software', 'Management'],
  },
  {
    name: 'FaLaravel',
    searchTerms: ['Laravel', 'PHP', 'Framework', 'Webentwicklung'],
  },
  {
    name: 'FaLastfm',
    searchTerms: ['Last.fm', 'Musik', 'Streaming', 'Audio'],
  },
  {
    name: 'FaLeanpub',
    searchTerms: ['Leanpub', 'E-Books', 'Veröffentlichung', 'Autoren'],
  },
  {
    name: 'FaLess',
    searchTerms: ['LESS', 'CSS', 'Stylesheet', 'Präprozessor'],
  },
  {
    name: 'FaLine',
    searchTerms: ['LINE', 'Chat', 'Nachrichten', 'Kommunikation'],
  },
  {
    name: 'FaLinkedinIn',
    searchTerms: ['LinkedIn In', 'Beruf', 'Netzwerk', 'Karriere'],
  },
  {
    name: 'FaLinkedin',
    searchTerms: ['LinkedIn', 'Beruf', 'Netzwerk', 'Karriere'],
  },
  {
    name: 'FaLinode',
    searchTerms: ['Linode', 'Hosting', 'Cloud', 'Server'],
  },
  {
    name: 'FaLinux',
    searchTerms: ['Linux', 'Betriebssystem', 'Open Source', 'Computer'],
  },
  {
    name: 'FaLyft',
    searchTerms: ['Lyft', 'Transport', 'Fahrt', 'Taxi'],
  },
  {
    name: 'FaMagento',
    searchTerms: ['Magento', 'E-Commerce', 'Shop', 'Webentwicklung'],
  },
  {
    name: 'FaMailchimp',
    searchTerms: ['Mailchimp', 'E-Mail', 'Marketing', 'Newsletter'],
  },
  {
    name: 'FaMandalorian',
    searchTerms: ['Mandalorian', 'Star Wars', 'Serie', 'Sci-Fi'],
  },
  {
    name: 'FaMarkdown',
    searchTerms: ['Markdown', 'Text', 'Formatierung', 'Schreiben'],
  },
  {
    name: 'FaMastodon',
    searchTerms: [
      'Mastodon',
      'Soziales Netzwerk',
      'Microblogging',
      'Open Source',
    ],
  },
  {
    name: 'FaMaxcdn',
    searchTerms: ['MaxCDN', 'CDN', 'Content Delivery', 'Hosting'],
  },
  {
    name: 'FaMdb',
    searchTerms: ['MDB', 'Material Design', 'Bootstrap', 'UI'],
  },
  {
    name: 'FaMedapps',
    searchTerms: ['MedApps', 'Medizin', 'Apps', 'Gesundheit'],
  },
  {
    name: 'FaMedium',
    searchTerms: ['Medium', 'Blog', 'Schreiben', 'Artikel'],
  },
  {
    name: 'FaMedrt',
    searchTerms: ['MedRT', 'Medizin', 'Forschung', 'Technologie'],
  },
  {
    name: 'FaMeetup',
    searchTerms: ['Meetup', 'Treffen', 'Gruppen', 'Community'],
  },
  {
    name: 'FaMegaport',
    searchTerms: ['Megaport', 'Netzwerk', 'Cloud', 'Verbindung'],
  },
  {
    name: 'FaMendeley',
    searchTerms: ['Mendeley', 'Referenzen', 'Forschung', 'Akademisch'],
  },
  {
    name: 'FaMeta',
    searchTerms: ['Meta', 'Facebook', 'Unternehmen', 'Technologie'],
  },
  {
    name: 'FaMicroblog',
    searchTerms: ['Microblog', 'Blog', 'Kurzbeiträge', 'Soziales Netzwerk'],
  },
  {
    name: 'FaMicrosoft',
    searchTerms: ['Microsoft', 'Windows', 'Software', 'Technologie'],
  },
  {
    name: 'FaMix',
    searchTerms: ['Mix', 'Musik', 'DJ', 'Audio'],
  },
  {
    name: 'FaMixcloud',
    searchTerms: ['Mixcloud', 'Musik', 'Streaming', 'DJ'],
  },
  {
    name: 'FaMixer',
    searchTerms: ['Mixer', 'Streaming', 'Gaming', 'Microsoft'],
  },
  {
    name: 'FaMizuni',
    searchTerms: ['Mizuni', 'Daten', 'Schule', 'Bildung'],
  },
  {
    name: 'FaModx',
    searchTerms: ['MODX', 'CMS', 'Webseite', 'Content-Management'],
  },
  {
    name: 'FaMonero',
    searchTerms: ['Monero', 'Kryptowährung', 'XMR', 'Blockchain'],
  },
  {
    name: 'FaNapster',
    searchTerms: ['Napster', 'Musik', 'Streaming', 'Audio'],
  },
  {
    name: 'FaNeos',
    searchTerms: ['Neos', 'CMS', 'Webseite', 'Content-Management'],
  },
  {
    name: 'FaNfcDirectional',
    searchTerms: ['NFC Richtung', 'Kontaktlos', 'Datenübertragung', 'Funk'],
  },
  {
    name: 'FaNfcSymbol',
    searchTerms: ['NFC Symbol', 'Kontaktlos', 'Datenübertragung', 'Funk'],
  },
  {
    name: 'FaNimblr',
    searchTerms: ['Nimblr', 'Kalender', 'Terminplanung', 'Automatisierung'],
  },
  {
    name: 'FaNodeJs',
    searchTerms: ['Node.js', 'JavaScript', 'Server', 'Backend'],
  },
  {
    name: 'FaNode',
    searchTerms: ['Node.js', 'JavaScript', 'Server', 'Backend'],
  },
  {
    name: 'FaNpm',
    searchTerms: ['npm', 'Paketmanager', 'JavaScript', 'Node.js'],
  },
  {
    name: 'FaNs8',
    searchTerms: ['NS8', 'Sicherheit', 'E-Commerce', 'Betrugsprävention'],
  },
  {
    name: 'FaNutritionix',
    searchTerms: ['Nutritionix', 'Ernährung', 'Kalorien', 'Datenbank'],
  },
  {
    name: 'FaOctopusDeploy',
    searchTerms: ['Octopus Deploy', 'Deployment', 'DevOps', 'Automatisierung'],
  },
  {
    name: 'FaOdnoklassniki',
    searchTerms: ['Odnoklassniki', 'Russland', 'Soziales Netzwerk', 'Freunde'],
  },
  {
    name: 'FaOdysee',
    searchTerms: ['Odysee', 'Video', 'Plattform', 'Blockchain'],
  },
  {
    name: 'FaOldRepublic',
    searchTerms: ['Alte Republik', 'Star Wars', 'Sci-Fi', 'Spiel'],
  },
  {
    name: 'FaOpencart',
    searchTerms: ['OpenCart', 'E-Commerce', 'Shop', 'Webentwicklung'],
  },
  {
    name: 'FaOpenid',
    searchTerms: ['OpenID', 'Authentifizierung', 'Login', 'Sicherheit'],
  },
  {
    name: 'FaOpera',
    searchTerms: ['Opera', 'Browser', 'Internet', 'Software'],
  },
  {
    name: 'FaOptinMonster',
    searchTerms: ['OptinMonster', 'Marketing', 'Lead-Generierung', 'Popup'],
  },
  {
    name: 'FaOrcid',
    searchTerms: ['ORCID', 'Forscher', 'Identifikation', 'Publikation'],
  },
  {
    name: 'FaOsi',
    searchTerms: ['OSI', 'Open Source', 'Initiative', 'Software'],
  },
  {
    name: 'FaPadlet',
    searchTerms: ['Padlet', 'Kollaboration', 'Whiteboard', 'Bildung'],
  },
  {
    name: 'FaPage4',
    searchTerms: ['Page4', 'CMS', 'Webseite', 'Content-Management'],
  },
  {
    name: 'FaPagelines',
    searchTerms: ['PageLines', 'WordPress', 'Thema', 'Framework'],
  },
  {
    name: 'FaPalfed',
    searchTerms: ['Palfed', 'Community', 'Unterstützung', 'Netzwerk'],
  },
  {
    name: 'FaPatreon',
    searchTerms: ['Patreon', 'Unterstützung', 'Künstler', 'Crowdfunding'],
  },
  {
    name: 'FaPaypal',
    searchTerms: ['PayPal', 'Zahlung', 'Bezahlen', 'Online'],
  },
  {
    name: 'FaPerbyte',
    searchTerms: ['PerByte', 'Hosting', 'Cloud', 'Server'],
  },
  {
    name: 'FaPeriscope',
    searchTerms: ['Periscope', 'Live-Streaming', 'Video', 'Twitter'],
  },
  {
    name: 'FaPhabricator',
    searchTerms: ['Phabricator', 'Entwicklung', 'Projektmanagement', 'Code'],
  },
  {
    name: 'FaPhoenixFramework',
    searchTerms: ['Phoenix Framework', 'Elixir', 'Webentwicklung', 'Backend'],
  },
  {
    name: 'FaPhoenixSquadron',
    searchTerms: ['Phoenix-Staffel', 'Star Wars', 'Rebellen', 'Sci-Fi'],
  },
  {
    name: 'FaPhp',
    searchTerms: ['PHP', 'Programmierung', 'Webentwicklung', 'Backend'],
  },
  {
    name: 'FaPiedPiperAlt',
    searchTerms: ['Pied Piper Alt', 'Silicon Valley', 'Startup', 'Fiktional'],
  },
  {
    name: 'FaPiedPiperHat',
    searchTerms: ['Pied Piper Hat', 'Silicon Valley', 'Startup', 'Fiktional'],
  },
  {
    name: 'FaPiedPiperPp',
    searchTerms: ['Pied Piper PP', 'Silicon Valley', 'Startup', 'Fiktional'],
  },
  {
    name: 'FaPiedPiper',
    searchTerms: ['Pied Piper', 'Silicon Valley', 'Startup', 'Fiktional'],
  },
  {
    name: 'FaPinterestP',
    searchTerms: ['Pinterest P', 'Bilder', 'Inspiration', 'Soziales Netzwerk'],
  },
  {
    name: 'FaPinterest',
    searchTerms: ['Pinterest', 'Bilder', 'Inspiration', 'Soziales Netzwerk'],
  },
  {
    name: 'FaPix',
    searchTerms: ['Pix', 'Zahlung', 'Brasilien', 'Überweisung'],
  },
  {
    name: 'FaPlaystation',
    searchTerms: ['Playstation', 'Konsole', 'Gaming', 'Sony'],
  },
  {
    name: 'FaProductHunt',
    searchTerms: ['ProductHunt', 'Startups', 'Innovation', 'Produkte'],
  },
  {
    name: 'FaPushed',
    searchTerms: ['Pushed', 'Benachrichtigung', 'Push', 'App'],
  },
  {
    name: 'FaPython',
    searchTerms: [
      'Python',
      'Programmiersprache',
      'Softwareentwicklung',
      'Code',
    ],
  },
  {
    name: 'FaQq',
    searchTerms: ['QQ', 'Chat', 'Nachrichten', 'China'],
  },
  {
    name: 'FaQuinscape',
    searchTerms: ['Quinscape', 'Software', 'Entwicklung', 'Daten'],
  },
  {
    name: 'FaQuora',
    searchTerms: ['Quora', 'Fragen', 'Wissen', 'Antworten'],
  },
  {
    name: 'FaRProject',
    searchTerms: [
      'R Project',
      'Statistik',
      'Datenanalyse',
      'Programmiersprache',
    ],
  },
  {
    name: 'FaRaspberryPi',
    searchTerms: [
      'Raspberry Pi',
      'Hardware',
      'Mini-Computer',
      'Programmierung',
    ],
  },
  {
    name: 'FaRavelry',
    searchTerms: ['Ravelry', 'Stricken', 'Häkeln', 'Handarbeit'],
  },
  {
    name: 'FaReact',
    searchTerms: ['React', 'JavaScript', 'Framework', 'Frontend'],
  },
  {
    name: 'FaReacteurope',
    searchTerms: ['React Europe', 'Konferenz', 'Frontend', 'JavaScript'],
  },
  {
    name: 'FaReadme',
    searchTerms: ['Readme', 'Dokumentation', 'Software', 'Code'],
  },
  {
    name: 'FaRebel',
    searchTerms: ['Rebel', 'Revolution', 'Unabhängigkeit', 'Symbol'],
  },
  {
    name: 'FaRedRiver',
    searchTerms: ['Red River', 'Firma', 'Technologie', 'IT'],
  },
  {
    name: 'FaRedditAlien',
    searchTerms: ['Reddit Alien', 'Reddit', 'Forum', 'Community'],
  },
  {
    name: 'FaReddit',
    searchTerms: ['Reddit', 'Forum', 'Community', 'Diskussionen'],
  },
  {
    name: 'FaRedhat',
    searchTerms: ['Red Hat', 'Linux', 'Open Source', 'Software'],
  },
  {
    name: 'FaRenren',
    searchTerms: ['Renren', 'Social Media', 'China', 'Netzwerk'],
  },
  {
    name: 'FaReplyd',
    searchTerms: ['Replyd', 'Antworten', 'Nachrichten', 'Kommunikation'],
  },
  {
    name: 'FaResearchgate',
    searchTerms: ['ResearchGate', 'Wissenschaft', 'Forschung', 'Papiere'],
  },
  {
    name: 'FaResolving',
    searchTerms: ['Resolving', 'Lösung', 'Problembehebung', 'IT'],
  },
  {
    name: 'FaRev',
    searchTerms: ['Rev', 'Transkription', 'Audio', 'Text'],
  },
  {
    name: 'FaRocketchat',
    searchTerms: ['Rocket.Chat', 'Chat', 'Kommunikation', 'Open Source'],
  },
  {
    name: 'FaRockrms',
    searchTerms: ['RockRMS', 'Kirchen', 'Verwaltung', 'Ressourcenmanagement'],
  },
  {
    name: 'FaRust',
    searchTerms: [
      'Rust',
      'Programmiersprache',
      'Systementwicklung',
      'Speichersicherheit',
    ],
  },
  {
    name: 'FaSafari',
    searchTerms: ['Safari', 'Browser', 'Apple', 'Web'],
  },
  {
    name: 'FaSalesforce',
    searchTerms: ['Salesforce', 'CRM', 'Kundenmanagement', 'Software'],
  },
  {
    name: 'FaSass',
    searchTerms: ['Sass', 'CSS', 'Stile', 'Frontend'],
  },
  {
    name: 'FaSchlix',
    searchTerms: ['Schlix', 'CMS', 'Websites', 'Verwaltung'],
  },
  {
    name: 'FaScreenpal',
    searchTerms: ['ScreenPal', 'Bildschirmaufnahme', 'Video', 'Tutorial'],
  },
  {
    name: 'FaScribd',
    searchTerms: ['Scribd', 'E-Books', 'Dokumente', 'Lesen'],
  },
  {
    name: 'FaSearchengin',
    searchTerms: ['Searchengin', 'Suchmaschine', 'Websuche', 'Optimierung'],
  },
  {
    name: 'FaSellcast',
    searchTerms: ['SellCast', 'Verkauf', 'Podcast', 'Markt'],
  },
  {
    name: 'FaSellsy',
    searchTerms: ['Sellsy', 'CRM', 'Vertrieb', 'Software'],
  },
  {
    name: 'FaServicestack',
    searchTerms: ['ServiceStack', 'Framework', 'Softwareentwicklung', 'APIs'],
  },
  {
    name: 'FaShirtsinbulk',
    searchTerms: ['ShirtsInBulk', 'Großhandel', 'Bekleidung', 'Shirts'],
  },
  {
    name: 'FaShopify',
    searchTerms: ['Shopify', 'E-Commerce', 'Online-Shop', 'Verkauf'],
  },
  {
    name: 'FaShopware',
    searchTerms: ['Shopware', 'E-Commerce', 'Online-Shop', 'Software'],
  },
  {
    name: 'FaSimplybuilt',
    searchTerms: ['SimplyBuilt', 'Websites', 'Baukasten', 'Design'],
  },
  {
    name: 'FaSistrix',
    searchTerms: ['Sistrix', 'SEO', 'Analyse', 'Suchmaschinen'],
  },
  {
    name: 'FaSith',
    searchTerms: ['Sith', 'Star Wars', 'Dunkle Seite', 'Science-Fiction'],
  },
  {
    name: 'FaSitrox',
    searchTerms: ['Sitrox', 'Technologie', 'IT', 'Cloud'],
  },
  {
    name: 'FaSketch',
    searchTerms: ['Sketch', 'Design', 'UI', 'Prototyping'],
  },
  {
    name: 'FaSkyatlas',
    searchTerms: ['SkyAtlas', 'Cloud', 'Hosting', 'Infrastruktur'],
  },
  {
    name: 'FaSkype',
    searchTerms: ['Skype', 'Videoanruf', 'Chat', 'Microsoft'],
  },
  {
    name: 'FaSlack',
    searchTerms: ['Slack', 'Chat', 'Teamarbeit', 'Kommunikation'],
  },
  {
    name: 'FaSlideshare',
    searchTerms: ['SlideShare', 'Präsentationen', 'Teilen', 'Inhalte'],
  },
  {
    name: 'FaSnapchat',
    searchTerms: ['Snapchat', 'Social Media', 'Bilder', 'Nachrichten'],
  },
  {
    name: 'FaSoundcloud',
    searchTerms: ['SoundCloud', 'Musik', 'Audio', 'Streaming'],
  },
  {
    name: 'FaSourcetree',
    searchTerms: [
      'SourceTree',
      'Git',
      'Versionskontrolle',
      'Softwareentwicklung',
    ],
  },
  {
    name: 'FaSpaceAwesome',
    searchTerms: ['Space Awesome', 'Icons', 'Design', 'Web'],
  },
  {
    name: 'FaSpeakap',
    searchTerms: ['Speakap', 'Kommunikation', 'Netzwerk', 'Team'],
  },
  {
    name: 'FaSpeakerDeck',
    searchTerms: ['SpeakerDeck', 'Präsentationen', 'Teilen', 'Slides'],
  },
  {
    name: 'FaSpotify',
    searchTerms: ['Spotify', 'Musik', 'Streaming', 'Audio'],
  },
  {
    name: 'FaSquareBehance',
    searchTerms: ['Behance', 'Kreativität', 'Design', 'Portfolio'],
  },
  {
    name: 'FaSquareDribbble',
    searchTerms: ['Dribbble', 'Design', 'Portfolio', 'Kreativität'],
  },
  {
    name: 'FaSquareFacebook',
    searchTerms: ['Facebook', 'Social Media', 'Netzwerk', 'Freunde'],
  },
  {
    name: 'FaSquareFontAwesomeStroke',
    searchTerms: ['FontAwesome', 'Icons', 'Webdesign', 'Schriftarten'],
  },
  {
    name: 'FaSquareFontAwesome',
    searchTerms: ['FontAwesome', 'Icons', 'Webdesign', 'Schriftarten'],
  },
  {
    name: 'FaSquareGit',
    searchTerms: ['Git', 'Versionskontrolle', 'Softwareentwicklung', 'Code'],
  },
  {
    name: 'FaSquareGithub',
    searchTerms: ['GitHub', 'Code', 'Versionskontrolle', 'Software'],
  },
  {
    name: 'FaSquareGitlab',
    searchTerms: ['GitLab', 'Code', 'Versionskontrolle', 'Softwareentwicklung'],
  },
  {
    name: 'FaSquareGooglePlus',
    searchTerms: ['Google+', 'Social Media', 'Google', 'Netzwerk'],
  },
  {
    name: 'FaSquareHackerNews',
    searchTerms: ['Hacker News', 'Technologie', 'Nachrichten', 'Diskussionen'],
  },
  {
    name: 'FaSquareInstagram',
    searchTerms: ['Instagram', 'Fotos', 'Social Media', 'Bilder'],
  },
  {
    name: 'FaSquareJs',
    searchTerms: ['JavaScript', 'Code', 'Webentwicklung', 'Frontend'],
  },
  {
    name: 'FaSquareLastfm',
    searchTerms: ['Last.fm', 'Musik', 'Streaming', 'Audio'],
  },
  {
    name: 'FaSquareOdnoklassniki',
    searchTerms: ['Odnoklassniki', 'Russland', 'Netzwerk', 'Social Media'],
  },
  {
    name: 'FaSquarePiedPiper',
    searchTerms: ['Pied Piper', 'Startup', 'Silicon Valley', 'Komödie'],
  },
  {
    name: 'FaSquarePinterest',
    searchTerms: ['Pinterest', 'Bilder', 'Social Media', 'Ideen'],
  },
  {
    name: 'FaSquareReddit',
    searchTerms: ['Reddit', 'Forum', 'Diskussionen', 'Community'],
  },
  {
    name: 'FaSquareSnapchat',
    searchTerms: ['Snapchat', 'Social Media', 'Bilder', 'Nachrichten'],
  },
  {
    name: 'FaSquareSteam',
    searchTerms: ['Steam', 'Spiele', 'Gaming', 'PC'],
  },
  {
    name: 'FaSquareThreads',
    searchTerms: ['Threads', 'Social Media', 'Meta', 'Kommunikation'],
  },
  {
    name: 'FaSquareTumblr',
    searchTerms: ['Tumblr', 'Blogging', 'Bilder', 'Community'],
  },
  {
    name: 'FaSquareTwitter',
    searchTerms: ['Twitter', 'Social Media', 'Nachrichten', 'Tweets'],
  },
  {
    name: 'FaSquareViadeo',
    searchTerms: ['Viadeo', 'Social Media', 'Netzwerk', 'Beruflich'],
  },
  {
    name: 'FaSquareVimeo',
    searchTerms: ['Vimeo', 'Videos', 'Streaming', 'Kreativität'],
  },
  {
    name: 'FaSquareWhatsapp',
    searchTerms: ['WhatsApp', 'Chat', 'Nachrichten', 'Kommunikation'],
  },
  {
    name: 'FaSquareXTwitter',
    searchTerms: ['X (Twitter)', 'Social Media', 'Nachrichten', 'Tweets'],
  },
  {
    name: 'FaSquareXing',
    searchTerms: ['Xing', 'Beruflich', 'Netzwerk', 'Jobs'],
  },
  {
    name: 'FaSquareYoutube',
    searchTerms: ['YouTube', 'Videos', 'Streaming', 'Kreativität'],
  },
  {
    name: 'FaSquarespace',
    searchTerms: ['Squarespace', 'Websites', 'Design', 'Baukasten'],
  },
  {
    name: 'FaStackExchange',
    searchTerms: ['Stack Exchange', 'Fragen', 'Community', 'Antworten'],
  },
  {
    name: 'FaStackOverflow',
    searchTerms: ['Stack Overflow', 'Programmierer', 'Fragen', 'Code'],
  },
  {
    name: 'FaStackpath',
    searchTerms: ['StackPath', 'Cloud', 'Sicherheit', 'Hosting'],
  },
  {
    name: 'FaStaylinked',
    searchTerms: ['StayLinked', 'Software', 'Mobile', 'Terminalemulation'],
  },
  {
    name: 'FaSteamSymbol',
    searchTerms: ['Steam', 'Symbol', 'Gaming', 'Plattform'],
  },
  {
    name: 'FaSteam',
    searchTerms: ['Steam', 'Spiele', 'Gaming', 'PC'],
  },
  {
    name: 'FaStickerMule',
    searchTerms: ['Sticker Mule', 'Aufkleber', 'Produktion', 'Design'],
  },
  {
    name: 'FaStrava',
    searchTerms: ['Strava', 'Sport', 'Laufen', 'Fahrradfahren'],
  },
  {
    name: 'FaStripeS',
    searchTerms: ['Stripe S', 'Zahlung', 'Online', 'Finanzen'],
  },
  {
    name: 'FaStripe',
    searchTerms: ['Stripe', 'Zahlung', 'Online', 'Finanzen'],
  },
  {
    name: 'FaStubber',
    searchTerms: ['Stubber', 'Video', 'Streaming', 'Unterhaltung'],
  },
  {
    name: 'FaStudiovinari',
    searchTerms: ['Studio Vinari', 'Kreativität', 'Design', 'Marketing'],
  },
  {
    name: 'FaStumbleuponCircle',
    searchTerms: ['StumbleUpon', 'Entdeckung', 'Webseiten', 'Empfehlungen'],
  },
  {
    name: 'FaStumbleupon',
    searchTerms: ['StumbleUpon', 'Entdeckung', 'Webseiten', 'Empfehlungen'],
  },
  {
    name: 'FaSuperpowers',
    searchTerms: ['Superpowers', 'Fähigkeiten', 'Kräfte', 'Helden'],
  },
  {
    name: 'FaSupple',
    searchTerms: ['Supple', 'Mobilität', 'Fitness', 'Beweglichkeit'],
  },
  {
    name: 'FaSuse',
    searchTerms: ['Suse', 'Linux', 'Software', 'Betriebssystem'],
  },
  {
    name: 'FaSwift',
    searchTerms: ['Swift', 'Programmiersprache', 'Apple', 'Entwicklung'],
  },
  {
    name: 'FaSymfony',
    searchTerms: ['Symfony', 'PHP', 'Framework', 'Webentwicklung'],
  },
  {
    name: 'FaTeamspeak',
    searchTerms: ['Teamspeak', 'VoIP', 'Kommunikation', 'Gaming'],
  },
  {
    name: 'FaTelegram',
    searchTerms: ['Telegram', 'Messaging', 'Chat', 'Kommunikation'],
  },
  {
    name: 'FaTencentWeibo',
    searchTerms: ['Tencent Weibo', 'Soziale Medien', 'China', 'Microblogging'],
  },
  {
    name: 'FaTheRedYeti',
    searchTerms: ['The Red Yeti', 'Yeti', 'Branding', 'Marke'],
  },
  {
    name: 'FaThemeco',
    searchTerms: ['Themeco', 'Themes', 'Webentwicklung', 'Design'],
  },
  {
    name: 'FaThemeisle',
    searchTerms: ['Themeisle', 'Themes', 'WordPress', 'Webdesign'],
  },
  {
    name: 'FaThinkPeaks',
    searchTerms: ['Think Peaks', 'Branding', 'Marke', 'Marketing'],
  },
  {
    name: 'FaThreads',
    searchTerms: ['Threads', 'Soziale Medien', 'Meta', 'Kommunikation'],
  },
  {
    name: 'FaTiktok',
    searchTerms: ['Tiktok', 'Videos', 'Soziale Medien', 'Kurzvideos'],
  },
  {
    name: 'FaTradeFederation',
    searchTerms: ['Trade Federation', 'Star Wars', 'Franchise', 'Sci-Fi'],
  },
  {
    name: 'FaTrello',
    searchTerms: ['Trello', 'Projektmanagement', 'Organisation', 'Kanban'],
  },
  {
    name: 'FaTumblr',
    searchTerms: ['Tumblr', 'Microblogging', 'Soziale Medien', 'Blogs'],
  },
  {
    name: 'FaTwitch',
    searchTerms: ['Twitch', 'Streaming', 'Gaming', 'Videos'],
  },
  {
    name: 'FaTwitter',
    searchTerms: [
      'Twitter',
      'Microblogging',
      'Soziale Medien',
      'Kommunikation',
    ],
  },
  {
    name: 'FaTypo3',
    searchTerms: ['Typo3', 'CMS', 'Content Management', 'Webentwicklung'],
  },
  {
    name: 'FaUber',
    searchTerms: ['Uber', 'Transport', 'Mobilität', 'Fahrdienst'],
  },
  {
    name: 'FaUbuntu',
    searchTerms: ['Ubuntu', 'Linux', 'Betriebssystem', 'Open Source'],
  },
  {
    name: 'FaUikit',
    searchTerms: ['Uikit', 'Frontend', 'Framework', 'Webentwicklung'],
  },
  {
    name: 'FaUmbraco',
    searchTerms: ['Umbraco', 'CMS', 'Webentwicklung', 'Content Management'],
  },
  {
    name: 'FaUncharted',
    searchTerms: ['Uncharted', 'Videospiel', 'Action', 'Abenteuer'],
  },
  {
    name: 'FaUniregistry',
    searchTerms: ['Uniregistry', 'Domain', 'Registry', 'Webdienste'],
  },
  {
    name: 'FaUnity',
    searchTerms: ['Unity', 'Game Engine', 'Entwicklung', 'Videospiele'],
  },
  {
    name: 'FaUnsplash',
    searchTerms: ['Unsplash', 'Bilder', 'Fotografie', 'Stockfotos'],
  },
  {
    name: 'FaUntappd',
    searchTerms: ['Untappd', 'Bier', 'App', 'Bewertungen'],
  },
  {
    name: 'FaUps',
    searchTerms: ['UPS', 'Logistik', 'Paketdienst', 'Transport'],
  },
  {
    name: 'FaUsb',
    searchTerms: ['USB', 'Anschluss', 'Datenübertragung', 'Speicher'],
  },
  {
    name: 'FaUsps',
    searchTerms: ['USPS', 'Post', 'Versand', 'Logistik'],
  },
  {
    name: 'FaUssunnah',
    searchTerms: ['Ussunnah', 'Islam', 'Religion', 'Organisation'],
  },
  {
    name: 'FaVaadin',
    searchTerms: ['Vaadin', 'Java', 'Webentwicklung', 'Framework'],
  },
  {
    name: 'FaViacoin',
    searchTerms: ['Viacoin', 'Kryptowährung', 'Blockchain', 'Digital'],
  },
  {
    name: 'FaViadeo',
    searchTerms: ['Viadeo', 'Soziale Netzwerke', 'Karriere', 'Beruf'],
  },
  {
    name: 'FaViber',
    searchTerms: ['Viber', 'Messaging', 'Chat', 'Kommunikation'],
  },
  {
    name: 'FaVimeoV',
    searchTerms: ['Vimeo', 'Videos', 'Plattform', 'Streaming'],
  },
  {
    name: 'FaVimeo',
    searchTerms: ['Vimeo', 'Videos', 'Streaming', 'Plattform'],
  },
  {
    name: 'FaVine',
    searchTerms: ['Vine', 'Videos', 'Kurzvideos', 'Plattform'],
  },
  {
    name: 'FaVk',
    searchTerms: ['VK', 'Soziale Medien', 'Russland', 'Netzwerk'],
  },
  {
    name: 'FaVnv',
    searchTerms: ['VNV', 'Organisation', 'Verband', 'Non-Profit'],
  },
  {
    name: 'FaVuejs',
    searchTerms: ['Vue.js', 'JavaScript', 'Framework', 'Webentwicklung'],
  },
  {
    name: 'FaWatchmanMonitoring',
    searchTerms: ['Watchman Monitoring', 'Monitoring', 'IT', 'Überwachung'],
  },
  {
    name: 'FaWaze',
    searchTerms: ['Waze', 'Navigation', 'Verkehr', 'Maps'],
  },
  {
    name: 'FaWeebly',
    searchTerms: ['Weebly', 'Webentwicklung', 'CMS', 'Webdesign'],
  },
  {
    name: 'FaWeibo',
    searchTerms: ['Weibo', 'Microblogging', 'China', 'Soziale Medien'],
  },
  {
    name: 'FaWeixin',
    searchTerms: ['Weixin', 'WeChat', 'China', 'Messaging'],
  },
  {
    name: 'FaWhatsapp',
    searchTerms: ['Whatsapp', 'Messaging', 'Kommunikation', 'Chat'],
  },
  {
    name: 'FaWhmcs',
    searchTerms: ['WHMCS', 'Hosting', 'Verwaltung', 'Webdienste'],
  },
  {
    name: 'FaWikipediaW',
    searchTerms: ['Wikipedia', 'Enzyklopädie', 'Wissen', 'Webseite'],
  },
  {
    name: 'FaWindows',
    searchTerms: ['Windows', 'Microsoft', 'Betriebssystem', 'Software'],
  },
  {
    name: 'FaWirsindhandwerk',
    searchTerms: ['Wirsindhandwerk', 'Handwerk', 'Branchen', 'Netzwerk'],
  },
  {
    name: 'FaWix',
    searchTerms: ['Wix', 'Webentwicklung', 'CMS', 'Webdesign'],
  },
  {
    name: 'FaWizardsOfTheCoast',
    searchTerms: ['Wizards of the Coast', 'Spiele', 'Fantasy', 'Franchise'],
  },
  {
    name: 'FaWodu',
    searchTerms: ['Wodu', 'Hosting', 'Webdienste', 'Cloud'],
  },
  {
    name: 'FaWolfPackBattalion',
    searchTerms: ['Wolf Pack Battalion', 'Militär', 'Wölfe', 'Organisation'],
  },
  {
    name: 'FaWordpressSimple',
    searchTerms: ['WordPress', 'CMS', 'Blog', 'Webentwicklung'],
  },
  {
    name: 'FaWordpress',
    searchTerms: ['WordPress', 'CMS', 'Webseite', 'Blog'],
  },
  {
    name: 'FaWpbeginner',
    searchTerms: ['WPBeginner', 'WordPress', 'Webentwicklung', 'Tutorial'],
  },
  {
    name: 'FaWpexplorer',
    searchTerms: ['WPExplorer', 'WordPress', 'Webentwicklung', 'Themes'],
  },
  {
    name: 'FaWpforms',
    searchTerms: ['WPForms', 'Formulare', 'WordPress', 'Plugins'],
  },
  {
    name: 'FaWpressr',
    searchTerms: ['WPressr', 'WordPress', 'Webentwicklung', 'Hosting'],
  },
  {
    name: 'FaXTwitter',
    searchTerms: [
      'X (ehemals Twitter)',
      'Microblogging',
      'Kommunikation',
      'Social Media',
    ],
  },
  {
    name: 'FaXbox',
    searchTerms: ['Xbox', 'Gaming', 'Konsolen', 'Microsoft'],
  },
  {
    name: 'FaXing',
    searchTerms: ['Xing', 'Karriere', 'Beruf', 'Soziale Netzwerke'],
  },
  {
    name: 'FaYCombinator',
    searchTerms: ['Y Combinator', 'Startups', 'Investoren', 'Technologie'],
  },
  {
    name: 'FaYahoo',
    searchTerms: ['Yahoo', 'Portal', 'E-Mail', 'Suchmaschine'],
  },
  {
    name: 'FaYammer',
    searchTerms: [
      'Yammer',
      'Kommunikation',
      'Unternehmen',
      'Soziale Netzwerke',
    ],
  },
  {
    name: 'FaYandexInternational',
    searchTerms: [
      'Yandex International',
      'Suchmaschine',
      'Russland',
      'Technologie',
    ],
  },
  {
    name: 'FaYandex',
    searchTerms: ['Yandex', 'Suchmaschine', 'Russland', 'Technologie'],
  },
  {
    name: 'FaYarn',
    searchTerms: ['Yarn', 'Package Manager', 'JavaScript', 'Entwicklung'],
  },
  {
    name: 'FaYelp',
    searchTerms: ['Yelp', 'Bewertungen', 'Lokale Unternehmen', 'Rezensionen'],
  },
  {
    name: 'FaYoast',
    searchTerms: ['Yoast', 'SEO', 'WordPress', 'Optimierung'],
  },
  {
    name: 'FaYoutube',
    searchTerms: ['YouTube', 'Videos', 'Streaming', 'Plattform'],
  },
  {
    name: 'FaZhihu',
    searchTerms: ['Zhihu', 'China', 'Fragen', 'Antworten', 'Plattform'],
  },
  {
    name: 'Fa0',
    searchTerms: ['0', 'Null', 'Zahl', 'Nummer'],
  },
  {
    name: 'Fa1',
    searchTerms: ['1', 'Eins', 'Zahl', 'Nummer'],
  },
  {
    name: 'Fa2',
    searchTerms: ['2', 'Zwei', 'Zahl', 'Nummer'],
  },
  {
    name: 'Fa3',
    searchTerms: ['3', 'Drei', 'Zahl', 'Nummer'],
  },
  {
    name: 'Fa4',
    searchTerms: ['4', 'Vier', 'Zahl', 'Nummer'],
  },
  {
    name: 'Fa5',
    searchTerms: ['5', 'Fünf', 'Zahl', 'Nummer'],
  },
  {
    name: 'Fa6',
    searchTerms: ['6', 'Sechs', 'Zahl', 'Nummer'],
  },
  {
    name: 'Fa7',
    searchTerms: ['7', 'Sieben', 'Zahl', 'Nummer'],
  },
  {
    name: 'Fa8',
    searchTerms: ['8', 'Acht', 'Zahl', 'Nummer'],
  },
  {
    name: 'Fa9',
    searchTerms: ['9', 'Neun', 'Zahl', 'Nummer'],
  },
  {
    name: 'FaA',
    searchTerms: ['A', 'Buchstabe', 'Alphabet', 'Anfang'],
  },
  {
    name: 'FaAddressBook',
    searchTerms: ['Address Book', 'Kontakte', 'Adressbuch', 'Verzeichnis'],
  },
  {
    name: 'FaAddressCard',
    searchTerms: ['Address Card', 'Visitenkarte', 'Kontakt', 'Informationen'],
  },
  {
    name: 'FaAlignCenter',
    searchTerms: ['Align Center', 'Zentrieren', 'Textausrichtung', 'Mitte'],
  },
  {
    name: 'FaAlignJustify',
    searchTerms: ['Align Justify', 'Blocksatz', 'Ausrichtung', 'Text'],
  },
  {
    name: 'FaAlignLeft',
    searchTerms: ['Align Left', 'Links', 'Textausrichtung', 'Text'],
  },
  {
    name: 'FaAlignRight',
    searchTerms: ['Align Right', 'Rechts', 'Textausrichtung', 'Text'],
  },
  {
    name: 'FaAnchorCircleCheck',
    searchTerms: ['Anchor Circle Check', 'Anker', 'Überprüfung', 'Stabilität'],
  },
  {
    name: 'FaAnchorCircleExclamation',
    searchTerms: [
      'Anchor Circle Exclamation',
      'Anker',
      'Warnung',
      'Ausrufezeichen',
    ],
  },
  {
    name: 'FaAnchorCircleXmark',
    searchTerms: ['Anchor Circle Xmark', 'Anker', 'Fehler', 'Kreuz'],
  },
  {
    name: 'FaAnchorLock',
    searchTerms: ['Anchor Lock', 'Anker', 'Sperre', 'Sicherheit'],
  },
  {
    name: 'FaAnchor',
    searchTerms: ['Anchor', 'Anker', 'Stabilität', 'Schiff'],
  },
  {
    name: 'FaAngleDown',
    searchTerms: ['Angle Down', 'Winkel nach unten', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaAngleLeft',
    searchTerms: ['Angle Left', 'Winkel nach links', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaAngleRight',
    searchTerms: ['Angle Right', 'Winkel nach rechts', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaAngleUp',
    searchTerms: ['Angle Up', 'Winkel nach oben', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaAnglesDown',
    searchTerms: [
      'Angles Down',
      'Mehrere Winkel nach unten',
      'Pfeile',
      'Richtung',
    ],
  },
  {
    name: 'FaAnglesLeft',
    searchTerms: [
      'Angles Left',
      'Mehrere Winkel nach links',
      'Pfeile',
      'Richtung',
    ],
  },
  {
    name: 'FaAnglesRight',
    searchTerms: [
      'Angles Right',
      'Mehrere Winkel nach rechts',
      'Pfeile',
      'Richtung',
    ],
  },
  {
    name: 'FaAnglesUp',
    searchTerms: [
      'Angles Up',
      'Mehrere Winkel nach oben',
      'Pfeile',
      'Richtung',
    ],
  },
  {
    name: 'FaAnkh',
    searchTerms: ['Ankh', 'Ägyptisch', 'Symbol', 'Leben'],
  },
  {
    name: 'FaAppleWhole',
    searchTerms: ['Apple Whole', 'Apfel', 'Obst', 'Gesundheit'],
  },
  {
    name: 'FaArchway',
    searchTerms: ['Archway', 'Bogen', 'Architektur', 'Eingang'],
  },
  {
    name: 'FaArrowDown19',
    searchTerms: ['Arrow Down 1-9', 'Pfeil absteigend', 'Sortieren', 'Zahlen'],
  },
  {
    name: 'FaArrowDown91',
    searchTerms: ['Arrow Down 9-1', 'Pfeil absteigend', 'Sortieren', 'Zahlen'],
  },
  {
    name: 'FaArrowDownAZ',
    searchTerms: [
      'Arrow Down A-Z',
      'Alphabetisch absteigend',
      'Sortieren',
      'Pfeil',
    ],
  },
  {
    name: 'FaArrowDownLong',
    searchTerms: [
      'Arrow Down Long',
      'Langer Pfeil nach unten',
      'Richtung',
      'Bewegung',
    ],
  },
  {
    name: 'FaArrowDownShortWide',
    searchTerms: ['Arrow Down Short Wide', 'Sortieren', 'Absteigend', 'Breit'],
  },
  {
    name: 'FaArrowDownUpAcrossLine',
    searchTerms: ['Arrow Down Up Across Line', 'Richtung', 'Wechsel', 'Linie'],
  },
  {
    name: 'FaArrowDownUpLock',
    searchTerms: ['Arrow Down Up Lock', 'Pfeile', 'Sperre', 'Richtung'],
  },
  {
    name: 'FaArrowDownWideShort',
    searchTerms: ['Arrow Down Wide Short', 'Sortieren', 'Breit', 'Kurz'],
  },
  {
    name: 'FaArrowDownZA',
    searchTerms: [
      'Arrow Down Z-A',
      'Alphabetisch absteigend',
      'Pfeil',
      'Sortieren',
    ],
  },
  {
    name: 'FaArrowDown',
    searchTerms: ['Arrow Down', 'Pfeil nach unten', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaArrowLeftLong',
    searchTerms: [
      'Arrow Left Long',
      'Langer Pfeil nach links',
      'Richtung',
      'Bewegung',
    ],
  },
  {
    name: 'FaArrowLeft',
    searchTerms: ['Arrow Left', 'Pfeil nach links', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaArrowPointer',
    searchTerms: ['Arrow Pointer', 'Pfeil', 'Zeiger', 'Mauszeiger'],
  },
  {
    name: 'FaArrowRightArrowLeft',
    searchTerms: [
      'Arrow Right Arrow Left',
      'Wechsel',
      'Richtung',
      'Zwei Pfeile',
    ],
  },
  {
    name: 'FaArrowRightFromBracket',
    searchTerms: ['Arrow Right From Bracket', 'Abmelden', 'Raus', 'Pfeil'],
  },
  {
    name: 'FaArrowRightLong',
    searchTerms: [
      'Arrow Right Long',
      'Langer Pfeil nach rechts',
      'Richtung',
      'Bewegung',
    ],
  },
  {
    name: 'FaArrowRightToBracket',
    searchTerms: ['Arrow Right To Bracket', 'Anmelden', 'Rein', 'Pfeil'],
  },
  {
    name: 'FaArrowRightToCity',
    searchTerms: ['Arrow Right To City', 'Richtung Stadt', 'Bewegung', 'Pfeil'],
  },
  {
    name: 'FaArrowRight',
    searchTerms: ['Arrow Right', 'Pfeil nach rechts', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaArrowRotateLeft',
    searchTerms: ['Arrow Rotate Left', 'Rückgängig', 'Drehen', 'Pfeil'],
  },
  {
    name: 'FaArrowRotateRight',
    searchTerms: ['Arrow Rotate Right', 'Wiederholen', 'Drehen', 'Pfeil'],
  },
  {
    name: 'FaArrowTrendDown',
    searchTerms: ['Arrow Trend Down', 'Abwärtstrend', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaArrowTrendUp',
    searchTerms: ['Arrow Trend Up', 'Aufwärtstrend', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaArrowTurnDown',
    searchTerms: ['Arrow Turn Down', 'Pfeil abbiegen', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaArrowTurnUp',
    searchTerms: ['Arrow Turn Up', 'Pfeil abbiegen', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaArrowUp19',
    searchTerms: ['Arrow Up 1-9', 'Pfeil aufsteigend', 'Sortieren', 'Zahlen'],
  },
  {
    name: 'FaArrowUp91',
    searchTerms: ['Arrow Up 9-1', 'Pfeil aufsteigend', 'Sortieren', 'Zahlen'],
  },
  {
    name: 'FaArrowUpAZ',
    searchTerms: [
      'Arrow Up A-Z',
      'Alphabetisch aufsteigend',
      'Sortieren',
      'Pfeil',
    ],
  },
  {
    name: 'FaArrowUpFromBracket',
    searchTerms: ['Arrow Up From Bracket', 'Export', 'Pfeil', 'Heraus'],
  },
  {
    name: 'FaArrowUpFromGroundWater',
    searchTerms: ['Arrow Up From Ground Water', 'Wasser', 'Boden', 'Pfeil'],
  },
  {
    name: 'FaArrowUpFromWaterPump',
    searchTerms: ['Arrow Up From Water Pump', 'Pumpe', 'Wasser', 'Pfeil'],
  },
  {
    name: 'FaArrowUpLong',
    searchTerms: [
      'Arrow Up Long',
      'Langer Pfeil nach oben',
      'Richtung',
      'Bewegung',
    ],
  },
  {
    name: 'FaArrowUpRightDots',
    searchTerms: ['Arrow Up Right Dots', 'Pfeil', 'Punkte', 'Bewegung'],
  },
  {
    name: 'FaArrowUpRightFromSquare',
    searchTerms: [
      'Arrow Up Right From Square',
      'Externer Link',
      'Richtung',
      'Bewegung',
    ],
  },
  {
    name: 'FaArrowUpShortWide',
    searchTerms: ['Arrow Up Short Wide', 'Sortieren', 'Aufsteigend', 'Breit'],
  },
  {
    name: 'FaArrowUpWideShort',
    searchTerms: ['Arrow Up Wide Short', 'Sortieren', 'Aufsteigend', 'Breit'],
  },
  {
    name: 'FaArrowUpZA',
    searchTerms: [
      'Arrow Up Z-A',
      'Alphabetisch aufsteigend',
      'Sortieren',
      'Pfeil',
    ],
  },
  {
    name: 'FaArrowUp',
    searchTerms: ['Arrow Up', 'Pfeil nach oben', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaArrowsDownToLine',
    searchTerms: ['Arrows Down To Line', 'Pfeile', 'Richtung', 'Linie'],
  },
  {
    name: 'FaArrowsDownToPeople',
    searchTerms: ['Arrows Down To People', 'Menschen', 'Pfeile', 'Richtung'],
  },
  {
    name: 'FaArrowsLeftRightToLine',
    searchTerms: ['Arrows Left Right To Line', 'Pfeile', 'Richtung', 'Linie'],
  },
  {
    name: 'FaArrowsLeftRight',
    searchTerms: ['Arrows Left Right', 'Richtung', 'Wechsel', 'Pfeile'],
  },
  {
    name: 'FaArrowsRotate',
    searchTerms: ['Arrows Rotate', 'Drehen', 'Wiederholen', 'Pfeile'],
  },
  {
    name: 'FaArrowsSpin',
    searchTerms: ['Arrows Spin', 'Drehen', 'Pfeile', 'Rotation'],
  },
  {
    name: 'FaArrowsSplitUpAndLeft',
    searchTerms: ['Arrows Split Up And Left', 'Pfeile', 'Richtung', 'Teilen'],
  },
  {
    name: 'FaArrowsToCircle',
    searchTerms: ['Arrows To Circle', 'Pfeile', 'Kreis', 'Richtung'],
  },
  {
    name: 'FaArrowsToDot',
    searchTerms: ['Arrows To Dot', 'Pfeile', 'Punkt', 'Ziel'],
  },
  {
    name: 'FaArrowsToEye',
    searchTerms: ['Arrows To Eye', 'Pfeile', 'Auge', 'Fokus'],
  },
  {
    name: 'FaArrowsTurnRight',
    searchTerms: ['Arrows Turn Right', 'Richtung', 'Drehen', 'Pfeile'],
  },
  {
    name: 'FaArrowsTurnToDots',
    searchTerms: ['Arrows Turn To Dots', 'Pfeile', 'Punkte', 'Wechsel'],
  },
  {
    name: 'FaArrowsUpDownLeftRight',
    searchTerms: [
      'Arrows Up Down Left Right',
      'Pfeile',
      'Richtung',
      'Vier Wege',
    ],
  },
  {
    name: 'FaArrowsUpDown',
    searchTerms: ['Arrows Up Down', 'Pfeile', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaArrowsUpToLine',
    searchTerms: ['Arrows Up To Line', 'Pfeile', 'Richtung', 'Linie'],
  },
  {
    name: 'FaAsterisk',
    searchTerms: ['Asterisk', 'Sternchen', 'Symbol', 'Zeichen'],
  },
  {
    name: 'FaAt',
    searchTerms: ['At', 'E-Mail', 'Symbol', 'Adresse'],
  },
  {
    name: 'FaAtom',
    searchTerms: ['Atom', 'Wissenschaft', 'Physik', 'Teilchen'],
  },
  {
    name: 'FaAudioDescription',
    searchTerms: ['Audio Description', 'Beschreibung', 'Hören', 'Audio'],
  },
  {
    name: 'FaAustralSign',
    searchTerms: ['Austral Sign', 'Währung', 'Austral', 'Geld'],
  },
  {
    name: 'FaAward',
    searchTerms: ['Award', 'Preis', 'Auszeichnung', 'Ehrung'],
  },
  {
    name: 'FaB',
    searchTerms: ['B', 'Buchstabe', 'Alphabet', 'B'],
  },
  {
    name: 'FaBabyCarriage',
    searchTerms: ['Baby Carriage', 'Kinderwagen', 'Baby', 'Transport'],
  },
  {
    name: 'FaBaby',
    searchTerms: ['Baby', 'Säugling', 'Kind', 'Neugeborenes'],
  },
  {
    name: 'FaBackwardFast',
    searchTerms: [
      'Backward Fast',
      'Schneller Rücklauf',
      'Zurückspulen',
      'Richtung',
    ],
  },
  {
    name: 'FaBackwardStep',
    searchTerms: ['Backward Step', 'Schritt zurück', 'Rücklauf', 'Richtung'],
  },
  {
    name: 'FaBackward',
    searchTerms: ['Backward', 'Zurück', 'Rücklauf', 'Richtung'],
  },
  {
    name: 'FaBacon',
    searchTerms: ['Bacon', 'Speck', 'Fleisch', 'Essen'],
  },
  {
    name: 'FaBacteria',
    searchTerms: ['Bacteria', 'Bakterien', 'Mikroben', 'Wissenschaft'],
  },
  {
    name: 'FaBacterium',
    searchTerms: ['Bacterium', 'Bakterium', 'Mikrobe', 'Wissenschaft'],
  },
  {
    name: 'FaBagShopping',
    searchTerms: ['Bag Shopping', 'Einkaufstasche', 'Shoppen', 'Einkaufen'],
  },
  {
    name: 'FaBahai',
    searchTerms: ['Bahai', 'Religion', 'Glaube', 'Symbol'],
  },
  {
    name: 'FaBahtSign',
    searchTerms: ['Baht Sign', 'Baht', 'Währung', 'Thailand'],
  },
  {
    name: 'FaBanSmoking',
    searchTerms: ['Ban Smoking', 'Rauchen verboten', 'Tabak', 'Gesundheit'],
  },
  {
    name: 'FaBan',
    searchTerms: ['Ban', 'Verbot', 'Sperre', 'Kein Zutritt'],
  },
  {
    name: 'FaBandage',
    searchTerms: ['Bandage', 'Verband', 'Medizin', 'Verletzung'],
  },
  {
    name: 'FaBangladeshiTakaSign',
    searchTerms: ['Bangladeshi Taka Sign', 'Taka', 'Währung', 'Bangladesch'],
  },
  {
    name: 'FaBarcode',
    searchTerms: ['Barcode', 'Strichcode', 'Scan', 'Produkt'],
  },
  {
    name: 'FaBarsProgress',
    searchTerms: ['Bars Progress', 'Fortschritt', 'Ladebalken', 'Status'],
  },
  {
    name: 'FaBarsStaggered',
    searchTerms: ['Bars Staggered', 'Gestaffelte Balken', 'Menü', 'Status'],
  },
  {
    name: 'FaBars',
    searchTerms: ['Bars', 'Menü', 'Navigation', 'Balken'],
  },
  {
    name: 'FaBaseballBatBall',
    searchTerms: ['Baseball Bat Ball', 'Baseball', 'Schläger', 'Sport'],
  },
  {
    name: 'FaBaseball',
    searchTerms: ['Baseball', 'Sport', 'Ball', 'Schläger'],
  },
  {
    name: 'FaBasketShopping',
    searchTerms: ['Basket Shopping', 'Einkaufskorb', 'Shoppen', 'Einkaufen'],
  },
  {
    name: 'FaBasketball',
    searchTerms: ['Basketball', 'Sport', 'Ball', 'Spiel'],
  },
  {
    name: 'FaBath',
    searchTerms: ['Bath', 'Badewanne', 'Baden', 'Hygiene'],
  },
  {
    name: 'FaBatteryEmpty',
    searchTerms: ['Battery Empty', 'Leere Batterie', 'Akkustand', 'Energie'],
  },
  {
    name: 'FaBatteryFull',
    searchTerms: ['Battery Full', 'Volle Batterie', 'Akkustand', 'Energie'],
  },
  {
    name: 'FaBatteryHalf',
    searchTerms: [
      'Battery Half',
      'Halb volle Batterie',
      'Akkustand',
      'Energie',
    ],
  },
  {
    name: 'FaBatteryQuarter',
    searchTerms: [
      'Battery Quarter',
      'Viertel volle Batterie',
      'Akkustand',
      'Energie',
    ],
  },
  {
    name: 'FaBatteryThreeQuarters',
    searchTerms: [
      'Battery Three Quarters',
      'Drei Viertel volle Batterie',
      'Akkustand',
      'Energie',
    ],
  },
  {
    name: 'FaBedPulse',
    searchTerms: ['Bed Pulse', 'Krankenbett', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaBed',
    searchTerms: ['Bed', 'Bett', 'Schlafen', 'Möbel'],
  },
  {
    name: 'FaBeerMugEmpty',
    searchTerms: ['Beer Mug Empty', 'Leeres Bierglas', 'Bier', 'Trinken'],
  },
  {
    name: 'FaBellConcierge',
    searchTerms: ['Bell Concierge', 'Glocke', 'Service', 'Hotel'],
  },
  {
    name: 'FaBellSlash',
    searchTerms: ['Bell Slash', 'Stumm', 'Benachrichtigungen', 'Glocke'],
  },
  {
    name: 'FaBell',
    searchTerms: ['Bell', 'Glocke', 'Benachrichtigungen', 'Alarm'],
  },
  {
    name: 'FaBezierCurve',
    searchTerms: ['Bezier Curve', 'Kurve', 'Design', 'Grafik'],
  },
  {
    name: 'FaBicycle',
    searchTerms: ['Bicycle', 'Fahrrad', 'Transport', 'Fahren'],
  },
  {
    name: 'FaBinoculars',
    searchTerms: ['Binoculars', 'Fernglas', 'Sehen', 'Beobachten'],
  },
  {
    name: 'FaBiohazard',
    searchTerms: ['Biohazard', 'Gefahr', 'Biologisch', 'Warnung'],
  },
  {
    name: 'FaBitcoinSign',
    searchTerms: ['Bitcoin Sign', 'Bitcoin', 'Kryptowährung', 'Währung'],
  },
  {
    name: 'FaBlenderPhone',
    searchTerms: ['Blender Phone', 'Mixer', 'Telefon', 'Gerät'],
  },
  {
    name: 'FaBlender',
    searchTerms: ['Blender', 'Mixer', 'Küchengerät', 'Essen'],
  },
  {
    name: 'FaBlog',
    searchTerms: ['Blog', 'Artikel', 'Webseite', 'Schreiben'],
  },
  {
    name: 'FaBold',
    searchTerms: ['Bold', 'Fett', 'Schrift', 'Text'],
  },
  {
    name: 'FaBoltLightning',
    searchTerms: ['Bolt Lightning', 'Blitz', 'Energie', 'Strom'],
  },
  {
    name: 'FaBolt',
    searchTerms: ['Bolt', 'Blitz', 'Energie', 'Strom'],
  },
  {
    name: 'FaBomb',
    searchTerms: ['Bomb', 'Explosion', 'Gefahr', 'Sprengstoff'],
  },
  {
    name: 'FaBone',
    searchTerms: ['Bone', 'Knochen', 'Skelett', 'Medizin'],
  },
  {
    name: 'FaBong',
    searchTerms: ['Bong', 'Wasserpfeife', 'Rauchen', 'Freizeit'],
  },
  {
    name: 'FaBookAtlas',
    searchTerms: ['Book Atlas', 'Atlas', 'Buch', 'Karten'],
  },
  {
    name: 'FaBookBible',
    searchTerms: ['Book Bible', 'Bibel', 'Religion', 'Glaube'],
  },
  {
    name: 'FaBookBookmark',
    searchTerms: ['Book Bookmark', 'Buch', 'Lesezeichen', 'Markierung'],
  },
  {
    name: 'FaBookJournalWhills',
    searchTerms: ['Book Journal Whills', 'Buch', 'Star Wars', 'Franchise'],
  },
  {
    name: 'FaBookMedical',
    searchTerms: [
      'Book Medical',
      'Medizinisches Buch',
      'Gesundheit',
      'Medizin',
    ],
  },
  {
    name: 'FaBookOpenReader',
    searchTerms: ['Book Open Reader', 'Leser', 'Buch', 'Lesen'],
  },
  {
    name: 'FaBookOpen',
    searchTerms: ['Book Open', 'Offenes Buch', 'Lesen', 'Bildung'],
  },
  {
    name: 'FaBookQuran',
    searchTerms: ['Book Quran', 'Koran', 'Religion', 'Islam'],
  },
  {
    name: 'FaBookSkull',
    searchTerms: ['Book Skull', 'Schädel', 'Buch', 'Totenkopf'],
  },
  {
    name: 'FaBookTanakh',
    searchTerms: ['Book Tanakh', 'Tanakh', 'Religion', 'Judentum'],
  },
  {
    name: 'FaBook',
    searchTerms: ['Book', 'Buch', 'Lesen', 'Bildung'],
  },
  {
    name: 'FaBookmark',
    searchTerms: ['Bookmark', 'Lesezeichen', 'Markierung', 'Buch'],
  },
  {
    name: 'FaBorderAll',
    searchTerms: ['Border All', 'Rahmen', 'Kanten', 'Ränder'],
  },
  {
    name: 'FaBorderNone',
    searchTerms: ['Border None', 'Kein Rahmen', 'Ohne Kanten', 'Design'],
  },
  {
    name: 'FaBorderTopLeft',
    searchTerms: ['Border Top Left', 'Oben links', 'Rahmen', 'Kante'],
  },
  {
    name: 'FaBoreHole',
    searchTerms: ['Bore Hole', 'Bohrloch', 'Bohren', 'Loch'],
  },
  {
    name: 'FaBottleDroplet',
    searchTerms: ['Bottle Droplet', 'Flasche', 'Tropfen', 'Flüssigkeit'],
  },
  {
    name: 'FaBottleWater',
    searchTerms: ['Bottle Water', 'Wasserflasche', 'Trinken', 'Flüssigkeit'],
  },
  {
    name: 'FaBowlFood',
    searchTerms: ['Bowl Food', 'Essensschale', 'Essen', 'Schüssel'],
  },
  {
    name: 'FaBowlRice',
    searchTerms: ['Bowl Rice', 'Reisschale', 'Essen', 'Reis'],
  },
  {
    name: 'FaBowlingBall',
    searchTerms: ['Bowling Ball', 'Bowling', 'Sport', 'Ball'],
  },
  {
    name: 'FaBoxArchive',
    searchTerms: ['Box Archive', 'Archiv', 'Kiste', 'Aufbewahrung'],
  },
  {
    name: 'FaBoxOpen',
    searchTerms: ['Box Open', 'Offene Box', 'Verpackung', 'Aufbewahrung'],
  },
  {
    name: 'FaBoxTissue',
    searchTerms: ['Box Tissue', 'Taschentuchbox', 'Taschentücher', 'Hygiene'],
  },
  {
    name: 'FaBox',
    searchTerms: ['Box', 'Kiste', 'Verpackung', 'Aufbewahrung'],
  },
  {
    name: 'FaBoxesPacking',
    searchTerms: ['Boxes Packing', 'Verpackung', 'Kisten', 'Transport'],
  },
  {
    name: 'FaBoxesStacked',
    searchTerms: [
      'Boxes Stacked',
      'Gestapelte Kisten',
      'Lagerung',
      'Verpackung',
    ],
  },
  {
    name: 'FaBraille',
    searchTerms: ['Braille', 'Blindenschrift', 'Schrift', 'Lesen'],
  },
  {
    name: 'FaBrain',
    searchTerms: ['Brain', 'Gehirn', 'Denken', 'Medizin'],
  },
  {
    name: 'FaBrazilianRealSign',
    searchTerms: ['Brazilian Real Sign', 'Real', 'Währung', 'Brasilien'],
  },
  {
    name: 'FaBreadSlice',
    searchTerms: ['Bread Slice', 'Brotscheibe', 'Essen', 'Brot'],
  },
  {
    name: 'FaBridgeCircleCheck',
    searchTerms: ['Bridge Circle Check', 'Brücke', 'Überprüfung', 'Struktur'],
  },
  {
    name: 'FaBridgeCircleExclamation',
    searchTerms: ['Bridge Circle Exclamation', 'Brücke', 'Warnung', 'Struktur'],
  },
  {
    name: 'FaBridgeCircleXmark',
    searchTerms: ['Bridge Circle Xmark', 'Brücke', 'Fehler', 'Struktur'],
  },
  {
    name: 'FaBridgeLock',
    searchTerms: ['Bridge Lock', 'Brücke', 'Schloss', 'Sicherheit'],
  },
  {
    name: 'FaBridgeWater',
    searchTerms: ['Bridge Water', 'Wasserbrücke', 'Struktur', 'Verbindung'],
  },
  {
    name: 'FaBridge',
    searchTerms: ['Bridge', 'Brücke', 'Verbindung', 'Struktur'],
  },
  {
    name: 'FaBriefcaseMedical',
    searchTerms: [
      'Briefcase Medical',
      'Medizinischer Koffer',
      'Medizin',
      'Gesundheit',
    ],
  },
  {
    name: 'FaBriefcase',
    searchTerms: ['Briefcase', 'Aktenkoffer', 'Geschäft', 'Koffer'],
  },
  {
    name: 'FaBroomBall',
    searchTerms: ['Broom Ball', 'Broom', 'Sport', 'Ball'],
  },
  {
    name: 'FaBroom',
    searchTerms: ['Broom', 'Besen', 'Reinigung', 'Sauberkeit'],
  },
  {
    name: 'FaBrush',
    searchTerms: ['Brush', 'Pinsel', 'Kunst', 'Malen'],
  },
  {
    name: 'FaBucket',
    searchTerms: ['Bucket', 'Eimer', 'Wasser', 'Reinigung'],
  },
  {
    name: 'FaBugSlash',
    searchTerms: [
      'Bug Slash',
      'Fehler behoben',
      'Programmierung',
      'Entwicklung',
    ],
  },
  {
    name: 'FaBug',
    searchTerms: ['Bug', 'Fehler', 'Programmierung', 'Problem'],
  },
  {
    name: 'FaBugs',
    searchTerms: ['Bugs', 'Mehrere Fehler', 'Programmierung', 'Probleme'],
  },
  {
    name: 'FaBuildingCircleArrowRight',
    searchTerms: ['Building Circle Arrow Right', 'Gebäude', 'Pfeil', 'Rechts'],
  },
  {
    name: 'FaBuildingCircleCheck',
    searchTerms: [
      'Building Circle Check',
      'Gebäude',
      'Überprüfung',
      'Struktur',
    ],
  },
  {
    name: 'FaBuildingCircleExclamation',
    searchTerms: [
      'Building Circle Exclamation',
      'Gebäude',
      'Warnung',
      'Struktur',
    ],
  },
  {
    name: 'FaBuildingCircleXmark',
    searchTerms: ['Building Circle Xmark', 'Gebäude', 'Fehler', 'Struktur'],
  },
  {
    name: 'FaBuildingColumns',
    searchTerms: ['Building Columns', 'Gebäude', 'Säulen', 'Struktur'],
  },
  {
    name: 'FaBuildingFlag',
    searchTerms: ['Building Flag', 'Gebäude', 'Flagge', 'Markierung'],
  },
  {
    name: 'FaBuildingLock',
    searchTerms: ['Building Lock', 'Gebäude', 'Sicherheit', 'Schloss'],
  },
  {
    name: 'FaBuildingNgo',
    searchTerms: ['Building Ngo', 'Gebäude', 'NGO', 'Organisation'],
  },
  {
    name: 'FaBuildingShield',
    searchTerms: ['Building Shield', 'Gebäude', 'Schild', 'Schutz'],
  },
  {
    name: 'FaBuildingUn',
    searchTerms: [
      'Building Un',
      'UN-Gebäude',
      'Organisation',
      'Vereinte Nationen',
    ],
  },
  {
    name: 'FaBuildingUser',
    searchTerms: ['Building User', 'Gebäude', 'Benutzer', 'Verwaltung'],
  },
  {
    name: 'FaBuildingWheat',
    searchTerms: ['Building Wheat', 'Gebäude', 'Weizen', 'Landwirtschaft'],
  },
  {
    name: 'FaBuilding',
    searchTerms: ['Building', 'Gebäude', 'Struktur', 'Architektur'],
  },
  {
    name: 'FaBullhorn',
    searchTerms: ['Bullhorn', 'Megafon', 'Lautsprecher', 'Ankündigung'],
  },
  {
    name: 'FaBullseye',
    searchTerms: ['Bullseye', 'Zielscheibe', 'Ziel', 'Treffer'],
  },
  {
    name: 'FaBurger',
    searchTerms: ['Burger', 'Essen', 'Hamburger', 'Fast Food'],
  },
  {
    name: 'FaBurst',
    searchTerms: ['Burst', 'Explosion', 'Platzen', 'Kraft'],
  },
  {
    name: 'FaBusSimple',
    searchTerms: ['Bus Simple', 'Bus', 'Transport', 'ÖPNV'],
  },
  {
    name: 'FaBus',
    searchTerms: ['Bus', 'Transport', 'Fahrzeug', 'ÖPNV'],
  },
  {
    name: 'FaBusinessTime',
    searchTerms: ['Business Time', 'Geschäftszeit', 'Uhr', 'Zeit'],
  },
  {
    name: 'FaC',
    searchTerms: ['C', 'Buchstabe C', 'Alphabet', 'Anfang'],
  },
  {
    name: 'FaCableCar',
    searchTerms: ['Cable Car', 'Seilbahn', 'Transport', 'Berg'],
  },
  {
    name: 'FaCakeCandles',
    searchTerms: ['Cake Candles', 'Kuchen mit Kerzen', 'Geburtstag', 'Feiern'],
  },
  {
    name: 'FaCalculator',
    searchTerms: ['Calculator', 'Rechner', 'Mathematik', 'Berechnung'],
  },
  {
    name: 'FaCalendarCheck',
    searchTerms: ['Calendar Check', 'Kalender', 'Überprüfung', 'Datum'],
  },
  {
    name: 'FaCalendarDay',
    searchTerms: ['Calendar Day', 'Kalendertag', 'Datum', 'Zeit'],
  },
  {
    name: 'FaCalendarDays',
    searchTerms: ['Calendar Days', 'Kalender', 'Tage', 'Datum'],
  },
  {
    name: 'FaCalendarMinus',
    searchTerms: ['Calendar Minus', 'Kalender', 'Löschen', 'Datum'],
  },
  {
    name: 'FaCalendarPlus',
    searchTerms: ['Calendar Plus', 'Kalender', 'Hinzufügen', 'Datum'],
  },
  {
    name: 'FaCalendarWeek',
    searchTerms: ['Calendar Week', 'Kalenderwoche', 'Zeit', 'Datum'],
  },
  {
    name: 'FaCalendarXmark',
    searchTerms: ['Calendar Xmark', 'Kalender', 'Löschen', 'Datum'],
  },
  {
    name: 'FaCalendar',
    searchTerms: ['Calendar', 'Kalender', 'Datum', 'Zeit'],
  },
  {
    name: 'FaCameraRetro',
    searchTerms: ['Camera Retro', 'Retro Kamera', 'Fotografie', 'Bild'],
  },
  {
    name: 'FaCameraRotate',
    searchTerms: ['Camera Rotate', 'Kamera drehen', 'Fotografie', 'Rotation'],
  },
  {
    name: 'FaCamera',
    searchTerms: ['Camera', 'Kamera', 'Fotografie', 'Bild'],
  },
  {
    name: 'FaCampground',
    searchTerms: ['Campground', 'Campingplatz', 'Zelt', 'Natur'],
  },
  {
    name: 'FaCandyCane',
    searchTerms: ['Candy Cane', 'Zuckerstange', 'Weihnachten', 'Süßigkeit'],
  },
  {
    name: 'FaCannabis',
    searchTerms: ['Cannabis', 'Hanf', 'Pflanze', 'Medizin'],
  },
  {
    name: 'FaCapsules',
    searchTerms: ['Capsules', 'Kapseln', 'Medikamente', 'Pharma'],
  },
  {
    name: 'FaCarBattery',
    searchTerms: ['Car Battery', 'Autobatterie', 'Batterie', 'Auto'],
  },
  {
    name: 'FaCarBurst',
    searchTerms: ['Car Burst', 'Autounfall', 'Explosion', 'Fahrzeug'],
  },
  {
    name: 'FaCarOn',
    searchTerms: ['Car On', 'Auto eingeschaltet', 'Fahrzeug', 'Motor'],
  },
  {
    name: 'FaCarRear',
    searchTerms: ['Car Rear', 'Auto Heck', 'Fahrzeug', 'Auto'],
  },
  {
    name: 'FaCarSide',
    searchTerms: ['Car Side', 'Seitenansicht', 'Fahrzeug', 'Auto'],
  },
  {
    name: 'FaCarTunnel',
    searchTerms: ['Car Tunnel', 'Autotunnel', 'Tunnel', 'Fahrzeug'],
  },
  {
    name: 'FaCar',
    searchTerms: ['Car', 'Auto', 'Fahrzeug', 'Transport'],
  },
  {
    name: 'FaCaravan',
    searchTerms: ['Caravan', 'Wohnwagen', 'Camping', 'Fahrzeug'],
  },
  {
    name: 'FaCaretDown',
    searchTerms: ['Caret Down', 'Pfeil nach unten', 'Richtung', 'Zeiger'],
  },
  {
    name: 'FaCaretLeft',
    searchTerms: ['Caret Left', 'Pfeil nach links', 'Richtung', 'Zeiger'],
  },
  {
    name: 'FaCaretRight',
    searchTerms: ['Caret Right', 'Pfeil nach rechts', 'Richtung', 'Zeiger'],
  },
  {
    name: 'FaCaretUp',
    searchTerms: ['Caret Up', 'Pfeil nach oben', 'Richtung', 'Zeiger'],
  },
  {
    name: 'FaCarrot',
    searchTerms: ['Carrot', 'Karotte', 'Gemüse', 'Essen'],
  },
  {
    name: 'FaCartArrowDown',
    searchTerms: [
      'Cart Arrow Down',
      'Einkaufswagen',
      'Einkaufen',
      'Pfeil nach unten',
    ],
  },
  {
    name: 'FaCartFlatbedSuitcase',
    searchTerms: [
      'Cart Flatbed Suitcase',
      'Gepäckwagen',
      'Koffer',
      'Transport',
    ],
  },
  {
    name: 'FaCartFlatbed',
    searchTerms: ['Cart Flatbed', 'Flachwagen', 'Transport', 'Waren'],
  },
  {
    name: 'FaCartPlus',
    searchTerms: ['Cart Plus', 'Einkaufswagen', 'Hinzufügen', 'Einkaufen'],
  },
  {
    name: 'FaCartShopping',
    searchTerms: ['Cart Shopping', 'Einkaufswagen', 'Einkaufen', 'Warenkorb'],
  },
  {
    name: 'FaCashRegister',
    searchTerms: ['Cash Register', 'Kasse', 'Geld', 'Einkaufen'],
  },
  {
    name: 'FaCat',
    searchTerms: ['Cat', 'Katze', 'Tier', 'Haustier'],
  },
  {
    name: 'FaCediSign',
    searchTerms: ['Cedi Sign', 'Cedi', 'Währung', 'Geld'],
  },
  {
    name: 'FaCentSign',
    searchTerms: ['Cent Sign', 'Cent', 'Währung', 'Geld'],
  },
  {
    name: 'FaCertificate',
    searchTerms: ['Certificate', 'Zertifikat', 'Auszeichnung', 'Dokument'],
  },
  {
    name: 'FaChair',
    searchTerms: ['Chair', 'Stuhl', 'Sitzgelegenheit', 'Möbel'],
  },
  {
    name: 'FaChalkboardUser',
    searchTerms: ['Chalkboard User', 'Tafel', 'Lehrer', 'Präsentation'],
  },
  {
    name: 'FaChalkboard',
    searchTerms: ['Chalkboard', 'Tafel', 'Schule', 'Präsentation'],
  },
  {
    name: 'FaChampagneGlasses',
    searchTerms: ['Champagne Glasses', 'Sektgläser', 'Feiern', 'Getränke'],
  },
  {
    name: 'FaChargingStation',
    searchTerms: ['Charging Station', 'Ladestation', 'Elektroauto', 'Strom'],
  },
  {
    name: 'FaChartArea',
    searchTerms: ['Chart Area', 'Diagramm', 'Bereich', 'Daten'],
  },
  {
    name: 'FaChartBar',
    searchTerms: ['Chart Bar', 'Balkendiagramm', 'Diagramm', 'Daten'],
  },
  {
    name: 'FaChartColumn',
    searchTerms: ['Chart Column', 'Säulendiagramm', 'Diagramm', 'Daten'],
  },
  {
    name: 'FaChartGantt',
    searchTerms: [
      'Chart Gantt',
      'Gantt-Diagramm',
      'Projektmanagement',
      'Zeitplan',
    ],
  },
  {
    name: 'FaChartLine',
    searchTerms: ['Chart Line', 'Liniendiagramm', 'Diagramm', 'Daten'],
  },
  {
    name: 'FaChartPie',
    searchTerms: ['Chart Pie', 'Kreisdiagramm', 'Diagramm', 'Daten'],
  },
  {
    name: 'FaChartSimple',
    searchTerms: ['Chart Simple', 'Einfaches Diagramm', 'Daten', 'Grafik'],
  },
  {
    name: 'FaCheckDouble',
    searchTerms: ['Check Double', 'Doppelt geprüft', 'Bestätigung', 'Richtig'],
  },
  {
    name: 'FaCheckToSlot',
    searchTerms: ['Check To Slot', 'Check', 'Slot', 'Bestätigung'],
  },
  {
    name: 'FaCheck',
    searchTerms: ['Check', 'Haken', 'Bestätigung', 'Richtig'],
  },
  {
    name: 'FaCheese',
    searchTerms: ['Cheese', 'Käse', 'Essen', 'Milchprodukt'],
  },
  {
    name: 'FaChessBishop',
    searchTerms: ['Chess Bishop', 'Schach', 'Läufer', 'Spiel'],
  },
  {
    name: 'FaChessBoard',
    searchTerms: ['Chess Board', 'Schachbrett', 'Schach', 'Spiel'],
  },
  {
    name: 'FaChessKing',
    searchTerms: ['Chess King', 'Schach', 'König', 'Spiel'],
  },
  {
    name: 'FaChessKnight',
    searchTerms: ['Chess Knight', 'Schach', 'Springer', 'Spiel'],
  },
  {
    name: 'FaChessPawn',
    searchTerms: ['Chess Pawn', 'Schach', 'Bauer', 'Spiel'],
  },
  {
    name: 'FaChessQueen',
    searchTerms: ['Chess Queen', 'Schach', 'Dame', 'Spiel'],
  },
  {
    name: 'FaChessRook',
    searchTerms: ['Chess Rook', 'Schach', 'Turm', 'Spiel'],
  },
  {
    name: 'FaChess',
    searchTerms: ['Chess', 'Schach', 'Spiel', 'Strategie'],
  },
  {
    name: 'FaChevronDown',
    searchTerms: ['Chevron Down', 'Pfeil nach unten', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaChevronLeft',
    searchTerms: ['Chevron Left', 'Pfeil nach links', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaChevronRight',
    searchTerms: ['Chevron Right', 'Pfeil nach rechts', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaChevronUp',
    searchTerms: ['Chevron Up', 'Pfeil nach oben', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaChildCombatant',
    searchTerms: ['Child Combatant', 'Kind', 'Kämpfer', 'Krieg'],
  },
  {
    name: 'FaChildDress',
    searchTerms: ['Child Dress', 'Kind', 'Kleid', 'Bekleidung'],
  },
  {
    name: 'FaChildReaching',
    searchTerms: ['Child Reaching', 'Kind', 'Erreichen', 'Hilfe'],
  },
  {
    name: 'FaChild',
    searchTerms: ['Child', 'Kind', 'Jugend', 'Mensch'],
  },
  {
    name: 'FaChildren',
    searchTerms: ['Children', 'Kinder', 'Jugend', 'Menschen'],
  },
  {
    name: 'FaChurch',
    searchTerms: ['Church', 'Kirche', 'Religion', 'Gebäude'],
  },
  {
    name: 'FaCircleArrowDown',
    searchTerms: ['Circle Arrow Down', 'Pfeil nach unten', 'Kreis', 'Richtung'],
  },
  {
    name: 'FaCircleArrowLeft',
    searchTerms: ['Circle Arrow Left', 'Pfeil nach links', 'Kreis', 'Richtung'],
  },
  {
    name: 'FaCircleArrowRight',
    searchTerms: [
      'Circle Arrow Right',
      'Pfeil nach rechts',
      'Kreis',
      'Richtung',
    ],
  },
  {
    name: 'FaCircleArrowUp',
    searchTerms: ['Circle Arrow Up', 'Pfeil nach oben', 'Kreis', 'Richtung'],
  },
  {
    name: 'FaCircleCheck',
    searchTerms: ['Circle Check', 'Haken', 'Bestätigung', 'Kreis'],
  },
  {
    name: 'FaCircleChevronDown',
    searchTerms: [
      'Circle Chevron Down',
      'Pfeil nach unten',
      'Kreis',
      'Richtung',
    ],
  },
  {
    name: 'FaCircleChevronLeft',
    searchTerms: [
      'Circle Chevron Left',
      'Pfeil nach links',
      'Kreis',
      'Richtung',
    ],
  },
  {
    name: 'FaCircleChevronRight',
    searchTerms: [
      'Circle Chevron Right',
      'Pfeil nach rechts',
      'Kreis',
      'Richtung',
    ],
  },
  {
    name: 'FaCircleChevronUp',
    searchTerms: ['Circle Chevron Up', 'Pfeil nach oben', 'Kreis', 'Richtung'],
  },
  {
    name: 'FaCircleDollarToSlot',
    searchTerms: ['Circle Dollar To Slot', 'Dollar', 'Geld', 'Kreis'],
  },
  {
    name: 'FaCircleDot',
    searchTerms: ['Circle Dot', 'Kreis', 'Punkt', 'Markierung'],
  },
  {
    name: 'FaCircleDown',
    searchTerms: ['Circle Down', 'Kreis', 'Pfeil nach unten', 'Richtung'],
  },
  {
    name: 'FaCircleExclamation',
    searchTerms: ['Circle Exclamation', 'Kreis', 'Ausrufezeichen', 'Warnung'],
  },
  {
    name: 'FaCircleH',
    searchTerms: ['Circle H', 'Kreis H', 'Hospital', 'Gesundheit'],
  },
  {
    name: 'FaCircleHalfStroke',
    searchTerms: ['Circle Half Stroke', 'Halber Kreis', 'Schlag', 'Muster'],
  },
  {
    name: 'FaCircleInfo',
    searchTerms: ['Circle Info', 'Kreis', 'Information', 'Hinweis'],
  },
  {
    name: 'FaCircleLeft',
    searchTerms: ['Circle Left', 'Kreis', 'Pfeil nach links', 'Richtung'],
  },
  {
    name: 'FaCircleMinus',
    searchTerms: ['Circle Minus', 'Kreis', 'Minus', 'Entfernen'],
  },
  {
    name: 'FaCircleNodes',
    searchTerms: ['Circle Nodes', 'Kreis', 'Knoten', 'Verbindungen'],
  },
  {
    name: 'FaCircleNotch',
    searchTerms: ['Circle Notch', 'Kreis', 'Kerbe', 'Laden'],
  },
  {
    name: 'FaCirclePause',
    searchTerms: ['Circle Pause', 'Kreis', 'Pause', 'Steuerung'],
  },
  {
    name: 'FaCirclePlay',
    searchTerms: ['Circle Play', 'Kreis', 'Abspielen', 'Steuerung'],
  },
  {
    name: 'FaCirclePlus',
    searchTerms: ['Circle Plus', 'Kreis', 'Hinzufügen', 'Plus'],
  },
  {
    name: 'FaCircleQuestion',
    searchTerms: ['Circle Question', 'Kreis', 'Fragezeichen', 'Hilfe'],
  },
  {
    name: 'FaCircleRadiation',
    searchTerms: ['Circle Radiation', 'Kreis', 'Strahlung', 'Gefahr'],
  },
  {
    name: 'FaCircleRight',
    searchTerms: ['Circle Right', 'Kreis', 'Pfeil nach rechts', 'Richtung'],
  },
  {
    name: 'FaCircleStop',
    searchTerms: ['Circle Stop', 'Kreis', 'Stopp', 'Steuerung'],
  },
  {
    name: 'FaCircleUp',
    searchTerms: ['Circle Up', 'Kreis', 'Pfeil nach oben', 'Richtung'],
  },
  {
    name: 'FaCircleUser',
    searchTerms: ['Circle User', 'Kreis', 'Benutzer', 'Profil'],
  },
  {
    name: 'FaCircleXmark',
    searchTerms: ['Circle Xmark', 'Kreis', 'Kreuz', 'Fehler'],
  },
  {
    name: 'FaCircle',
    searchTerms: ['Circle', 'Kreis', 'Form', 'Geometrie'],
  },
  {
    name: 'FaCity',
    searchTerms: ['City', 'Stadt', 'Gebäude', 'Urban'],
  },
  {
    name: 'FaClapperboard',
    searchTerms: ['Clapperboard', 'Filmklappe', 'Film', 'Kino'],
  },
  {
    name: 'FaClipboardCheck',
    searchTerms: ['Clipboard Check', 'Checkliste', 'Überprüfung', 'Klemmbrett'],
  },
  {
    name: 'FaClipboardList',
    searchTerms: ['Clipboard List', 'Checkliste', 'Liste', 'Klemmbrett'],
  },
  {
    name: 'FaClipboardQuestion',
    searchTerms: [
      'Clipboard Question',
      'Fragenliste',
      'Checkliste',
      'Klemmbrett',
    ],
  },
  {
    name: 'FaClipboardUser',
    searchTerms: [
      'Clipboard User',
      'Benutzerliste',
      'Checkliste',
      'Klemmbrett',
    ],
  },
  {
    name: 'FaClipboard',
    searchTerms: ['Clipboard', 'Klemmbrett', 'Checkliste', 'Papier'],
  },
  {
    name: 'FaClockRotateLeft',
    searchTerms: ['Clock Rotate Left', 'Zurückspulen', 'Uhr', 'Zeit'],
  },
  {
    name: 'FaClock',
    searchTerms: ['Clock', 'Uhr', 'Zeit', 'Zeitmessung'],
  },
  {
    name: 'FaClone',
    searchTerms: ['Clone', 'Duplikat', 'Klonen', 'Kopie'],
  },
  {
    name: 'FaClosedCaptioning',
    searchTerms: ['Closed Captioning', 'Untertitel', 'Video', 'Beschriftung'],
  },
  {
    name: 'FaCloudArrowDown',
    searchTerms: ['Cloud Arrow Down', 'Wolke', 'Download', 'Pfeil nach unten'],
  },
  {
    name: 'FaCloudArrowUp',
    searchTerms: ['Cloud Arrow Up', 'Wolke', 'Upload', 'Pfeil nach oben'],
  },
  {
    name: 'FaCloudBolt',
    searchTerms: ['Cloud Bolt', 'Wolke', 'Blitz', 'Gewitter'],
  },
  {
    name: 'FaCloudMeatball',
    searchTerms: ['Cloud Meatball', 'Wolke', 'Fleischbällchen', 'Wetter'],
  },
  {
    name: 'FaCloudMoonRain',
    searchTerms: ['Cloud Moon Rain', 'Wolke', 'Mond', 'Regen'],
  },
  {
    name: 'FaCloudMoon',
    searchTerms: ['Cloud Moon', 'Wolke', 'Mond', 'Nacht'],
  },
  {
    name: 'FaCloudRain',
    searchTerms: ['Cloud Rain', 'Wolke', 'Regen', 'Wetter'],
  },
  {
    name: 'FaCloudShowersHeavy',
    searchTerms: ['Cloud Showers Heavy', 'Wolke', 'Starker Regen', 'Wetter'],
  },
  {
    name: 'FaCloudShowersWater',
    searchTerms: ['Cloud Showers Water', 'Wolke', 'Regenschauer', 'Wasser'],
  },
  {
    name: 'FaCloudSunRain',
    searchTerms: ['Cloud Sun Rain', 'Wolke', 'Sonne', 'Regen'],
  },
  {
    name: 'FaCloudSun',
    searchTerms: ['Cloud Sun', 'Wolke', 'Sonne', 'Wetter'],
  },
  {
    name: 'FaCloud',
    searchTerms: ['Cloud', 'Wolke', 'Wetter', 'Speicher'],
  },
  {
    name: 'FaClover',
    searchTerms: ['Clover', 'Kleeblatt', 'Pflanze', 'Glück'],
  },
  {
    name: 'FaCodeBranch',
    searchTerms: ['Code Branch', 'Code', 'Zweig', 'Programmierung'],
  },
  {
    name: 'FaCodeCommit',
    searchTerms: ['Code Commit', 'Code', 'Programmierung', 'Commit'],
  },
  {
    name: 'FaCodeCompare',
    searchTerms: ['Code Compare', 'Code', 'Vergleich', 'Programmierung'],
  },
  {
    name: 'FaCodeFork',
    searchTerms: ['Code Fork', 'Code', 'Gabel', 'Programmierung'],
  },
  {
    name: 'FaCodeMerge',
    searchTerms: ['Code Merge', 'Code', 'Zusammenführen', 'Programmierung'],
  },
  {
    name: 'FaCodePullRequest',
    searchTerms: ['Code Pull Request', 'Code', 'Anfrage', 'Programmierung'],
  },
  {
    name: 'FaCode',
    searchTerms: ['Code', 'Programmierung', 'Entwicklung', 'Technologie'],
  },
  {
    name: 'FaCoins',
    searchTerms: ['Coins', 'Münzen', 'Geld', 'Währung'],
  },
  {
    name: 'FaColonSign',
    searchTerms: ['Colon Sign', 'Colon', 'Währung', 'Geld'],
  },
  {
    name: 'FaCommentDollar',
    searchTerms: ['Comment Dollar', 'Kommentar', 'Dollar', 'Geld'],
  },
  {
    name: 'FaCommentDots',
    searchTerms: ['Comment Dots', 'Kommentar', 'Nachricht', 'Chat'],
  },
  {
    name: 'FaCommentMedical',
    searchTerms: ['Comment Medical', 'Kommentar', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaCommentSlash',
    searchTerms: ['Comment Slash', 'Kommentar', 'Deaktiviert', 'Chat'],
  },
  {
    name: 'FaCommentSms',
    searchTerms: ['Comment Sms', 'Kommentar', 'SMS', 'Nachricht'],
  },
  {
    name: 'FaComment',
    searchTerms: ['Comment', 'Kommentar', 'Nachricht', 'Chat'],
  },
  {
    name: 'FaCommentsDollar',
    searchTerms: ['Comments Dollar', 'Kommentare', 'Dollar', 'Geld'],
  },
  {
    name: 'FaComments',
    searchTerms: ['Comments', 'Kommentare', 'Chat', 'Nachrichten'],
  },
  {
    name: 'FaCompactDisc',
    searchTerms: ['Compact Disc', 'CD', 'Musik', 'Speicher'],
  },
  {
    name: 'FaCompassDrafting',
    searchTerms: ['Compass Drafting', 'Kompass', 'Zeichnen', 'Navigation'],
  },
  {
    name: 'FaCompass',
    searchTerms: ['Compass', 'Kompass', 'Navigation', 'Orientierung'],
  },
  {
    name: 'FaCompress',
    searchTerms: ['Compress', 'Komprimieren', 'Verkleinern', 'Zusammenziehen'],
  },
  {
    name: 'FaComputerMouse',
    searchTerms: ['Computer Mouse', 'Maus', 'Computer', 'Gerät'],
  },
  {
    name: 'FaComputer',
    searchTerms: ['Computer', 'PC', 'Technologie', 'Gerät'],
  },
  {
    name: 'FaCookieBite',
    searchTerms: ['Cookie Bite', 'Keks', 'Essen', 'Naschen'],
  },
  {
    name: 'FaCookie',
    searchTerms: ['Cookie', 'Keks', 'Essen', 'Naschen'],
  },
  {
    name: 'FaCopy',
    searchTerms: ['Copy', 'Kopieren', 'Duplikat', 'Vervielfältigen'],
  },
  {
    name: 'FaCopyright',
    searchTerms: ['Copyright', 'Urheberrecht', 'Recht', 'Schutz'],
  },
  {
    name: 'FaCouch',
    searchTerms: ['Couch', 'Sofa', 'Möbel', 'Sitzgelegenheit'],
  },
  {
    name: 'FaCow',
    searchTerms: ['Cow', 'Kuh', 'Tier', 'Milch'],
  },
  {
    name: 'FaCreditCard',
    searchTerms: ['Credit Card', 'Kreditkarte', 'Bezahlung', 'Geld'],
  },
  {
    name: 'FaCropSimple',
    searchTerms: ['Crop Simple', 'Zuschneiden', 'Bildbearbeitung', 'Anpassen'],
  },
  {
    name: 'FaCrop',
    searchTerms: ['Crop', 'Zuschneiden', 'Bildbearbeitung', 'Anpassen'],
  },
  {
    name: 'FaCross',
    searchTerms: ['Cross', 'Kreuz', 'Religion', 'Symbol'],
  },
  {
    name: 'FaCrosshairs',
    searchTerms: ['Crosshairs', 'Fadenkreuz', 'Zielen', 'Fokus'],
  },
  {
    name: 'FaCrow',
    searchTerms: ['Crow', 'Krähe', 'Vogel', 'Tier'],
  },
  {
    name: 'FaCrown',
    searchTerms: ['Crown', 'Krone', 'Adel', 'Herrschaft'],
  },
  {
    name: 'FaCrutch',
    searchTerms: ['Crutch', 'Krücke', 'Medizin', 'Stütze'],
  },
  {
    name: 'FaCruzeiroSign',
    searchTerms: ['Cruzeiro Sign', 'Cruzeiro', 'Währung', 'Brasilien'],
  },
  {
    name: 'FaCube',
    searchTerms: ['Cube', 'Würfel', '3D', 'Form'],
  },
  {
    name: 'FaCubesStacked',
    searchTerms: ['Cubes Stacked', 'Gestapelte Würfel', '3D', 'Formen'],
  },
  {
    name: 'FaCubes',
    searchTerms: ['Cubes', 'Würfel', '3D', 'Formen'],
  },
  {
    name: 'FaD',
    searchTerms: ['D', 'Buchstabe D', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaDatabase',
    searchTerms: ['Database', 'Datenbank', 'Speicherung', 'Daten'],
  },
  {
    name: 'FaDeleteLeft',
    searchTerms: ['Delete Left', 'Löschen', 'Zurück', 'Tastatur'],
  },
  {
    name: 'FaDemocrat',
    searchTerms: ['Democrat', 'Demokratie', 'Politik', 'Partei'],
  },
  {
    name: 'FaDesktop',
    searchTerms: ['Desktop', 'Computer', 'PC', 'Bildschirm'],
  },
  {
    name: 'FaDharmachakra',
    searchTerms: ['Dharmachakra', 'Dharma', 'Buddhismus', 'Religion'],
  },
  {
    name: 'FaDiagramNext',
    searchTerms: ['Diagram Next', 'Diagramm', 'Nächstes', 'Grafik'],
  },
  {
    name: 'FaDiagramPredecessor',
    searchTerms: ['Diagram Predecessor', 'Diagramm', 'Vorheriges', 'Grafik'],
  },
  {
    name: 'FaDiagramProject',
    searchTerms: ['Diagram Project', 'Diagramm', 'Projekt', 'Grafik'],
  },
  {
    name: 'FaDiagramSuccessor',
    searchTerms: ['Diagram Successor', 'Diagramm', 'Nachfolger', 'Grafik'],
  },
  {
    name: 'FaDiamondTurnRight',
    searchTerms: ['Diamond Turn Right', 'Diamant', 'Drehen', 'Rechts'],
  },
  {
    name: 'FaDiamond',
    searchTerms: ['Diamond', 'Diamant', 'Edelstein', 'Schmuck'],
  },
  {
    name: 'FaDiceD20',
    searchTerms: ['Dice D20', 'Würfel', 'Spiel', 'D20'],
  },
  {
    name: 'FaDiceD6',
    searchTerms: ['Dice D6', 'Würfel', 'Spiel', 'D6'],
  },
  {
    name: 'FaDiceFive',
    searchTerms: ['Dice Five', 'Würfel', 'Fünf', 'Spiel'],
  },
  {
    name: 'FaDiceFour',
    searchTerms: ['Dice Four', 'Würfel', 'Vier', 'Spiel'],
  },
  {
    name: 'FaDiceOne',
    searchTerms: ['Dice One', 'Würfel', 'Eins', 'Spiel'],
  },
  {
    name: 'FaDiceSix',
    searchTerms: ['Dice Six', 'Würfel', 'Sechs', 'Spiel'],
  },
  {
    name: 'FaDiceThree',
    searchTerms: ['Dice Three', 'Würfel', 'Drei', 'Spiel'],
  },
  {
    name: 'FaDiceTwo',
    searchTerms: ['Dice Two', 'Würfel', 'Zwei', 'Spiel'],
  },
  {
    name: 'FaDice',
    searchTerms: ['Dice', 'Würfel', 'Spiel', 'Zufall'],
  },
  {
    name: 'FaDisease',
    searchTerms: ['Disease', 'Krankheit', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaDisplay',
    searchTerms: ['Display', 'Bildschirm', 'Anzeige', 'Monitor'],
  },
  {
    name: 'FaDivide',
    searchTerms: ['Divide', 'Teilen', 'Mathematik', 'Rechnen'],
  },
  {
    name: 'FaDna',
    searchTerms: ['DNA', 'Genetik', 'Wissenschaft', 'Biologie'],
  },
  {
    name: 'FaDog',
    searchTerms: ['Dog', 'Hund', 'Tier', 'Haustier'],
  },
  {
    name: 'FaDollarSign',
    searchTerms: ['Dollar Sign', 'Dollar', 'Währung', 'Geld'],
  },
  {
    name: 'FaDolly',
    searchTerms: ['Dolly', 'Transportwagen', 'Transport', 'Waren'],
  },
  {
    name: 'FaDongSign',
    searchTerms: ['Dong Sign', 'Dong', 'Währung', 'Geld'],
  },
  {
    name: 'FaDoorClosed',
    searchTerms: ['Door Closed', 'Tür geschlossen', 'Eingang', 'Ausgang'],
  },
  {
    name: 'FaDoorOpen',
    searchTerms: ['Door Open', 'Tür geöffnet', 'Eingang', 'Ausgang'],
  },
  {
    name: 'FaDove',
    searchTerms: ['Dove', 'Taube', 'Frieden', 'Vogel'],
  },
  {
    name: 'FaDownLeftAndUpRightToCenter',
    searchTerms: [
      'Down Left And Up Right To Center',
      'Zentrieren',
      'Bewegung',
      'Richtung',
    ],
  },
  {
    name: 'FaDownLong',
    searchTerms: ['Down Long', 'Pfeil nach unten', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaDownload',
    searchTerms: ['Download', 'Herunterladen', 'Daten', 'Pfeil nach unten'],
  },
  {
    name: 'FaDragon',
    searchTerms: ['Dragon', 'Drache', 'Fantasie', 'Mythologie'],
  },
  {
    name: 'FaDrawPolygon',
    searchTerms: ['Draw Polygon', 'Polygon zeichnen', 'Geometrie', 'Form'],
  },
  {
    name: 'FaDropletSlash',
    searchTerms: ['Droplet Slash', 'Tropfen', 'Kein Wasser', 'Feuchtigkeit'],
  },
  {
    name: 'FaDroplet',
    searchTerms: ['Droplet', 'Tropfen', 'Wasser', 'Flüssigkeit'],
  },
  {
    name: 'FaDrumSteelpan',
    searchTerms: ['Drum Steelpan', 'Stahltrommel', 'Musik', 'Instrument'],
  },
  {
    name: 'FaDrum',
    searchTerms: ['Drum', 'Trommel', 'Musik', 'Instrument'],
  },
  {
    name: 'FaDrumstickBite',
    searchTerms: ['Drumstick Bite', 'Trommelstock', 'Musik', 'Instrument'],
  },
  {
    name: 'FaDumbbell',
    searchTerms: ['Dumbbell', 'Hantel', 'Fitness', 'Sport'],
  },
  {
    name: 'FaDumpsterFire',
    searchTerms: ['Dumpster Fire', 'Müllcontainer', 'Feuer', 'Katastrophe'],
  },
  {
    name: 'FaDumpster',
    searchTerms: ['Dumpster', 'Müllcontainer', 'Abfall', 'Entsorgung'],
  },
  {
    name: 'FaDungeon',
    searchTerms: ['Dungeon', 'Verlies', 'Gefängnis', 'Abenteuer'],
  },
  {
    name: 'FaE',
    searchTerms: ['E', 'Buchstabe E', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaEarDeaf',
    searchTerms: ['Ear Deaf', 'Taubheit', 'Hören', 'Behinderung'],
  },
  {
    name: 'FaEarListen',
    searchTerms: ['Ear Listen', 'Hören', 'Ohr', 'Akustik'],
  },
  {
    name: 'FaEarthAfrica',
    searchTerms: ['Earth Africa', 'Erde', 'Afrika', 'Globus'],
  },
  {
    name: 'FaEarthAmericas',
    searchTerms: ['Earth Americas', 'Erde', 'Amerika', 'Globus'],
  },
  {
    name: 'FaEarthAsia',
    searchTerms: ['Earth Asia', 'Erde', 'Asien', 'Globus'],
  },
  {
    name: 'FaEarthEurope',
    searchTerms: ['Earth Europe', 'Erde', 'Europa', 'Globus'],
  },
  {
    name: 'FaEarthOceania',
    searchTerms: ['Earth Oceania', 'Erde', 'Ozeanien', 'Globus'],
  },
  {
    name: 'FaEgg',
    searchTerms: ['Egg', 'Ei', 'Nahrung', 'Essen'],
  },
  {
    name: 'FaEject',
    searchTerms: ['Eject', 'Auswerfen', 'Steuerung', 'Multimedia'],
  },
  {
    name: 'FaElevator',
    searchTerms: ['Elevator', 'Aufzug', 'Lift', 'Gebäude'],
  },
  {
    name: 'FaEllipsisVertical',
    searchTerms: [
      'Ellipsis Vertical',
      'Drei Punkte vertikal',
      'Menü',
      'Optionen',
    ],
  },
  {
    name: 'FaEllipsis',
    searchTerms: ['Ellipsis', 'Drei Punkte', 'Menü', 'Optionen'],
  },
  {
    name: 'FaEnvelopeCircleCheck',
    searchTerms: ['Envelope Circle Check', 'Umschlag', 'Bestätigung', 'E-Mail'],
  },
  {
    name: 'FaEnvelopeOpenText',
    searchTerms: [
      'Envelope Open Text',
      'Geöffneter Umschlag',
      'E-Mail',
      'Nachricht',
    ],
  },
  {
    name: 'FaEnvelopeOpen',
    searchTerms: [
      'Envelope Open',
      'Geöffneter Umschlag',
      'E-Mail',
      'Nachricht',
    ],
  },
  {
    name: 'FaEnvelope',
    searchTerms: ['Envelope', 'Umschlag', 'E-Mail', 'Nachricht'],
  },
  {
    name: 'FaEnvelopesBulk',
    searchTerms: ['Envelopes Bulk', 'Massenumschläge', 'E-Mail', 'Nachrichten'],
  },
  {
    name: 'FaEquals',
    searchTerms: ['Equals', 'Gleichzeichen', 'Mathematik', 'Rechnen'],
  },
  {
    name: 'FaEraser',
    searchTerms: ['Eraser', 'Radiergummi', 'Löschen', 'Schreiben'],
  },
  {
    name: 'FaEthernet',
    searchTerms: ['Ethernet', 'Netzwerk', 'Internet', 'Verbindung'],
  },
  {
    name: 'FaEuroSign',
    searchTerms: ['Euro Sign', 'Euro', 'Währung', 'Geld'],
  },
  {
    name: 'FaExclamation',
    searchTerms: ['Exclamation', 'Ausrufezeichen', 'Warnung', 'Achtung'],
  },
  {
    name: 'FaExpand',
    searchTerms: ['Expand', 'Erweitern', 'Vergrößern', 'Skalieren'],
  },
  {
    name: 'FaExplosion',
    searchTerms: ['Explosion', 'Detonation', 'Gefahr', 'Explosion'],
  },
  {
    name: 'FaEyeDropper',
    searchTerms: ['Eye Dropper', 'Pipette', 'Farbe', 'Design'],
  },
  {
    name: 'FaEyeLowVision',
    searchTerms: ['Eye Low Vision', 'Sehschwäche', 'Auge', 'Sehen'],
  },
  {
    name: 'FaEyeSlash',
    searchTerms: ['Eye Slash', 'Auge', 'Versteckt', 'Sehen'],
  },
  {
    name: 'FaEye',
    searchTerms: ['Eye', 'Auge', 'Sehen', 'Blick'],
  },
  {
    name: 'FaF',
    searchTerms: ['F', 'Buchstabe F', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaFaceAngry',
    searchTerms: ['Face Angry', 'Wütend', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceDizzy',
    searchTerms: ['Face Dizzy', 'Schwindel', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceFlushed',
    searchTerms: ['Face Flushed', 'Erröten', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceFrownOpen',
    searchTerms: ['Face Frown Open', 'Stirnrunzeln', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceFrown',
    searchTerms: ['Face Frown', 'Stirnrunzeln', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceGrimace',
    searchTerms: ['Face Grimace', 'Grimasse', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceGrinBeamSweat',
    searchTerms: ['Face Grin Beam Sweat', 'Schweiß', 'Gesicht', 'Lächeln'],
  },
  {
    name: 'FaFaceGrinBeam',
    searchTerms: ['Face Grin Beam', 'Lächeln', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceGrinHearts',
    searchTerms: ['Face Grin Hearts', 'Lächeln', 'Herzen', 'Liebe'],
  },
  {
    name: 'FaFaceGrinSquintTears',
    searchTerms: ['Face Grin Squint Tears', 'Lächeln', 'Tränen', 'Lachen'],
  },
  {
    name: 'FaFaceGrinSquint',
    searchTerms: ['Face Grin Squint', 'Lächeln', 'Zwinkern', 'Gesicht'],
  },
  {
    name: 'FaFaceGrinStars',
    searchTerms: ['Face Grin Stars', 'Lächeln', 'Sterne', 'Emoji'],
  },
  {
    name: 'FaFaceGrinTears',
    searchTerms: ['Face Grin Tears', 'Lächeln', 'Tränen', 'Lachen'],
  },
  {
    name: 'FaFaceGrinTongueSquint',
    searchTerms: ['Face Grin Tongue Squint', 'Lächeln', 'Zunge', 'Zwinkern'],
  },
  {
    name: 'FaFaceGrinTongueWink',
    searchTerms: ['Face Grin Tongue Wink', 'Lächeln', 'Zunge', 'Zwinkern'],
  },
  {
    name: 'FaFaceGrinTongue',
    searchTerms: ['Face Grin Tongue', 'Lächeln', 'Zunge', 'Emoji'],
  },
  {
    name: 'FaFaceGrinWide',
    searchTerms: ['Face Grin Wide', 'Lächeln', 'Breites Grinsen', 'Emoji'],
  },
  {
    name: 'FaFaceGrinWink',
    searchTerms: ['Face Grin Wink', 'Lächeln', 'Zwinkern', 'Emoji'],
  },
  {
    name: 'FaFaceGrin',
    searchTerms: ['Face Grin', 'Lächeln', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceKissBeam',
    searchTerms: ['Face Kiss Beam', 'Kuss', 'Gesicht', 'Liebe'],
  },
  {
    name: 'FaFaceKissWinkHeart',
    searchTerms: ['Face Kiss Wink Heart', 'Kuss', 'Zwinkern', 'Herz'],
  },
  {
    name: 'FaFaceKiss',
    searchTerms: ['Face Kiss', 'Kuss', 'Gesicht', 'Liebe'],
  },
  {
    name: 'FaFaceLaughBeam',
    searchTerms: ['Face Laugh Beam', 'Lachen', 'Gesicht', 'Lächeln'],
  },
  {
    name: 'FaFaceLaughSquint',
    searchTerms: ['Face Laugh Squint', 'Lachen', 'Zwinkern', 'Gesicht'],
  },
  {
    name: 'FaFaceLaughWink',
    searchTerms: ['Face Laugh Wink', 'Lachen', 'Zwinkern', 'Gesicht'],
  },
  {
    name: 'FaFaceLaugh',
    searchTerms: ['Face Laugh', 'Lachen', 'Gesicht', 'Lächeln'],
  },
  {
    name: 'FaFaceMehBlank',
    searchTerms: ['Face Meh Blank', 'Gleichgültig', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceMeh',
    searchTerms: ['Face Meh', 'Gleichgültig', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceRollingEyes',
    searchTerms: ['Face Rolling Eyes', 'Augenrollen', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceSadCry',
    searchTerms: ['Face Sad Cry', 'Weinen', 'Gesicht', 'Traurig'],
  },
  {
    name: 'FaFaceSadTear',
    searchTerms: ['Face Sad Tear', 'Träne', 'Weinen', 'Gesicht'],
  },
  {
    name: 'FaFaceSmileBeam',
    searchTerms: ['Face Smile Beam', 'Lächeln', 'Strahlen', 'Emoji'],
  },
  {
    name: 'FaFaceSmileWink',
    searchTerms: ['Face Smile Wink', 'Lächeln', 'Zwinkern', 'Emoji'],
  },
  {
    name: 'FaFaceSmile',
    searchTerms: ['Face Smile', 'Lächeln', 'Gesicht', 'Freude'],
  },
  {
    name: 'FaFaceSurprise',
    searchTerms: ['Face Surprise', 'Überraschung', 'Gesicht', 'Emoji'],
  },
  {
    name: 'FaFaceTired',
    searchTerms: ['Face Tired', 'Müde', 'Gesicht', 'Erschöpfung'],
  },
  {
    name: 'FaFan',
    searchTerms: ['Fan', 'Ventilator', 'Luft', 'Kühlung'],
  },
  {
    name: 'FaFaucetDrip',
    searchTerms: ['Faucet Drip', 'Tropfender Wasserhahn', 'Wasser', 'Leck'],
  },
  {
    name: 'FaFaucet',
    searchTerms: ['Faucet', 'Wasserhahn', 'Wasser', 'Installation'],
  },
  {
    name: 'FaFax',
    searchTerms: ['Fax', 'Faxgerät', 'Kommunikation', 'Dokument'],
  },
  {
    name: 'FaFeatherPointed',
    searchTerms: ['Feather Pointed', 'Spitze Feder', 'Schreiben', 'Vogel'],
  },
  {
    name: 'FaFeather',
    searchTerms: ['Feather', 'Feder', 'Schreiben', 'Vogel'],
  },
  {
    name: 'FaFerry',
    searchTerms: ['Ferry', 'Fähre', 'Transport', 'Schiff'],
  },
  {
    name: 'FaFileArrowDown',
    searchTerms: ['File Arrow Down', 'Datei', 'Download', 'Pfeil nach unten'],
  },
  {
    name: 'FaFileArrowUp',
    searchTerms: ['File Arrow Up', 'Datei', 'Upload', 'Pfeil nach oben'],
  },
  {
    name: 'FaFileAudio',
    searchTerms: ['File Audio', 'Audiodatei', 'Musik', 'Ton'],
  },
  {
    name: 'FaFileCircleCheck',
    searchTerms: ['File Circle Check', 'Datei', 'Bestätigung', 'Kreis'],
  },
  {
    name: 'FaFileCircleExclamation',
    searchTerms: [
      'File Circle Exclamation',
      'Datei',
      'Ausrufezeichen',
      'Warnung',
    ],
  },
  {
    name: 'FaFileCircleMinus',
    searchTerms: ['File Circle Minus', 'Datei', 'Entfernen', 'Minus'],
  },
  {
    name: 'FaFileCirclePlus',
    searchTerms: ['File Circle Plus', 'Datei', 'Hinzufügen', 'Plus'],
  },
  {
    name: 'FaFileCircleQuestion',
    searchTerms: ['File Circle Question', 'Datei', 'Frage', 'Hilfe'],
  },
  {
    name: 'FaFileCircleXmark',
    searchTerms: ['File Circle Xmark', 'Datei', 'Fehler', 'Kreis'],
  },
  {
    name: 'FaFileCode',
    searchTerms: ['File Code', 'Code', 'Datei', 'Programmierung'],
  },
  {
    name: 'FaFileContract',
    searchTerms: ['File Contract', 'Vertrag', 'Datei', 'Dokument'],
  },
  {
    name: 'FaFileCsv',
    searchTerms: ['File Csv', 'CSV', 'Datei', 'Daten'],
  },
  {
    name: 'FaFileExcel',
    searchTerms: ['File Excel', 'Excel', 'Datei', 'Tabellen'],
  },
  {
    name: 'FaFileExport',
    searchTerms: ['File Export', 'Export', 'Datei', 'Daten'],
  },
  {
    name: 'FaFileImage',
    searchTerms: ['File Image', 'Bilddatei', 'Foto', 'Bild'],
  },
  {
    name: 'FaFileImport',
    searchTerms: ['File Import', 'Import', 'Datei', 'Daten'],
  },
  {
    name: 'FaFileInvoiceDollar',
    searchTerms: ['File Invoice Dollar', 'Rechnung', 'Dollar', 'Datei'],
  },
  {
    name: 'FaFileInvoice',
    searchTerms: ['File Invoice', 'Rechnung', 'Datei', 'Dokument'],
  },
  {
    name: 'FaFileLines',
    searchTerms: ['File Lines', 'Textdatei', 'Datei', 'Dokument'],
  },
  {
    name: 'FaFileMedical',
    searchTerms: [
      'File Medical',
      'Medizinische Datei',
      'Dokument',
      'Gesundheit',
    ],
  },
  {
    name: 'FaFilePdf',
    searchTerms: ['File Pdf', 'PDF', 'Datei', 'Dokument'],
  },
  {
    name: 'FaFilePen',
    searchTerms: ['File Pen', 'Datei', 'Bearbeiten', 'Schreiben'],
  },
  {
    name: 'FaFilePowerpoint',
    searchTerms: ['File Powerpoint', 'PowerPoint', 'Datei', 'Präsentation'],
  },
  {
    name: 'FaFilePrescription',
    searchTerms: ['File Prescription', 'Rezept', 'Medizin', 'Datei'],
  },
  {
    name: 'FaFileShield',
    searchTerms: ['File Shield', 'Datei', 'Schild', 'Sicherheit'],
  },
  {
    name: 'FaFileSignature',
    searchTerms: ['File Signature', 'Signatur', 'Datei', 'Dokument'],
  },
  {
    name: 'FaFileVideo',
    searchTerms: ['File Video', 'Videodatei', 'Film', 'Multimedia'],
  },
  {
    name: 'FaFileWaveform',
    searchTerms: ['File Waveform', 'Datei', 'Wellenform', 'Audio'],
  },
  {
    name: 'FaFileWord',
    searchTerms: ['File Word', 'Datei', 'Word', 'Dokument'],
  },
  {
    name: 'FaFileZipper',
    searchTerms: ['File Zipper', 'Datei', 'ZIP', 'Archiv'],
  },
  {
    name: 'FaFile',
    searchTerms: ['File', 'Datei', 'Dokument', 'Speichern'],
  },
  {
    name: 'FaFillDrip',
    searchTerms: ['Fill Drip', 'Füllen', 'Tropfen', 'Design'],
  },
  {
    name: 'FaFill',
    searchTerms: ['Fill', 'Füllen', 'Eimer', 'Design'],
  },
  {
    name: 'FaFilm',
    searchTerms: ['Film', 'Kino', 'Filmrolle', 'Video'],
  },
  {
    name: 'FaFilterCircleDollar',
    searchTerms: ['Filter Circle Dollar', 'Filter', 'Dollar', 'Geld'],
  },
  {
    name: 'FaFilterCircleXmark',
    searchTerms: ['Filter Circle Xmark', 'Filter', 'X', 'Entfernen'],
  },
  {
    name: 'FaFilter',
    searchTerms: ['Filter', 'Filtern', 'Aussortieren', 'Suche'],
  },
  {
    name: 'FaFingerprint',
    searchTerms: [
      'Fingerprint',
      'Fingerabdruck',
      'Identifikation',
      'Sicherheit',
    ],
  },
  {
    name: 'FaFireBurner',
    searchTerms: ['Fire Burner', 'Feuer', 'Brenner', 'Hitze'],
  },
  {
    name: 'FaFireExtinguisher',
    searchTerms: [
      'Fire Extinguisher',
      'Feuerlöscher',
      'Sicherheit',
      'Brandbekämpfung',
    ],
  },
  {
    name: 'FaFireFlameCurved',
    searchTerms: ['Fire Flame Curved', 'Feuer', 'Flamme', 'Hitze'],
  },
  {
    name: 'FaFireFlameSimple',
    searchTerms: ['Fire Flame Simple', 'Feuer', 'Flamme', 'Hitze'],
  },
  {
    name: 'FaFire',
    searchTerms: ['Fire', 'Feuer', 'Flamme', 'Hitze'],
  },
  {
    name: 'FaFishFins',
    searchTerms: ['Fish Fins', 'Fisch', 'Flossen', 'Meer'],
  },
  {
    name: 'FaFish',
    searchTerms: ['Fish', 'Fisch', 'Meer', 'Tier'],
  },
  {
    name: 'FaFlagCheckered',
    searchTerms: ['Flag Checkered', 'Zielflagge', 'Rennen', 'Sport'],
  },
  {
    name: 'FaFlagUsa',
    searchTerms: ['Flag USA', 'Flagge', 'USA', 'Amerika'],
  },
  {
    name: 'FaFlag',
    searchTerms: ['Flag', 'Flagge', 'Symbol', 'Land'],
  },
  {
    name: 'FaFlaskVial',
    searchTerms: ['Flask Vial', 'Kolben', 'Labor', 'Wissenschaft'],
  },
  {
    name: 'FaFlask',
    searchTerms: ['Flask', 'Kolben', 'Labor', 'Wissenschaft'],
  },
  {
    name: 'FaFloppyDisk',
    searchTerms: ['Floppy Disk', 'Diskette', 'Speichern', 'Speichergerät'],
  },
  {
    name: 'FaFlorinSign',
    searchTerms: ['Florin Sign', 'Florin', 'Währung', 'Geld'],
  },
  {
    name: 'FaFolderClosed',
    searchTerms: ['Folder Closed', 'Ordner', 'Geschlossen', 'Dateien'],
  },
  {
    name: 'FaFolderMinus',
    searchTerms: ['Folder Minus', 'Ordner', 'Entfernen', 'Dateien'],
  },
  {
    name: 'FaFolderOpen',
    searchTerms: ['Folder Open', 'Ordner', 'Geöffnet', 'Dateien'],
  },
  {
    name: 'FaFolderPlus',
    searchTerms: ['Folder Plus', 'Ordner', 'Hinzufügen', 'Dateien'],
  },
  {
    name: 'FaFolderTree',
    searchTerms: ['Folder Tree', 'Ordnerbaum', 'Dateien', 'Struktur'],
  },
  {
    name: 'FaFolder',
    searchTerms: ['Folder', 'Ordner', 'Dateien', 'Speicher'],
  },
  {
    name: 'FaFont',
    searchTerms: ['Font', 'Schriftart', 'Text', 'Typografie'],
  },
  {
    name: 'FaFootball',
    searchTerms: ['Football', 'Fußball', 'Sport', 'Ball'],
  },
  {
    name: 'FaForwardFast',
    searchTerms: ['Forward Fast', 'Vorspulen', 'Schnell', 'Richtung'],
  },
  {
    name: 'FaForwardStep',
    searchTerms: ['Forward Step', 'Schritt vorwärts', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaForward',
    searchTerms: ['Forward', 'Vorwärts', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaFrancSign',
    searchTerms: ['Franc Sign', 'Franken', 'Währung', 'Geld'],
  },
  {
    name: 'FaFrog',
    searchTerms: ['Frog', 'Frosch', 'Tier', 'Natur'],
  },
  {
    name: 'FaFutbol',
    searchTerms: ['Futbol', 'Fußball', 'Sport', 'Ball'],
  },
  {
    name: 'FaG',
    searchTerms: ['G', 'Buchstabe G', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaGamepad',
    searchTerms: ['Gamepad', 'Controller', 'Spiele', 'Konsole'],
  },
  {
    name: 'FaGasPump',
    searchTerms: ['Gas Pump', 'Tankstelle', 'Benzin', 'Auto'],
  },
  {
    name: 'FaGaugeHigh',
    searchTerms: ['Gauge High', 'Messgerät', 'Hoch', 'Geschwindigkeit'],
  },
  {
    name: 'FaGaugeSimpleHigh',
    searchTerms: [
      'Gauge Simple High',
      'Einfaches Messgerät',
      'Hoch',
      'Geschwindigkeit',
    ],
  },
  {
    name: 'FaGaugeSimple',
    searchTerms: [
      'Gauge Simple',
      'Einfaches Messgerät',
      'Anzeige',
      'Geschwindigkeit',
    ],
  },
  {
    name: 'FaGauge',
    searchTerms: ['Gauge', 'Messgerät', 'Anzeige', 'Geschwindigkeit'],
  },
  {
    name: 'FaGavel',
    searchTerms: ['Gavel', 'Richterhammer', 'Gericht', 'Recht'],
  },
  {
    name: 'FaGear',
    searchTerms: ['Gear', 'Zahnrad', 'Einstellungen', 'Technologie'],
  },
  {
    name: 'FaGears',
    searchTerms: ['Gears', 'Zahnräder', 'Mechanik', 'Technologie'],
  },
  {
    name: 'FaGem',
    searchTerms: ['Gem', 'Edelstein', 'Schmuck', 'Wertvoll'],
  },
  {
    name: 'FaGenderless',
    searchTerms: ['Genderless', 'Geschlechtsneutral', 'Symbol', 'Identität'],
  },
  {
    name: 'FaGhost',
    searchTerms: ['Ghost', 'Geist', 'Fantasie', 'Spuk'],
  },
  {
    name: 'FaGift',
    searchTerms: ['Gift', 'Geschenk', 'Präsent', 'Feiern'],
  },
  {
    name: 'FaGifts',
    searchTerms: ['Gifts', 'Geschenke', 'Präsente', 'Feiern'],
  },
  {
    name: 'FaGlassWaterDroplet',
    searchTerms: ['Glass Water Droplet', 'Wasserglas', 'Tropfen', 'Trinken'],
  },
  {
    name: 'FaGlassWater',
    searchTerms: ['Glass Water', 'Wasserglas', 'Trinken', 'Wasser'],
  },
  {
    name: 'FaGlasses',
    searchTerms: ['Glasses', 'Brille', 'Sehen', 'Optik'],
  },
  {
    name: 'FaGlobe',
    searchTerms: ['Globe', 'Globus', 'Erde', 'Welt'],
  },
  {
    name: 'FaGolfBallTee',
    searchTerms: ['Golf Ball Tee', 'Golfball', 'Sport', 'Golf'],
  },
  {
    name: 'FaGopuram',
    searchTerms: ['Gopuram', 'Tempel', 'Indien', 'Religion'],
  },
  {
    name: 'FaGraduationCap',
    searchTerms: ['Graduation Cap', 'Abschlusskappe', 'Bildung', 'Abschluss'],
  },
  {
    name: 'FaGreaterThanEqual',
    searchTerms: [
      'Greater Than Equal',
      'Größer gleich',
      'Mathematik',
      'Vergleich',
    ],
  },
  {
    name: 'FaGreaterThan',
    searchTerms: ['Greater Than', 'Größer als', 'Mathematik', 'Vergleich'],
  },
  {
    name: 'FaGripLinesVertical',
    searchTerms: [
      'Grip Lines Vertical',
      'Vertikale Linien',
      'Griff',
      'Steuerung',
    ],
  },
  {
    name: 'FaGripLines',
    searchTerms: ['Grip Lines', 'Linien', 'Griff', 'Steuerung'],
  },
  {
    name: 'FaGripVertical',
    searchTerms: ['Grip Vertical', 'Vertikaler Griff', 'Steuerung', 'Linien'],
  },
  {
    name: 'FaGrip',
    searchTerms: ['Grip', 'Griff', 'Steuerung', 'Linien'],
  },
  {
    name: 'FaGroupArrowsRotate',
    searchTerms: ['Group Arrows Rotate', 'Pfeile', 'Drehen', 'Gruppe'],
  },
  {
    name: 'FaGuaraniSign',
    searchTerms: ['Guarani Sign', 'Guarani', 'Währung', 'Geld'],
  },
  {
    name: 'FaGuitar',
    searchTerms: ['Guitar', 'Gitarre', 'Musik', 'Instrument'],
  },
  {
    name: 'FaGun',
    searchTerms: ['Gun', 'Waffe', 'Pistole', 'Schießen'],
  },
  {
    name: 'FaH',
    searchTerms: ['H', 'Buchstabe H', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaHammer',
    searchTerms: ['Hammer', 'Werkzeug', 'Schlagen', 'Bauen'],
  },
  {
    name: 'FaHamsa',
    searchTerms: ['Hamsa', 'Hand', 'Symbol', 'Schutz'],
  },
  {
    name: 'FaHandBackFist',
    searchTerms: ['Hand Back Fist', 'Faust', 'Hand', 'Kampf'],
  },
  {
    name: 'FaHandDots',
    searchTerms: ['Hand Dots', 'Hand', 'Flecken', 'Erkrankung'],
  },
  {
    name: 'FaHandFist',
    searchTerms: ['Hand Fist', 'Faust', 'Hand', 'Kampf'],
  },
  {
    name: 'FaHandHoldingDollar',
    searchTerms: ['Hand Holding Dollar', 'Hand', 'Dollar', 'Geld'],
  },
  {
    name: 'FaHandHoldingDroplet',
    searchTerms: ['Hand Holding Droplet', 'Hand', 'Tropfen', 'Wasser'],
  },
  {
    name: 'FaHandHoldingHand',
    searchTerms: ['Hand Holding Hand', 'Hand', 'Hilfe', 'Unterstützung'],
  },
  {
    name: 'FaHandHoldingHeart',
    searchTerms: ['Hand Holding Heart', 'Hand', 'Herz', 'Liebe'],
  },
  {
    name: 'FaHandHoldingMedical',
    searchTerms: ['Hand Holding Medical', 'Hand', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaHandHolding',
    searchTerms: ['Hand Holding', 'Hand', 'Halten', 'Hilfe'],
  },
  {
    name: 'FaHandLizard',
    searchTerms: ['Hand Lizard', 'Hand', 'Eidechse', 'Symbol'],
  },
  {
    name: 'FaHandMiddleFinger',
    searchTerms: ['Hand Middle Finger', 'Mittelfinger', 'Hand', 'Gestik'],
  },
  {
    name: 'FaHandPeace',
    searchTerms: ['Hand Peace', 'Frieden', 'Hand', 'Symbol'],
  },
  {
    name: 'FaHandPointDown',
    searchTerms: ['Hand Point Down', 'Hand', 'Zeigen', 'Pfeil nach unten'],
  },
  {
    name: 'FaHandPointLeft',
    searchTerms: ['Hand Point Left', 'Hand', 'Zeigen', 'Pfeil nach links'],
  },
  {
    name: 'FaHandPointRight',
    searchTerms: ['Hand Point Right', 'Hand', 'Zeigen', 'Pfeil nach rechts'],
  },
  {
    name: 'FaHandPointUp',
    searchTerms: ['Hand Point Up', 'Hand', 'Zeigen', 'Pfeil nach oben'],
  },
  {
    name: 'FaHandPointer',
    searchTerms: ['Hand Pointer', 'Hand', 'Zeiger', 'Maus'],
  },
  {
    name: 'FaHandScissors',
    searchTerms: ['Hand Scissors', 'Schere', 'Hand', 'Symbol'],
  },
  {
    name: 'FaHandSparkles',
    searchTerms: ['Hand Sparkles', 'Hand', 'Funkeln', 'Magie'],
  },
  {
    name: 'FaHandSpock',
    searchTerms: ['Hand Spock', 'Hand', 'Spock', 'Geste'],
  },
  {
    name: 'FaHand',
    searchTerms: ['Hand', 'Hand', 'Symbol', 'Gestik'],
  },
  {
    name: 'FaHandcuffs',
    searchTerms: ['Handcuffs', 'Handschellen', 'Polizei', 'Sicherheit'],
  },
  {
    name: 'FaHandsAslInterpreting',
    searchTerms: ['Hands ASL Interpreting', 'Gebärdensprache', 'ASL', 'Hände'],
  },
  {
    name: 'FaHandsBound',
    searchTerms: ['Hands Bound', 'Gefesselte Hände', 'Hände', 'Fesseln'],
  },
  {
    name: 'FaHandsBubbles',
    searchTerms: ['Hands Bubbles', 'Hände', 'Blasen', 'Waschen'],
  },
  {
    name: 'FaHandsClapping',
    searchTerms: ['Hands Clapping', 'Hände', 'Applaus', 'Klatschen'],
  },
  {
    name: 'FaHandsHoldingChild',
    searchTerms: ['Hands Holding Child', 'Hände', 'Kind', 'Schutz'],
  },
  {
    name: 'FaHandsHoldingCircle',
    searchTerms: ['Hands Holding Circle', 'Hände', 'Kreis', 'Schutz'],
  },
  {
    name: 'FaHandsHolding',
    searchTerms: ['Hands Holding', 'Hände', 'Halten', 'Unterstützung'],
  },
  {
    name: 'FaHandsPraying',
    searchTerms: ['Hands Praying', 'Betende Hände', 'Gebet', 'Religion'],
  },
  {
    name: 'FaHands',
    searchTerms: ['Hands', 'Hände', 'Symbol', 'Gestik'],
  },
  {
    name: 'FaHandshakeAngle',
    searchTerms: [
      'Handshake Angle',
      'Händedruck',
      'Vereinbarung',
      'Partnerschaft',
    ],
  },
  {
    name: 'FaHandshakeSimpleSlash',
    searchTerms: [
      'Handshake Simple Slash',
      'Kein Händedruck',
      'Verboten',
      'Partnerschaft',
    ],
  },
  {
    name: 'FaHandshakeSimple',
    searchTerms: [
      'Handshake Simple',
      'Einfacher Händedruck',
      'Vereinbarung',
      'Partnerschaft',
    ],
  },
  {
    name: 'FaHandshakeSlash',
    searchTerms: [
      'Handshake Slash',
      'Kein Händedruck',
      'Verboten',
      'Partnerschaft',
    ],
  },
  {
    name: 'FaHandshake',
    searchTerms: ['Handshake', 'Händedruck', 'Vereinbarung', 'Partnerschaft'],
  },
  {
    name: 'FaHanukiah',
    searchTerms: ['Hanukiah', 'Kerzenständer', 'Judentum', 'Religion'],
  },
  {
    name: 'FaHardDrive',
    searchTerms: ['Hard Drive', 'Festplatte', 'Speicher', 'Computer'],
  },
  {
    name: 'FaHashtag',
    searchTerms: ['Hashtag', 'Symbol', 'Social Media', 'Nummer'],
  },
  {
    name: 'FaHatCowboySide',
    searchTerms: ['Hat Cowboy Side', 'Cowboyhut', 'Kleidung', 'Westen'],
  },
  {
    name: 'FaHatCowboy',
    searchTerms: ['Hat Cowboy', 'Cowboyhut', 'Kleidung', 'Westen'],
  },
  {
    name: 'FaHatWizard',
    searchTerms: ['Hat Wizard', 'Zaubererhut', 'Magie', 'Fantasy'],
  },
  {
    name: 'FaHeadSideCoughSlash',
    searchTerms: ['Head Side Cough Slash', 'Husten', 'Verboten', 'Gesundheit'],
  },
  {
    name: 'FaHeadSideCough',
    searchTerms: ['Head Side Cough', 'Husten', 'Kopf', 'Gesundheit'],
  },
  {
    name: 'FaHeadSideMask',
    searchTerms: ['Head Side Mask', 'Maske', 'Gesundheit', 'Schutz'],
  },
  {
    name: 'FaHeadSideVirus',
    searchTerms: ['Head Side Virus', 'Virus', 'Kopf', 'Gesundheit'],
  },
  {
    name: 'FaHeading',
    searchTerms: ['Heading', 'Überschrift', 'Text', 'Schriftart'],
  },
  {
    name: 'FaHeadphonesSimple',
    searchTerms: ['Headphones Simple', 'Kopfhörer', 'Musik', 'Audio'],
  },
  {
    name: 'FaHeadphones',
    searchTerms: ['Headphones', 'Kopfhörer', 'Musik', 'Audio'],
  },
  {
    name: 'FaHeadset',
    searchTerms: ['Headset', 'Kopfhörer', 'Mikrofon', 'Kommunikation'],
  },
  {
    name: 'FaHeartCircleBolt',
    searchTerms: ['Heart Circle Bolt', 'Herz', 'Blitz', 'Kreis'],
  },
  {
    name: 'FaHeartCircleCheck',
    searchTerms: ['Heart Circle Check', 'Herz', 'Bestätigung', 'Kreis'],
  },
  {
    name: 'FaHeartCircleExclamation',
    searchTerms: [
      'Heart Circle Exclamation',
      'Herz',
      'Ausrufezeichen',
      'Kreis',
    ],
  },
  {
    name: 'FaHeartCircleMinus',
    searchTerms: ['Heart Circle Minus', 'Herz', 'Entfernen', 'Kreis'],
  },
  {
    name: 'FaHeartCirclePlus',
    searchTerms: ['Heart Circle Plus', 'Herz', 'Hinzufügen', 'Kreis'],
  },
  {
    name: 'FaHeartCircleXmark',
    searchTerms: ['Heart Circle Xmark', 'Herz', 'Fehler', 'Kreis'],
  },
  {
    name: 'FaHeartCrack',
    searchTerms: ['Heart Crack', 'Gebrochenes Herz', 'Liebe', 'Trennung'],
  },
  {
    name: 'FaHeartPulse',
    searchTerms: ['Heart Pulse', 'Herzschlag', 'Herz', 'Gesundheit'],
  },
  {
    name: 'FaHeart',
    searchTerms: ['Heart', 'Herz', 'Liebe', 'Symbol'],
  },
  {
    name: 'FaHelicopterSymbol',
    searchTerms: ['Helicopter Symbol', 'Hubschrauber', 'Symbol', 'Transport'],
  },
  {
    name: 'FaHelicopter',
    searchTerms: ['Helicopter', 'Hubschrauber', 'Transport', 'Luftfahrt'],
  },
  {
    name: 'FaHelmetSafety',
    searchTerms: ['Helmet Safety', 'Sicherheitshelm', 'Schutz', 'Bau'],
  },
  {
    name: 'FaHelmetUn',
    searchTerms: ['Helmet UN', 'UN-Helm', 'Schutz', 'Vereinte Nationen'],
  },
  {
    name: 'FaHighlighter',
    searchTerms: ['Highlighter', 'Textmarker', 'Schreiben', 'Markieren'],
  },
  {
    name: 'FaHillAvalanche',
    searchTerms: ['Hill Avalanche', 'Lawine', 'Berg', 'Naturkatastrophe'],
  },
  {
    name: 'FaHillRockslide',
    searchTerms: ['Hill Rockslide', 'Steinschlag', 'Berg', 'Naturkatastrophe'],
  },
  {
    name: 'FaHippo',
    searchTerms: ['Hippo', 'Nilpferd', 'Tier', 'Safari'],
  },
  {
    name: 'FaHockeyPuck',
    searchTerms: ['Hockey Puck', 'Hockey', 'Sport', 'Eishockey'],
  },
  {
    name: 'FaHollyBerry',
    searchTerms: ['Holly Berry', 'Stechpalme', 'Beere', 'Weihnachten'],
  },
  {
    name: 'FaHorseHead',
    searchTerms: ['Horse Head', 'Pferdekopf', 'Tier', 'Reiten'],
  },
  {
    name: 'FaHorse',
    searchTerms: ['Horse', 'Pferd', 'Tier', 'Reiten'],
  },
  {
    name: 'FaHospitalUser',
    searchTerms: ['Hospital User', 'Krankenhaus', 'Benutzer', 'Gesundheit'],
  },
  {
    name: 'FaHospital',
    searchTerms: ['Hospital', 'Krankenhaus', 'Gesundheit', 'Medizin'],
  },
  {
    name: 'FaHotTubPerson',
    searchTerms: ['Hot Tub Person', 'Whirlpool', 'Person', 'Entspannung'],
  },
  {
    name: 'FaHotdog',
    searchTerms: ['Hotdog', 'Essen', 'Fast Food', 'Snack'],
  },
  {
    name: 'FaHotel',
    searchTerms: ['Hotel', 'Unterkunft', 'Reise', 'Übernachtung'],
  },
  {
    name: 'FaHourglassEnd',
    searchTerms: ['Hourglass End', 'Sanduhr Ende', 'Zeit', 'Ende'],
  },
  {
    name: 'FaHourglassHalf',
    searchTerms: ['Hourglass Half', 'Sanduhr Halb', 'Zeit', 'Zwischen'],
  },
  {
    name: 'FaHourglassStart',
    searchTerms: ['Hourglass Start', 'Sanduhr Anfang', 'Zeit', 'Beginn'],
  },
  {
    name: 'FaHourglass',
    searchTerms: ['Hourglass', 'Sanduhr', 'Zeit', 'Messung'],
  },
  {
    name: 'FaHouseChimneyCrack',
    searchTerms: ['House Chimney Crack', 'Haus', 'Schornstein', 'Schaden'],
  },
  {
    name: 'FaHouseChimneyMedical',
    searchTerms: ['House Chimney Medical', 'Haus', 'Medizin', 'Schornstein'],
  },
  {
    name: 'FaHouseChimneyUser',
    searchTerms: ['House Chimney User', 'Haus', 'Benutzer', 'Schornstein'],
  },
  {
    name: 'FaHouseChimneyWindow',
    searchTerms: ['House Chimney Window', 'Haus', 'Fenster', 'Schornstein'],
  },
  {
    name: 'FaHouseChimney',
    searchTerms: ['House Chimney', 'Haus', 'Schornstein', 'Gebäude'],
  },
  {
    name: 'FaHouseCircleCheck',
    searchTerms: ['House Circle Check', 'Haus', 'Bestätigung', 'Kreis'],
  },
  {
    name: 'FaHouseCircleExclamation',
    searchTerms: ['House Circle Exclamation', 'Haus', 'Warnung', 'Kreis'],
  },
  {
    name: 'FaHouseCircleXmark',
    searchTerms: ['House Circle Xmark', 'Haus', 'Fehler', 'Kreis'],
  },
  {
    name: 'FaHouseCrack',
    searchTerms: ['House Crack', 'Riss im Haus', 'Schaden', 'Gebäude'],
  },
  {
    name: 'FaHouseFire',
    searchTerms: ['House Fire', 'Haus', 'Feuer', 'Brand'],
  },
  {
    name: 'FaHouseFlag',
    searchTerms: ['House Flag', 'Haus', 'Flagge', 'Symbol'],
  },
  {
    name: 'FaHouseFloodWaterCircleArrowRight',
    searchTerms: [
      'House Flood Water Circle Arrow Right',
      'Haus',
      'Flut',
      'Wasser',
    ],
  },
  {
    name: 'FaHouseFloodWater',
    searchTerms: ['House Flood Water', 'Haus', 'Flut', 'Wasser'],
  },
  {
    name: 'FaHouseLaptop',
    searchTerms: ['House Laptop', 'Haus', 'Laptop', 'Arbeit'],
  },
  {
    name: 'FaHouseLock',
    searchTerms: ['House Lock', 'Haus', 'Schloss', 'Sicherheit'],
  },
  {
    name: 'FaHouseMedicalCircleCheck',
    searchTerms: [
      'House Medical Circle Check',
      'Medizinisches Haus',
      'Bestätigung',
      'Kreis',
    ],
  },
  {
    name: 'FaHouseMedicalCircleExclamation',
    searchTerms: [
      'House Medical Circle Exclamation',
      'Medizinisches Haus',
      'Warnung',
      'Kreis',
    ],
  },
  {
    name: 'FaHouseMedicalCircleXmark',
    searchTerms: [
      'House Medical Circle Xmark',
      'Medizinisches Haus',
      'Fehler',
      'Kreis',
    ],
  },
  {
    name: 'FaHouseMedicalFlag',
    searchTerms: [
      'House Medical Flag',
      'Medizinisches Haus',
      'Flagge',
      'Gesundheit',
    ],
  },
  {
    name: 'FaHouseMedical',
    searchTerms: [
      'House Medical',
      'Medizinisches Haus',
      'Gesundheit',
      'Gebäude',
    ],
  },
  {
    name: 'FaHouseSignal',
    searchTerms: ['House Signal', 'Haus', 'Signal', 'Verbindung'],
  },
  {
    name: 'FaHouseTsunami',
    searchTerms: ['House Tsunami', 'Haus', 'Tsunami', 'Naturkatastrophe'],
  },
  {
    name: 'FaHouseUser',
    searchTerms: ['House User', 'Haus', 'Benutzer', 'Gebäude'],
  },
  {
    name: 'FaHouse',
    searchTerms: ['House', 'Haus', 'Gebäude', 'Zuhause'],
  },
  {
    name: 'FaHryvniaSign',
    searchTerms: ['Hryvnia Sign', 'Hryvnia', 'Währung', 'Ukraine'],
  },
  {
    name: 'FaHurricane',
    searchTerms: ['Hurricane', 'Wirbelsturm', 'Naturkatastrophe', 'Wetter'],
  },
  {
    name: 'FaICursor',
    searchTerms: ['I Cursor', 'Textcursor', 'Schreiben', 'Computer'],
  },
  {
    name: 'FaI',
    searchTerms: ['I', 'Buchstabe I', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaIceCream',
    searchTerms: ['Ice Cream', 'Eiscreme', 'Nachtisch', 'Essen'],
  },
  {
    name: 'FaIcicles',
    searchTerms: ['Icicles', 'Eiszapfen', 'Winter', 'Kälte'],
  },
  {
    name: 'FaIcons',
    searchTerms: ['Icons', 'Symbole', 'Bilder', 'Grafik'],
  },
  {
    name: 'FaIdBadge',
    searchTerms: ['ID Badge', 'Ausweis', 'Abzeichen', 'Identifikation'],
  },
  {
    name: 'FaIdCardClip',
    searchTerms: ['ID Card Clip', 'Ausweis', 'Clip', 'Identifikation'],
  },
  {
    name: 'FaIdCard',
    searchTerms: ['ID Card', 'Ausweis', 'Identifikation', 'Dokument'],
  },
  {
    name: 'FaIgloo',
    searchTerms: ['Igloo', 'Iglu', 'Schnee', 'Winter'],
  },
  {
    name: 'FaImagePortrait',
    searchTerms: ['Image Portrait', 'Porträtbild', 'Bild', 'Foto'],
  },
  {
    name: 'FaImage',
    searchTerms: ['Image', 'Bild', 'Foto', 'Grafik'],
  },
  {
    name: 'FaImages',
    searchTerms: ['Images', 'Bilder', 'Fotos', 'Grafiken'],
  },
  {
    name: 'FaInbox',
    searchTerms: ['Inbox', 'Posteingang', 'Nachrichten', 'E-Mail'],
  },
  {
    name: 'FaIndent',
    searchTerms: ['Indent', 'Einzug', 'Text', 'Formatierung'],
  },
  {
    name: 'FaIndianRupeeSign',
    searchTerms: ['Indian Rupee Sign', 'Indische Rupie', 'Währung', 'Geld'],
  },
  {
    name: 'FaIndustry',
    searchTerms: ['Industry', 'Industrie', 'Fabrik', 'Arbeit'],
  },
  {
    name: 'FaInfinity',
    searchTerms: ['Infinity', 'Unendlichkeit', 'Symbol', 'Endlos'],
  },
  {
    name: 'FaInfo',
    searchTerms: ['Info', 'Information', 'Details', 'Hinweis'],
  },
  {
    name: 'FaItalic',
    searchTerms: ['Italic', 'Kursiv', 'Text', 'Formatierung'],
  },
  {
    name: 'FaJ',
    searchTerms: ['J', 'Buchstabe J', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaJarWheat',
    searchTerms: ['Jar Wheat', 'Weckglas', 'Weizen', 'Vorrat'],
  },
  {
    name: 'FaJar',
    searchTerms: ['Jar', 'Weckglas', 'Glas', 'Vorrat'],
  },
  {
    name: 'FaJedi',
    searchTerms: ['Jedi', 'Star Wars', 'Krieger', 'Lichtschwert'],
  },
  {
    name: 'FaJetFighterUp',
    searchTerms: ['Jet Fighter Up', 'Kampfjet', 'Flugzeug', 'Luftfahrt'],
  },
  {
    name: 'FaJetFighter',
    searchTerms: ['Jet Fighter', 'Kampfjet', 'Flugzeug', 'Luftfahrt'],
  },
  {
    name: 'FaJoint',
    searchTerms: ['Joint', 'Zigarette', 'Rauchen', 'Cannabis'],
  },
  {
    name: 'FaJugDetergent',
    searchTerms: ['Jug Detergent', 'Waschmittel', 'Flüssigkeit', 'Reinigung'],
  },
  {
    name: 'FaK',
    searchTerms: ['K', 'Buchstabe K', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaKaaba',
    searchTerms: ['Kaaba', 'Religion', 'Mekka', 'Islam'],
  },
  {
    name: 'FaKey',
    searchTerms: ['Key', 'Schlüssel', 'Sicherheit', 'Schloss'],
  },
  {
    name: 'FaKeyboard',
    searchTerms: ['Keyboard', 'Tastatur', 'Schreiben', 'Computer'],
  },
  {
    name: 'FaKhanda',
    searchTerms: ['Khanda', 'Symbol', 'Sikhismus', 'Religion'],
  },
  {
    name: 'FaKipSign',
    searchTerms: ['Kip Sign', 'Kip', 'Währung', 'Geld'],
  },
  {
    name: 'FaKitMedical',
    searchTerms: ['Kit Medical', 'Erste-Hilfe-Set', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaKitchenSet',
    searchTerms: ['Kitchen Set', 'Küchenset', 'Küche', 'Kochen'],
  },
  {
    name: 'FaKiwiBird',
    searchTerms: ['Kiwi Bird', 'Vogel', 'Tier', 'Natur'],
  },
  {
    name: 'FaL',
    searchTerms: ['L', 'Buchstabe L', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaLandMineOn',
    searchTerms: ['Land Mine On', 'Landmine', 'Explosion', 'Gefahr'],
  },
  {
    name: 'FaLandmarkDome',
    searchTerms: ['Landmark Dome', 'Wahrzeichen', 'Gebäude', 'Kuppel'],
  },
  {
    name: 'FaLandmarkFlag',
    searchTerms: ['Landmark Flag', 'Wahrzeichen', 'Flagge', 'Gebäude'],
  },
  {
    name: 'FaLandmark',
    searchTerms: ['Landmark', 'Wahrzeichen', 'Gebäude', 'Architektur'],
  },
  {
    name: 'FaLanguage',
    searchTerms: ['Language', 'Sprache', 'Kommunikation', 'Wörter'],
  },
  {
    name: 'FaLaptopCode',
    searchTerms: ['Laptop Code', 'Laptop', 'Programmierung', 'Computer'],
  },
  {
    name: 'FaLaptopFile',
    searchTerms: ['Laptop File', 'Laptop', 'Datei', 'Arbeit'],
  },
  {
    name: 'FaLaptopMedical',
    searchTerms: ['Laptop Medical', 'Laptop', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaLaptop',
    searchTerms: ['Laptop', 'Computer', 'Arbeit', 'Technologie'],
  },
  {
    name: 'FaLariSign',
    searchTerms: ['Lari Sign', 'Lari', 'Währung', 'Geld'],
  },
  {
    name: 'FaLayerGroup',
    searchTerms: ['Layer Group', 'Schichtengruppe', 'Design', 'Ebenen'],
  },
  {
    name: 'FaLeaf',
    searchTerms: ['Leaf', 'Blatt', 'Natur', 'Pflanze'],
  },
  {
    name: 'FaLeftLong',
    searchTerms: ['Left Long', 'Links', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaLeftRight',
    searchTerms: ['Left Right', 'Links und rechts', 'Pfeile', 'Richtung'],
  },
  {
    name: 'FaLemon',
    searchTerms: ['Lemon', 'Zitrone', 'Frucht', 'Essen'],
  },
  {
    name: 'FaLessThanEqual',
    searchTerms: [
      'Less Than Equal',
      'Kleiner gleich',
      'Mathematik',
      'Vergleich',
    ],
  },
  {
    name: 'FaLessThan',
    searchTerms: ['Less Than', 'Kleiner als', 'Mathematik', 'Vergleich'],
  },
  {
    name: 'FaLifeRing',
    searchTerms: ['Life Ring', 'Rettungsring', 'Sicherheit', 'Wasser'],
  },
  {
    name: 'FaLightbulb',
    searchTerms: ['Lightbulb', 'Glühbirne', 'Idee', 'Licht'],
  },
  {
    name: 'FaLinesLeaning',
    searchTerms: ['Lines Leaning', 'Lehnende Linien', 'Design', 'Formen'],
  },
  {
    name: 'FaLinkSlash',
    searchTerms: ['Link Slash', 'Link entfernen', 'Verbindung', 'Trennen'],
  },
  {
    name: 'FaLink',
    searchTerms: ['Link', 'Verbindung', 'Internet', 'Hyperlink'],
  },
  {
    name: 'FaLiraSign',
    searchTerms: ['Lira Sign', 'Lira', 'Währung', 'Geld'],
  },
  {
    name: 'FaListCheck',
    searchTerms: ['List Check', 'Checkliste', 'Aufgaben', 'Prüfen'],
  },
  {
    name: 'FaListOl',
    searchTerms: ['List Ol', 'Nummerierte Liste', 'Aufzählung', 'Text'],
  },
  {
    name: 'FaListUl',
    searchTerms: ['List Ul', 'Unnummerierte Liste', 'Aufzählung', 'Text'],
  },
  {
    name: 'FaList',
    searchTerms: ['List', 'Liste', 'Aufzählung', 'Text'],
  },
  {
    name: 'FaLitecoinSign',
    searchTerms: ['Litecoin Sign', 'Litecoin', 'Währung', 'Kryptowährung'],
  },
  {
    name: 'FaLocationArrow',
    searchTerms: ['Location Arrow', 'Standortpfeil', 'Navigation', 'Richtung'],
  },
  {
    name: 'FaLocationCrosshairs',
    searchTerms: ['Location Crosshairs', 'Ziel', 'Standort', 'Richtung'],
  },
  {
    name: 'FaLocationDot',
    searchTerms: ['Location Dot', 'Standortpunkt', 'Navigation', 'Standort'],
  },
  {
    name: 'FaLocationPinLock',
    searchTerms: ['Location Pin Lock', 'Standort', 'Schloss', 'Sicherheit'],
  },
  {
    name: 'FaLocationPin',
    searchTerms: ['Location Pin', 'Standort', 'Pin', 'Navigation'],
  },
  {
    name: 'FaLockOpen',
    searchTerms: ['Lock Open', 'Schloss geöffnet', 'Sicherheit', 'Offen'],
  },
  {
    name: 'FaLock',
    searchTerms: ['Lock', 'Schloss', 'Sicherheit', 'Schließen'],
  },
  {
    name: 'FaLocust',
    searchTerms: ['Locust', 'Heuschrecke', 'Insekt', 'Natur'],
  },
  {
    name: 'FaLungsVirus',
    searchTerms: ['Lungs Virus', 'Lungen', 'Virus', 'Gesundheit'],
  },
  {
    name: 'FaLungs',
    searchTerms: ['Lungs', 'Lungen', 'Atmung', 'Gesundheit'],
  },
  {
    name: 'FaM',
    searchTerms: ['M', 'Buchstabe M', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaMagnet',
    searchTerms: ['Magnet', 'Magnetismus', 'Anziehung', 'Physik'],
  },
  {
    name: 'FaMagnifyingGlassArrowRight',
    searchTerms: ['Magnifying Glass Arrow Right', 'Lupe', 'Pfeil', 'Suche'],
  },
  {
    name: 'FaMagnifyingGlassChart',
    searchTerms: ['Magnifying Glass Chart', 'Lupe', 'Diagramm', 'Suche'],
  },
  {
    name: 'FaMagnifyingGlassDollar',
    searchTerms: ['Magnifying Glass Dollar', 'Lupe', 'Dollar', 'Suche'],
  },
  {
    name: 'FaMagnifyingGlassLocation',
    searchTerms: ['Magnifying Glass Location', 'Lupe', 'Standort', 'Suche'],
  },
  {
    name: 'FaMagnifyingGlassMinus',
    searchTerms: ['Magnifying Glass Minus', 'Lupe', 'Verkleinern', 'Suche'],
  },
  {
    name: 'FaMagnifyingGlassPlus',
    searchTerms: ['Magnifying Glass Plus', 'Lupe', 'Vergrößern', 'Suche'],
  },
  {
    name: 'FaMagnifyingGlass',
    searchTerms: ['Magnifying Glass', 'Lupe', 'Suche', 'Vergrößerung'],
  },
  {
    name: 'FaManatSign',
    searchTerms: ['Manat Sign', 'Manat', 'Währung', 'Geld'],
  },
  {
    name: 'FaMapLocationDot',
    searchTerms: ['Map Location Dot', 'Karte', 'Standort', 'Punkt'],
  },
  {
    name: 'FaMapLocation',
    searchTerms: ['Map Location', 'Karte', 'Standort', 'Navigation'],
  },
  {
    name: 'FaMapPin',
    searchTerms: ['Map Pin', 'Karten-Pin', 'Navigation', 'Standort'],
  },
  {
    name: 'FaMap',
    searchTerms: ['Map', 'Karte', 'Navigation', 'Weg'],
  },
  {
    name: 'FaMarker',
    searchTerms: ['Marker', 'Stift', 'Schreiben', 'Markieren'],
  },
  {
    name: 'FaMarsAndVenusBurst',
    searchTerms: ['Mars And Venus Burst', 'Mars', 'Venus', 'Symbol'],
  },
  {
    name: 'FaMarsAndVenus',
    searchTerms: ['Mars And Venus', 'Mars', 'Venus', 'Symbol'],
  },
  {
    name: 'FaMarsDouble',
    searchTerms: ['Mars Double', 'Mars', 'Doppelt', 'Symbol'],
  },
  {
    name: 'FaMarsStrokeRight',
    searchTerms: ['Mars Stroke Right', 'Mars', 'Pfeil rechts', 'Symbol'],
  },
  {
    name: 'FaMarsStrokeUp',
    searchTerms: ['Mars Stroke Up', 'Mars', 'Pfeil oben', 'Symbol'],
  },
  {
    name: 'FaMarsStroke',
    searchTerms: ['Mars Stroke', 'Mars', 'Pfeil', 'Symbol'],
  },
  {
    name: 'FaMars',
    searchTerms: ['Mars', 'Symbol', 'Männlich', 'Planet'],
  },
  {
    name: 'FaMartiniGlassCitrus',
    searchTerms: ['Martini Glass Citrus', 'Martiniglas', 'Zitrone', 'Getränk'],
  },
  {
    name: 'FaMartiniGlassEmpty',
    searchTerms: ['Martini Glass Empty', 'Martiniglas leer', 'Getränk', 'Bar'],
  },
  {
    name: 'FaMartiniGlass',
    searchTerms: ['Martini Glass', 'Martiniglas', 'Getränk', 'Bar'],
  },
  {
    name: 'FaMaskFace',
    searchTerms: ['Mask Face', 'Gesichtsmaske', 'Schutz', 'Gesundheit'],
  },
  {
    name: 'FaMaskVentilator',
    searchTerms: ['Mask Ventilator', 'Beatmungsmaske', 'Schutz', 'Gesundheit'],
  },
  {
    name: 'FaMask',
    searchTerms: ['Mask', 'Maske', 'Schutz', 'Gesundheit'],
  },
  {
    name: 'FaMasksTheater',
    searchTerms: ['Masks Theater', 'Theatermasken', 'Kunst', 'Schauspiel'],
  },
  {
    name: 'FaMattressPillow',
    searchTerms: ['Mattress Pillow', 'Matratze', 'Kissen', 'Schlaf'],
  },
  {
    name: 'FaMaximize',
    searchTerms: ['Maximize', 'Maximieren', 'Vergrößern', 'Größe'],
  },
  {
    name: 'FaMedal',
    searchTerms: ['Medal', 'Medaille', 'Auszeichnung', 'Erfolg'],
  },
  {
    name: 'FaMemory',
    searchTerms: ['Memory', 'Speicher', 'RAM', 'Computer'],
  },
  {
    name: 'FaMenorah',
    searchTerms: ['Menorah', 'Kerzenständer', 'Religion', 'Judentum'],
  },
  {
    name: 'FaMercury',
    searchTerms: ['Mercury', 'Merkur', 'Symbol', 'Planet'],
  },
  {
    name: 'FaMessage',
    searchTerms: ['Message', 'Nachricht', 'Chat', 'Kommunikation'],
  },
  {
    name: 'FaMeteor',
    searchTerms: ['Meteor', 'Meteorit', 'Weltraum', 'Einschlag'],
  },
  {
    name: 'FaMicrochip',
    searchTerms: ['Microchip', 'Chip', 'Computer', 'Technologie'],
  },
  {
    name: 'FaMicrophoneLinesSlash',
    searchTerms: ['Microphone Lines Slash', 'Mikrofon', 'Stumm', 'Audio'],
  },
  {
    name: 'FaMicrophoneLines',
    searchTerms: ['Microphone Lines', 'Mikrofon', 'Audio', 'Aufnahme'],
  },
  {
    name: 'FaMicrophoneSlash',
    searchTerms: ['Microphone Slash', 'Mikrofon', 'Stumm', 'Audio'],
  },
  {
    name: 'FaMicrophone',
    searchTerms: ['Microphone', 'Mikrofon', 'Audio', 'Aufnahme'],
  },
  {
    name: 'FaMicroscope',
    searchTerms: ['Microscope', 'Mikroskop', 'Wissenschaft', 'Vergrößerung'],
  },
  {
    name: 'FaMillSign',
    searchTerms: ['Mill Sign', 'Mills', 'Währung', 'Geld'],
  },
  {
    name: 'FaMinimize',
    searchTerms: ['Minimize', 'Minimieren', 'Verkleinern', 'Größe'],
  },
  {
    name: 'FaMinus',
    searchTerms: ['Minus', 'Subtraktion', 'Entfernen', 'Mathematik'],
  },
  {
    name: 'FaMitten',
    searchTerms: ['Mitten', 'Handschuh', 'Winter', 'Kälte'],
  },
  {
    name: 'FaMobileButton',
    searchTerms: ['Mobile Button', 'Mobiltelefon', 'Knopf', 'Technologie'],
  },
  {
    name: 'FaMobileRetro',
    searchTerms: ['Mobile Retro', 'Retro Handy', 'Telefon', 'Technologie'],
  },
  {
    name: 'FaMobileScreenButton',
    searchTerms: [
      'Mobile Screen Button',
      'Mobiltelefon',
      'Knopf',
      'Bildschirm',
    ],
  },
  {
    name: 'FaMobileScreen',
    searchTerms: ['Mobile Screen', 'Mobiltelefon', 'Bildschirm', 'Technologie'],
  },
  {
    name: 'FaMobile',
    searchTerms: ['Mobile', 'Mobiltelefon', 'Handy', 'Technologie'],
  },
  {
    name: 'FaMoneyBill1Wave',
    searchTerms: ['Money Bill 1 Wave', 'Geldschein', 'Winken', 'Währung'],
  },
  {
    name: 'FaMoneyBill1',
    searchTerms: ['Money Bill 1', 'Geldschein', 'Währung', 'Finanzen'],
  },
  {
    name: 'FaMoneyBillTransfer',
    searchTerms: ['Money Bill Transfer', 'Geldtransfer', 'Währung', 'Finanzen'],
  },
  {
    name: 'FaMoneyBillTrendUp',
    searchTerms: ['Money Bill Trend Up', 'Geldschein', 'Aufwärts', 'Trend'],
  },
  {
    name: 'FaMoneyBillWave',
    searchTerms: ['Money Bill Wave', 'Geldschein', 'Winken', 'Währung'],
  },
  {
    name: 'FaMoneyBillWheat',
    searchTerms: ['Money Bill Wheat', 'Geldschein', 'Weizen', 'Währung'],
  },
  {
    name: 'FaMoneyBill',
    searchTerms: ['Money Bill', 'Geldschein', 'Währung', 'Finanzen'],
  },
  {
    name: 'FaMoneyBills',
    searchTerms: ['Money Bills', 'Geldscheine', 'Währung', 'Finanzen'],
  },
  {
    name: 'FaMoneyCheckDollar',
    searchTerms: ['Money Check Dollar', 'Scheck', 'Dollar', 'Finanzen'],
  },
  {
    name: 'FaMoneyCheck',
    searchTerms: ['Money Check', 'Scheck', 'Geld', 'Finanzen'],
  },
  {
    name: 'FaMonument',
    searchTerms: ['Monument', 'Denkmal', 'Gebäude', 'Architektur'],
  },
  {
    name: 'FaMoon',
    searchTerms: ['Moon', 'Mond', 'Nacht', 'Himmel'],
  },
  {
    name: 'FaMortarPestle',
    searchTerms: ['Mortar Pestle', 'Mörser', 'Küche', 'Kochen'],
  },
  {
    name: 'FaMosque',
    searchTerms: ['Mosque', 'Moschee', 'Religion', 'Gebäude'],
  },
  {
    name: 'FaMosquitoNet',
    searchTerms: ['Mosquito Net', 'Moskitonetz', 'Schutz', 'Insekten'],
  },
  {
    name: 'FaMosquito',
    searchTerms: ['Mosquito', 'Moskito', 'Insekt', 'Schädling'],
  },
  {
    name: 'FaMotorcycle',
    searchTerms: ['Motorcycle', 'Motorrad', 'Fahrzeug', 'Transport'],
  },
  {
    name: 'FaMound',
    searchTerms: ['Mound', 'Hügel', 'Boden', 'Natur'],
  },
  {
    name: 'FaMountainCity',
    searchTerms: ['Mountain City', 'Bergstadt', 'Gebirge', 'Natur'],
  },
  {
    name: 'FaMountainSun',
    searchTerms: ['Mountain Sun', 'Berg', 'Sonne', 'Natur'],
  },
  {
    name: 'FaMountain',
    searchTerms: ['Mountain', 'Berg', 'Natur', 'Gebirge'],
  },
  {
    name: 'FaMugHot',
    searchTerms: ['Mug Hot', 'Heißer Becher', 'Getränk', 'Kaffee'],
  },
  {
    name: 'FaMugSaucer',
    searchTerms: ['Mug Saucer', 'Tasse und Untertasse', 'Getränk', 'Tee'],
  },
  {
    name: 'FaMusic',
    searchTerms: ['Music', 'Musik', 'Note', 'Ton'],
  },
  {
    name: 'FaN',
    searchTerms: ['N', 'Buchstabe N', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaNairaSign',
    searchTerms: ['Naira Sign', 'Naira', 'Währung', 'Nigeria'],
  },
  {
    name: 'FaNetworkWired',
    searchTerms: ['Network Wired', 'Netzwerk', 'Kabel', 'Verbindung'],
  },
  {
    name: 'FaNeuter',
    searchTerms: ['Neuter', 'Neutral', 'Geschlecht', 'Symbol'],
  },
  {
    name: 'FaNewspaper',
    searchTerms: ['Newspaper', 'Zeitung', 'Nachrichten', 'Medien'],
  },
  {
    name: 'FaNotEqual',
    searchTerms: ['Not Equal', 'Ungleich', 'Mathematik', 'Vergleich'],
  },
  {
    name: 'FaNotdef',
    searchTerms: ['Notdef', 'Nicht definiert', 'Symbol', 'Platzhalter'],
  },
  {
    name: 'FaNoteSticky',
    searchTerms: ['Note Sticky', 'Haftnotiz', 'Notiz', 'Papier'],
  },
  {
    name: 'FaNotesMedical',
    searchTerms: [
      'Notes Medical',
      'Medizinische Notizen',
      'Gesundheit',
      'Dokument',
    ],
  },
  {
    name: 'FaO',
    searchTerms: ['O', 'Buchstabe O', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaObjectGroup',
    searchTerms: ['Object Group', 'Objektgruppe', 'Design', 'Gruppe'],
  },
  {
    name: 'FaObjectUngroup',
    searchTerms: ['Object Ungroup', 'Objekt entgruppieren', 'Design', 'Gruppe'],
  },
  {
    name: 'FaOilCan',
    searchTerms: ['Oil Can', 'Ölkanne', 'Werkzeug', 'Schmierung'],
  },
  {
    name: 'FaOilWell',
    searchTerms: ['Oil Well', 'Ölquelle', 'Energie', 'Rohstoffe'],
  },
  {
    name: 'FaOm',
    searchTerms: ['Om', 'Symbol', 'Hinduismus', 'Religion'],
  },
  {
    name: 'FaOtter',
    searchTerms: ['Otter', 'Tier', 'Wasser', 'Natur'],
  },
  {
    name: 'FaOutdent',
    searchTerms: ['Outdent', 'Einzug verkleinern', 'Text', 'Formatierung'],
  },
  {
    name: 'FaP',
    searchTerms: ['P', 'Buchstabe P', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaPager',
    searchTerms: ['Pager', 'Funkrufempfänger', 'Technologie', 'Kommunikation'],
  },
  {
    name: 'FaPaintRoller',
    searchTerms: ['Paint Roller', 'Farbroller', 'Malen', 'Werkzeug'],
  },
  {
    name: 'FaPaintbrush',
    searchTerms: ['Paintbrush', 'Pinsel', 'Malen', 'Kunst'],
  },
  {
    name: 'FaPalette',
    searchTerms: ['Palette', 'Farbpalette', 'Malen', 'Kunst'],
  },
  {
    name: 'FaPallet',
    searchTerms: ['Pallet', 'Palette', 'Transport', 'Logistik'],
  },
  {
    name: 'FaPanorama',
    searchTerms: ['Panorama', 'Rundblick', 'Landschaft', 'Natur'],
  },
  {
    name: 'FaPaperPlane',
    searchTerms: ['Paper Plane', 'Papierflieger', 'Flugzeug', 'Spielzeug'],
  },
  {
    name: 'FaPaperclip',
    searchTerms: ['Paperclip', 'Büroklammer', 'Papier', 'Dokument'],
  },
  {
    name: 'FaParachuteBox',
    searchTerms: ['Parachute Box', 'Fallschirm', 'Paket', 'Lieferung'],
  },
  {
    name: 'FaParagraph',
    searchTerms: ['Paragraph', 'Absatz', 'Text', 'Schreiben'],
  },
  {
    name: 'FaPassport',
    searchTerms: ['Passport', 'Reisepass', 'Dokument', 'Reise'],
  },
  {
    name: 'FaPaste',
    searchTerms: ['Paste', 'Einfügen', 'Text', 'Dokument'],
  },
  {
    name: 'FaPause',
    searchTerms: ['Pause', 'Stoppen', 'Multimedia', 'Steuerung'],
  },
  {
    name: 'FaPaw',
    searchTerms: ['Paw', 'Pfote', 'Tier', 'Hund'],
  },
  {
    name: 'FaPeace',
    searchTerms: ['Peace', 'Frieden', 'Symbol', 'Welt'],
  },
  {
    name: 'FaPenClip',
    searchTerms: ['Pen Clip', 'Stift mit Clip', 'Schreiben', 'Papier'],
  },
  {
    name: 'FaPenFancy',
    searchTerms: ['Pen Fancy', 'Eleganter Stift', 'Schreiben', 'Papier'],
  },
  {
    name: 'FaPenNib',
    searchTerms: ['Pen Nib', 'Füllfeder', 'Schreiben', 'Tinte'],
  },
  {
    name: 'FaPenRuler',
    searchTerms: ['Pen Ruler', 'Stift und Lineal', 'Design', 'Schreiben'],
  },
  {
    name: 'FaPenToSquare',
    searchTerms: ['Pen To Square', 'Stift', 'Bearbeiten', 'Text'],
  },
  {
    name: 'FaPen',
    searchTerms: ['Pen', 'Stift', 'Schreiben', 'Papier'],
  },
  {
    name: 'FaPencil',
    searchTerms: ['Pencil', 'Bleistift', 'Schreiben', 'Papier'],
  },
  {
    name: 'FaPeopleArrows',
    searchTerms: ['People Arrows', 'Menschen', 'Pfeile', 'Bewegung'],
  },
  {
    name: 'FaPeopleCarryBox',
    searchTerms: ['People Carry Box', 'Menschen', 'Kisten', 'Transport'],
  },
  {
    name: 'FaPeopleGroup',
    searchTerms: ['People Group', 'Menschengruppe', 'Gemeinschaft', 'Gruppe'],
  },
  {
    name: 'FaPeopleLine',
    searchTerms: ['People Line', 'Menschen', 'Warteschlange', 'Gruppe'],
  },
  {
    name: 'FaPeoplePulling',
    searchTerms: ['People Pulling', 'Menschen', 'Ziehen', 'Arbeit'],
  },
  {
    name: 'FaPeopleRobbery',
    searchTerms: ['People Robbery', 'Menschen', 'Raub', 'Kriminalität'],
  },
  {
    name: 'FaPeopleRoof',
    searchTerms: ['People Roof', 'Menschen', 'Dach', 'Schutz'],
  },
  {
    name: 'FaPepperHot',
    searchTerms: ['Pepper Hot', 'Chili', 'Scharf', 'Essen'],
  },
  {
    name: 'FaPercent',
    searchTerms: ['Percent', 'Prozent', 'Mathematik', 'Rechnen'],
  },
  {
    name: 'FaPersonArrowDownToLine',
    searchTerms: [
      'Person Arrow Down To Line',
      'Pfeil nach unten',
      'Person',
      'Linie',
    ],
  },
  {
    name: 'FaPersonArrowUpFromLine',
    searchTerms: [
      'Person Arrow Up From Line',
      'Pfeil nach oben',
      'Person',
      'Linie',
    ],
  },
  {
    name: 'FaPersonBiking',
    searchTerms: ['Person Biking', 'Radfahren', 'Person', 'Sport'],
  },
  {
    name: 'FaPersonBooth',
    searchTerms: ['Person Booth', 'Kabine', 'Person', 'Stimme'],
  },
  {
    name: 'FaPersonBreastfeeding',
    searchTerms: ['Person Breastfeeding', 'Stillen', 'Person', 'Baby'],
  },
  {
    name: 'FaPersonBurst',
    searchTerms: ['Person Burst', 'Person', 'Explosion', 'Gefahr'],
  },
  {
    name: 'FaPersonCane',
    searchTerms: ['Person Cane', 'Person', 'Gehstock', 'Alter'],
  },
  {
    name: 'FaPersonChalkboard',
    searchTerms: ['Person Chalkboard', 'Tafel', 'Person', 'Lehrer'],
  },
  {
    name: 'FaPersonCircleCheck',
    searchTerms: ['Person Circle Check', 'Person', 'Bestätigung', 'Kreis'],
  },
  {
    name: 'FaPersonCircleExclamation',
    searchTerms: ['Person Circle Exclamation', 'Person', 'Warnung', 'Kreis'],
  },
  {
    name: 'FaPersonCircleMinus',
    searchTerms: ['Person Circle Minus', 'Person', 'Entfernen', 'Kreis'],
  },
  {
    name: 'FaPersonCirclePlus',
    searchTerms: ['Person Circle Plus', 'Person', 'Hinzufügen', 'Kreis'],
  },
  {
    name: 'FaPersonCircleQuestion',
    searchTerms: ['Person Circle Question', 'Person', 'Frage', 'Kreis'],
  },
  {
    name: 'FaPersonCircleXmark',
    searchTerms: ['Person Circle Xmark', 'Person', 'Fehler', 'Kreis'],
  },
  {
    name: 'FaPersonDigging',
    searchTerms: ['Person Digging', 'Grabende Person', 'Arbeit', 'Schaufel'],
  },
  {
    name: 'FaPersonDotsFromLine',
    searchTerms: ['Person Dots From Line', 'Punkte', 'Person', 'Linie'],
  },
  {
    name: 'FaPersonDressBurst',
    searchTerms: ['Person Dress Burst', 'Kleid', 'Person', 'Explosion'],
  },
  {
    name: 'FaPersonDress',
    searchTerms: ['Person Dress', 'Kleid', 'Person', 'Mode'],
  },
  {
    name: 'FaPersonDrowning',
    searchTerms: ['Person Drowning', 'Ertrinken', 'Person', 'Wasser'],
  },
  {
    name: 'FaPersonFallingBurst',
    searchTerms: [
      'Person Falling Burst',
      'Fallende Person',
      'Explosion',
      'Gefahr',
    ],
  },
  {
    name: 'FaPersonFalling',
    searchTerms: ['Person Falling', 'Person', 'Fallen', 'Unfall'],
  },
  {
    name: 'FaPersonHalfDress',
    searchTerms: ['Person Half Dress', 'Person', 'Halbkleid', 'Mode'],
  },
  {
    name: 'FaPersonHarassing',
    searchTerms: ['Person Harassing', 'Belästigung', 'Person', 'Unrecht'],
  },
  {
    name: 'FaPersonHiking',
    searchTerms: ['Person Hiking', 'Wandern', 'Person', 'Outdoor'],
  },
  {
    name: 'FaPersonMilitaryPointing',
    searchTerms: ['Person Military Pointing', 'Militär', 'Person', 'Richtung'],
  },
  {
    name: 'FaPersonMilitaryRifle',
    searchTerms: ['Person Military Rifle', 'Militär', 'Gewehr', 'Waffe'],
  },
  {
    name: 'FaPersonMilitaryToPerson',
    searchTerms: ['Person Military To Person', 'Militär', 'Person', 'Rückkehr'],
  },
  {
    name: 'FaPersonPraying',
    searchTerms: ['Person Praying', 'Beten', 'Religion', 'Person'],
  },
  {
    name: 'FaPersonPregnant',
    searchTerms: ['Person Pregnant', 'Schwangerschaft', 'Person', 'Baby'],
  },
  {
    name: 'FaPersonRays',
    searchTerms: ['Person Rays', 'Strahlen', 'Person', 'Licht'],
  },
  {
    name: 'FaPersonRifle',
    searchTerms: ['Person Rifle', 'Person', 'Gewehr', 'Waffe'],
  },
  {
    name: 'FaPersonRunning',
    searchTerms: ['Person Running', 'Laufen', 'Person', 'Sport'],
  },
  {
    name: 'FaPersonShelter',
    searchTerms: ['Person Shelter', 'Schutz', 'Person', 'Dach'],
  },
  {
    name: 'FaPersonSkating',
    searchTerms: ['Person Skating', 'Skaten', 'Person', 'Sport'],
  },
  {
    name: 'FaPersonSkiingNordic',
    searchTerms: [
      'Person Skiing Nordic',
      'Skilanglauf',
      'Person',
      'Wintersport',
    ],
  },
  {
    name: 'FaPersonSkiing',
    searchTerms: ['Person Skiing', 'Skifahren', 'Person', 'Wintersport'],
  },
  {
    name: 'FaPersonSnowboarding',
    searchTerms: [
      'Person Snowboarding',
      'Snowboarden',
      'Person',
      'Wintersport',
    ],
  },
  {
    name: 'FaPersonSwimming',
    searchTerms: ['Person Swimming', 'Schwimmen', 'Person', 'Sport'],
  },
  {
    name: 'FaPersonThroughWindow',
    searchTerms: ['Person Through Window', 'Fenster', 'Person', 'Springen'],
  },
  {
    name: 'FaPersonWalkingArrowLoopLeft',
    searchTerms: ['Person Walking Arrow Loop Left', 'Gehen', 'Pfeil', 'Person'],
  },
  {
    name: 'FaPersonWalkingArrowRight',
    searchTerms: ['Person Walking Arrow Right', 'Gehen', 'Person', 'Richtung'],
  },
  {
    name: 'FaPersonWalkingDashedLineArrowRight',
    searchTerms: [
      'Person Walking Dashed Line Arrow Right',
      'Person',
      'Gestrichelte Linie',
      'Richtung',
    ],
  },
  {
    name: 'FaPersonWalkingLuggage',
    searchTerms: ['Person Walking Luggage', 'Koffer', 'Reisen', 'Person'],
  },
  {
    name: 'FaPersonWalkingWithCane',
    searchTerms: ['Person Walking With Cane', 'Gehstock', 'Person', 'Alter'],
  },
  {
    name: 'FaPersonWalking',
    searchTerms: ['Person Walking', 'Gehen', 'Person', 'Bewegung'],
  },
  {
    name: 'FaPerson',
    searchTerms: ['Person', 'Mensch', 'Person', 'Individuum'],
  },
  {
    name: 'FaPesetaSign',
    searchTerms: ['Peseta Sign', 'Peseta', 'Währung', 'Geld'],
  },
  {
    name: 'FaPesoSign',
    searchTerms: ['Peso Sign', 'Peso', 'Währung', 'Geld'],
  },
  {
    name: 'FaPhoneFlip',
    searchTerms: ['Phone Flip', 'Handy', 'Telefon', 'Flip'],
  },
  {
    name: 'FaPhoneSlash',
    searchTerms: ['Phone Slash', 'Telefon', 'Stumm', 'Durchgestrichen'],
  },
  {
    name: 'FaPhoneVolume',
    searchTerms: ['Phone Volume', 'Telefon', 'Lautstärke', 'Ton'],
  },
  {
    name: 'FaPhone',
    searchTerms: ['Phone', 'Telefon', 'Kommunikation', 'Anruf'],
  },
  {
    name: 'FaPhotoFilm',
    searchTerms: ['Photo Film', 'Foto', 'Film', 'Kamera'],
  },
  {
    name: 'FaPiggyBank',
    searchTerms: ['Piggy Bank', 'Sparschwein', 'Geld', 'Sparen'],
  },
  {
    name: 'FaPills',
    searchTerms: ['Pills', 'Tabletten', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaPizzaSlice',
    searchTerms: ['Pizza Slice', 'Pizza', 'Essen', 'Fastfood'],
  },
  {
    name: 'FaPlaceOfWorship',
    searchTerms: ['Place Of Worship', 'Gotteshaus', 'Religion', 'Gebäude'],
  },
  {
    name: 'FaPlaneArrival',
    searchTerms: ['Plane Arrival', 'Flugzeug', 'Ankunft', 'Reise'],
  },
  {
    name: 'FaPlaneCircleCheck',
    searchTerms: ['Plane Circle Check', 'Flugzeug', 'Bestätigung', 'Reise'],
  },
  {
    name: 'FaPlaneCircleExclamation',
    searchTerms: ['Plane Circle Exclamation', 'Flugzeug', 'Warnung', 'Reise'],
  },
  {
    name: 'FaPlaneCircleXmark',
    searchTerms: ['Plane Circle Xmark', 'Flugzeug', 'Fehler', 'Reise'],
  },
  {
    name: 'FaPlaneDeparture',
    searchTerms: ['Plane Departure', 'Flugzeug', 'Abflug', 'Reise'],
  },
  {
    name: 'FaPlaneLock',
    searchTerms: ['Plane Lock', 'Flugzeug', 'Schloss', 'Sicherheit'],
  },
  {
    name: 'FaPlaneSlash',
    searchTerms: ['Plane Slash', 'Flugzeug', 'Verboten', 'Storniert'],
  },
  {
    name: 'FaPlaneUp',
    searchTerms: ['Plane Up', 'Flugzeug', 'Aufwärts', 'Reise'],
  },
  {
    name: 'FaPlane',
    searchTerms: ['Plane', 'Flugzeug', 'Reise', 'Transport'],
  },
  {
    name: 'FaPlantWilt',
    searchTerms: ['Plant Wilt', 'Pflanze', 'Verwelken', 'Natur'],
  },
  {
    name: 'FaPlateWheat',
    searchTerms: ['Plate Wheat', 'Teller', 'Weizen', 'Essen'],
  },
  {
    name: 'FaPlay',
    searchTerms: ['Play', 'Abspielen', 'Video', 'Start'],
  },
  {
    name: 'FaPlugCircleBolt',
    searchTerms: ['Plug Circle Bolt', 'Stecker', 'Blitz', 'Energie'],
  },
  {
    name: 'FaPlugCircleCheck',
    searchTerms: ['Plug Circle Check', 'Stecker', 'Bestätigung', 'Energie'],
  },
  {
    name: 'FaPlugCircleExclamation',
    searchTerms: ['Plug Circle Exclamation', 'Stecker', 'Warnung', 'Energie'],
  },
  {
    name: 'FaPlugCircleMinus',
    searchTerms: ['Plug Circle Minus', 'Stecker', 'Entfernen', 'Energie'],
  },
  {
    name: 'FaPlugCirclePlus',
    searchTerms: ['Plug Circle Plus', 'Stecker', 'Hinzufügen', 'Energie'],
  },
  {
    name: 'FaPlugCircleXmark',
    searchTerms: ['Plug Circle Xmark', 'Stecker', 'Fehler', 'Energie'],
  },
  {
    name: 'FaPlug',
    searchTerms: ['Plug', 'Stecker', 'Energie', 'Technologie'],
  },
  {
    name: 'FaPlusMinus',
    searchTerms: ['Plus Minus', 'Plus', 'Minus', 'Mathematik'],
  },
  {
    name: 'FaPlus',
    searchTerms: ['Plus', 'Hinzufügen', 'Erweitern', 'Mathematik'],
  },
  {
    name: 'FaPodcast',
    searchTerms: ['Podcast', 'Audio', 'Sendung', 'Medien'],
  },
  {
    name: 'FaPooStorm',
    searchTerms: ['Poo Storm', 'Kot', 'Sturm', 'Chaos'],
  },
  {
    name: 'FaPoo',
    searchTerms: ['Poo', 'Kot', 'Humor', 'Eklig'],
  },
  {
    name: 'FaPoop',
    searchTerms: ['Poop', 'Kot', 'Humor', 'Eklig'],
  },
  {
    name: 'FaPowerOff',
    searchTerms: ['Power Off', 'Ausschalten', 'Strom', 'Technologie'],
  },
  {
    name: 'FaPrescriptionBottleMedical',
    searchTerms: [
      'Prescription Bottle Medical',
      'Medikamentenflasche',
      'Medizin',
      'Gesundheit',
    ],
  },
  {
    name: 'FaPrescriptionBottle',
    searchTerms: [
      'Prescription Bottle',
      'Medikamentenflasche',
      'Medizin',
      'Gesundheit',
    ],
  },
  {
    name: 'FaPrescription',
    searchTerms: ['Prescription', 'Rezept', 'Medizin', 'Dokument'],
  },
  {
    name: 'FaPrint',
    searchTerms: ['Print', 'Drucken', 'Dokument', 'Papier'],
  },
  {
    name: 'FaPumpMedical',
    searchTerms: [
      'Pump Medical',
      'Medizinische Pumpe',
      'Gesundheit',
      'Ausrüstung',
    ],
  },
  {
    name: 'FaPumpSoap',
    searchTerms: ['Pump Soap', 'Seifenspender', 'Hygiene', 'Reinigung'],
  },
  {
    name: 'FaPuzzlePiece',
    searchTerms: ['Puzzle Piece', 'Puzzleteil', 'Spiel', 'Teile'],
  },
  {
    name: 'FaQ',
    searchTerms: ['Q', 'Buchstabe Q', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaQrcode',
    searchTerms: ['Qrcode', 'QR-Code', 'Technologie', 'Code'],
  },
  {
    name: 'FaQuestion',
    searchTerms: ['Question', 'Frage', 'Hilfe', 'Unklarheit'],
  },
  {
    name: 'FaQuoteLeft',
    searchTerms: ['Quote Left', 'Linkes Anführungszeichen', 'Zitat', 'Text'],
  },
  {
    name: 'FaQuoteRight',
    searchTerms: ['Quote Right', 'Rechtes Anführungszeichen', 'Zitat', 'Text'],
  },
  {
    name: 'FaR',
    searchTerms: ['R', 'Buchstabe R', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaRadiation',
    searchTerms: ['Radiation', 'Strahlung', 'Gefahr', 'Radioaktivität'],
  },
  {
    name: 'FaRadio',
    searchTerms: ['Radio', 'Sender', 'Audio', 'Technologie'],
  },
  {
    name: 'FaRainbow',
    searchTerms: ['Rainbow', 'Regenbogen', 'Farbe', 'Natur'],
  },
  {
    name: 'FaRankingStar',
    searchTerms: ['Ranking Star', 'Bewertung', 'Stern', 'Rang'],
  },
  {
    name: 'FaReceipt',
    searchTerms: ['Receipt', 'Quittung', 'Dokument', 'Kauf'],
  },
  {
    name: 'FaRecordVinyl',
    searchTerms: ['Record Vinyl', 'Schallplatte', 'Musik', 'Retro'],
  },
  {
    name: 'FaRectangleAd',
    searchTerms: ['Rectangle Ad', 'Rechteckige Anzeige', 'Werbung', 'Banner'],
  },
  {
    name: 'FaRectangleList',
    searchTerms: ['Rectangle List', 'Rechteckige Liste', 'Dokument', 'Liste'],
  },
  {
    name: 'FaRectangleXmark',
    searchTerms: ['Rectangle Xmark', 'Rechteck', 'Fehler', 'X'],
  },
  {
    name: 'FaRecycle',
    searchTerms: ['Recycle', 'Recycling', 'Umwelt', 'Wiederverwertung'],
  },
  {
    name: 'FaRegistered',
    searchTerms: ['Registered', 'Registriert', 'Markenzeichen', 'R'],
  },
  {
    name: 'FaRepeat',
    searchTerms: ['Repeat', 'Wiederholen', 'Schleife', 'Musik'],
  },
  {
    name: 'FaReplyAll',
    searchTerms: ['Reply All', 'Allen antworten', 'E-Mail', 'Kommunikation'],
  },
  {
    name: 'FaReply',
    searchTerms: ['Reply', 'Antwort', 'E-Mail', 'Kommunikation'],
  },
  {
    name: 'FaRepublican',
    searchTerms: ['Republican', 'Republikaner', 'Politik', 'Partei'],
  },
  {
    name: 'FaRestroom',
    searchTerms: ['Restroom', 'Toilette', 'WC', 'Bad'],
  },
  {
    name: 'FaRetweet',
    searchTerms: ['Retweet', 'Teilen', 'Soziale Medien', 'Twitter'],
  },
  {
    name: 'FaRibbon',
    searchTerms: ['Ribbon', 'Band', 'Schleife', 'Dekoration'],
  },
  {
    name: 'FaRightFromBracket',
    searchTerms: [
      'Right From Bracket',
      'Rechts aus Klammer',
      'Richtung',
      'Verlassen',
    ],
  },
  {
    name: 'FaRightLeft',
    searchTerms: ['Right Left', 'Rechts und links', 'Pfeile', 'Richtung'],
  },
  {
    name: 'FaRightLong',
    searchTerms: ['Right Long', 'Rechts lang', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaRightToBracket',
    searchTerms: [
      'Right To Bracket',
      'Rechts zur Klammer',
      'Eintreten',
      'Richtung',
    ],
  },
  {
    name: 'FaRing',
    searchTerms: ['Ring', 'Schmuck', 'Ringe', 'Verlobung'],
  },
  {
    name: 'FaRoadBarrier',
    searchTerms: ['Road Barrier', 'Straßenbarriere', 'Sperre', 'Verkehr'],
  },
  {
    name: 'FaRoadBridge',
    searchTerms: ['Road Bridge', 'Straßenbrücke', 'Brücke', 'Verkehr'],
  },
  {
    name: 'FaRoadCircleCheck',
    searchTerms: ['Road Circle Check', 'Straße', 'Kreis', 'Bestätigung'],
  },
  {
    name: 'FaRoadCircleExclamation',
    searchTerms: ['Road Circle Exclamation', 'Straße', 'Kreis', 'Warnung'],
  },
  {
    name: 'FaRoadCircleXmark',
    searchTerms: ['Road Circle Xmark', 'Straße', 'Kreis', 'Fehler'],
  },
  {
    name: 'FaRoadLock',
    searchTerms: ['Road Lock', 'Straße', 'Schloss', 'Sicherheit'],
  },
  {
    name: 'FaRoadSpikes',
    searchTerms: ['Road Spikes', 'Straßenstacheln', 'Sperre', 'Verkehr'],
  },
  {
    name: 'FaRoad',
    searchTerms: ['Road', 'Straße', 'Verkehr', 'Weg'],
  },
  {
    name: 'FaRobot',
    searchTerms: ['Robot', 'Roboter', 'Technologie', 'Automatisierung'],
  },
  {
    name: 'FaRocket',
    searchTerms: ['Rocket', 'Rakete', 'Weltraum', 'Start'],
  },
  {
    name: 'FaRotateLeft',
    searchTerms: ['Rotate Left', 'Links drehen', 'Richtung', 'Drehen'],
  },
  {
    name: 'FaRotateRight',
    searchTerms: ['Rotate Right', 'Rechts drehen', 'Richtung', 'Drehen'],
  },
  {
    name: 'FaRotate',
    searchTerms: ['Rotate', 'Drehen', 'Rotation', 'Richtung'],
  },
  {
    name: 'FaRoute',
    searchTerms: ['Route', 'Weg', 'Reise', 'Pfad'],
  },
  {
    name: 'FaRss',
    searchTerms: ['RSS', 'Feed', 'Nachrichten', 'Updates'],
  },
  {
    name: 'FaRubleSign',
    searchTerms: ['Ruble Sign', 'Rubel', 'Währung', 'Geld'],
  },
  {
    name: 'FaRug',
    searchTerms: ['Rug', 'Teppich', 'Dekoration', 'Boden'],
  },
  {
    name: 'FaRulerCombined',
    searchTerms: ['Ruler Combined', 'Lineal', 'Maß', 'Werkzeug'],
  },
  {
    name: 'FaRulerHorizontal',
    searchTerms: ['Ruler Horizontal', 'Horizontales Lineal', 'Maß', 'Werkzeug'],
  },
  {
    name: 'FaRulerVertical',
    searchTerms: ['Ruler Vertical', 'Vertikales Lineal', 'Maß', 'Werkzeug'],
  },
  {
    name: 'FaRuler',
    searchTerms: ['Ruler', 'Lineal', 'Maß', 'Werkzeug'],
  },
  {
    name: 'FaRupeeSign',
    searchTerms: ['Rupee Sign', 'Rupie', 'Währung', 'Geld'],
  },
  {
    name: 'FaRupiahSign',
    searchTerms: ['Rupiah Sign', 'Rupiah', 'Währung', 'Geld'],
  },
  {
    name: 'FaS',
    searchTerms: ['S', 'Buchstabe S', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaSackDollar',
    searchTerms: ['Sack Dollar', 'Geldsack', 'Dollar', 'Reichtum'],
  },
  {
    name: 'FaSackXmark',
    searchTerms: ['Sack Xmark', 'Geldsack', 'Fehler', 'Verloren'],
  },
  {
    name: 'FaSailboat',
    searchTerms: ['Sailboat', 'Segelboot', 'Wasser', 'Schiff'],
  },
  {
    name: 'FaSatelliteDish',
    searchTerms: [
      'Satellite Dish',
      'Satellitenschüssel',
      'Technologie',
      'Kommunikation',
    ],
  },
  {
    name: 'FaSatellite',
    searchTerms: ['Satellite', 'Satellit', 'Weltraum', 'Kommunikation'],
  },
  {
    name: 'FaScaleBalanced',
    searchTerms: ['Scale Balanced', 'Waage', 'Gleichgewicht', 'Gerechtigkeit'],
  },
  {
    name: 'FaScaleUnbalancedFlip',
    searchTerms: [
      'Scale Unbalanced Flip',
      'Ungleiche Waage',
      'Ungleichgewicht',
      'Gerechtigkeit',
    ],
  },
  {
    name: 'FaScaleUnbalanced',
    searchTerms: [
      'Scale Unbalanced',
      'Ungleiche Waage',
      'Ungleichgewicht',
      'Gerechtigkeit',
    ],
  },
  {
    name: 'FaSchoolCircleCheck',
    searchTerms: ['School Circle Check', 'Schule', 'Kreis', 'Bestätigung'],
  },
  {
    name: 'FaSchoolCircleExclamation',
    searchTerms: ['School Circle Exclamation', 'Schule', 'Kreis', 'Warnung'],
  },
  {
    name: 'FaSchoolCircleXmark',
    searchTerms: ['School Circle Xmark', 'Schule', 'Kreis', 'Fehler'],
  },
  {
    name: 'FaSchoolFlag',
    searchTerms: ['School Flag', 'Schule', 'Flagge', 'Bildung'],
  },
  {
    name: 'FaSchoolLock',
    searchTerms: ['School Lock', 'Schule', 'Schloss', 'Sicherheit'],
  },
  {
    name: 'FaSchool',
    searchTerms: ['School', 'Schule', 'Bildung', 'Gebäude'],
  },
  {
    name: 'FaScissors',
    searchTerms: ['Scissors', 'Schere', 'Schneiden', 'Werkzeug'],
  },
  {
    name: 'FaScrewdriverWrench',
    searchTerms: [
      'Screwdriver Wrench',
      'Schraubenzieher',
      'Schraubenschlüssel',
      'Werkzeug',
    ],
  },
  {
    name: 'FaScrewdriver',
    searchTerms: ['Screwdriver', 'Schraubenzieher', 'Werkzeug', 'Handwerk'],
  },
  {
    name: 'FaScrollTorah',
    searchTerms: ['Scroll Torah', 'Torarolle', 'Religion', 'Judentum'],
  },
  {
    name: 'FaScroll',
    searchTerms: ['Scroll', 'Rolle', 'Schriftrolle', 'Papier'],
  },
  {
    name: 'FaSdCard',
    searchTerms: ['SD Card', 'Speicherkarte', 'SD', 'Technologie'],
  },
  {
    name: 'FaSection',
    searchTerms: ['Section', 'Abschnitt', 'Kapitel', 'Text'],
  },
  {
    name: 'FaSeedling',
    searchTerms: ['Seedling', 'Keimling', 'Pflanze', 'Natur'],
  },
  {
    name: 'FaServer',
    searchTerms: ['Server', 'Technologie', 'Daten', 'Netzwerk'],
  },
  {
    name: 'FaShapes',
    searchTerms: ['Shapes', 'Formen', 'Design', 'Geometrie'],
  },
  {
    name: 'FaShareFromSquare',
    searchTerms: ['Share From Square', 'Teilen', 'Soziale Medien', 'Symbol'],
  },
  {
    name: 'FaShareNodes',
    searchTerms: ['Share Nodes', 'Teilen', 'Netzwerk', 'Knoten'],
  },
  {
    name: 'FaShare',
    searchTerms: ['Share', 'Teilen', 'Soziale Medien', 'Verteilung'],
  },
  {
    name: 'FaSheetPlastic',
    searchTerms: ['Sheet Plastic', 'Plastikfolie', 'Material', 'Industrie'],
  },
  {
    name: 'FaShekelSign',
    searchTerms: ['Shekel Sign', 'Schekel', 'Währung', 'Israel'],
  },
  {
    name: 'FaShieldCat',
    searchTerms: ['Shield Cat', 'Schild', 'Katze', 'Schutz'],
  },
  {
    name: 'FaShieldDog',
    searchTerms: ['Shield Dog', 'Schild', 'Hund', 'Schutz'],
  },
  {
    name: 'FaShieldHalved',
    searchTerms: ['Shield Halved', 'Halbierter Schild', 'Schutz', 'Sicherheit'],
  },
  {
    name: 'FaShieldHeart',
    searchTerms: ['Shield Heart', 'Herzschild', 'Schutz', 'Liebe'],
  },
  {
    name: 'FaShieldVirus',
    searchTerms: ['Shield Virus', 'Schild', 'Virus', 'Schutz'],
  },
  {
    name: 'FaShield',
    searchTerms: ['Shield', 'Schild', 'Schutz', 'Sicherheit'],
  },
  {
    name: 'FaShip',
    searchTerms: ['Ship', 'Schiff', 'Transport', 'Wasser'],
  },
  {
    name: 'FaShirt',
    searchTerms: ['Shirt', 'Hemd', 'Kleidung', 'Mode'],
  },
  {
    name: 'FaShoePrints',
    searchTerms: ['Shoe Prints', 'Schuhabdrücke', 'Spuren', 'Schuhe'],
  },
  {
    name: 'FaShopLock',
    searchTerms: ['Shop Lock', 'Laden', 'Schloss', 'Geschäft'],
  },
  {
    name: 'FaShopSlash',
    searchTerms: ['Shop Slash', 'Laden', 'Geschlossen', 'Geschäft'],
  },
  {
    name: 'FaShop',
    searchTerms: ['Shop', 'Laden', 'Geschäft', 'Einkaufen'],
  },
  {
    name: 'FaShower',
    searchTerms: ['Shower', 'Dusche', 'Baden', 'Wasser'],
  },
  {
    name: 'FaShrimp',
    searchTerms: ['Shrimp', 'Garnele', 'Meeresfrüchte', 'Essen'],
  },
  {
    name: 'FaShuffle',
    searchTerms: ['Shuffle', 'Mischen', 'Musik', 'Steuerung'],
  },
  {
    name: 'FaShuttleSpace',
    searchTerms: ['Shuttle Space', 'Raumfähre', 'Weltraum', 'Transport'],
  },
  {
    name: 'FaSignHanging',
    searchTerms: ['Sign Hanging', 'Hängendes Schild', 'Zeichen', 'Ankündigung'],
  },
  {
    name: 'FaSignal',
    searchTerms: ['Signal', 'Empfang', 'Netzwerk', 'Verbindung'],
  },
  {
    name: 'FaSignature',
    searchTerms: ['Signature', 'Unterschrift', 'Dokument', 'Signatur'],
  },
  {
    name: 'FaSignsPost',
    searchTerms: ['Signs Post', 'Wegweiser', 'Schilder', 'Richtung'],
  },
  {
    name: 'FaSimCard',
    searchTerms: ['Sim Card', 'SIM-Karte', 'Technologie', 'Handy'],
  },
  {
    name: 'FaSink',
    searchTerms: ['Sink', 'Spüle', 'Waschbecken', 'Küche'],
  },
  {
    name: 'FaSitemap',
    searchTerms: ['Sitemap', 'Seitenübersicht', 'Navigation', 'Website'],
  },
  {
    name: 'FaSkullCrossbones',
    searchTerms: ['Skull Crossbones', 'Totenkopf', 'Knochen', 'Gefahr'],
  },
  {
    name: 'FaSkull',
    searchTerms: ['Skull', 'Totenkopf', 'Knochen', 'Tod'],
  },
  {
    name: 'FaSlash',
    searchTerms: ['Slash', 'Schrägstrich', 'Trennen', 'Symbol'],
  },
  {
    name: 'FaSleigh',
    searchTerms: ['Sleigh', 'Schlitten', 'Winter', 'Transport'],
  },
  {
    name: 'FaSliders',
    searchTerms: ['Sliders', 'Schieberegler', 'Einstellungen', 'Steuerung'],
  },
  {
    name: 'FaSmog',
    searchTerms: ['Smog', 'Luftverschmutzung', 'Rauch', 'Umwelt'],
  },
  {
    name: 'FaSmoking',
    searchTerms: ['Smoking', 'Rauchen', 'Zigaretten', 'Tabak'],
  },
  {
    name: 'FaSnowflake',
    searchTerms: ['Snowflake', 'Schneeflocke', 'Winter', 'Eis'],
  },
  {
    name: 'FaSnowman',
    searchTerms: ['Snowman', 'Schneemann', 'Winter', 'Schnee'],
  },
  {
    name: 'FaSnowplow',
    searchTerms: ['Snowplow', 'Schneepflug', 'Winter', 'Räumen'],
  },
  {
    name: 'FaSoap',
    searchTerms: ['Soap', 'Seife', 'Reinigung', 'Hygiene'],
  },
  {
    name: 'FaSocks',
    searchTerms: ['Socks', 'Socken', 'Kleidung', 'Fußbekleidung'],
  },
  {
    name: 'FaSolarPanel',
    searchTerms: ['Solar Panel', 'Solarmodul', 'Energie', 'Technologie'],
  },
  {
    name: 'FaSortDown',
    searchTerms: [
      'Sort Down',
      'Absteigend sortieren',
      'Sortierung',
      'Richtung',
    ],
  },
  {
    name: 'FaSortUp',
    searchTerms: ['Sort Up', 'Aufsteigend sortieren', 'Sortierung', 'Richtung'],
  },
  {
    name: 'FaSort',
    searchTerms: ['Sort', 'Sortieren', 'Ordnen', 'Richtung'],
  },
  {
    name: 'FaSpa',
    searchTerms: ['Spa', 'Entspannung', 'Wellness', 'Wasser'],
  },
  {
    name: 'FaSpaghettiMonsterFlying',
    searchTerms: [
      'Spaghetti Monster Flying',
      'Fliegendes Spaghettimonster',
      'Religion',
      'Humor',
    ],
  },
  {
    name: 'FaSpellCheck',
    searchTerms: ['Spell Check', 'Rechtschreibprüfung', 'Text', 'Korrektur'],
  },
  {
    name: 'FaSpider',
    searchTerms: ['Spider', 'Spinne', 'Insekt', 'Natur'],
  },
  {
    name: 'FaSpinner',
    searchTerms: ['Spinner', 'Ladesymbol', 'Drehen', 'Warten'],
  },
  {
    name: 'FaSplotch',
    searchTerms: ['Splotch', 'Fleck', 'Form', 'Design'],
  },
  {
    name: 'FaSpoon',
    searchTerms: ['Spoon', 'Löffel', 'Besteck', 'Essen'],
  },
  {
    name: 'FaSprayCanSparkles',
    searchTerms: ['Spray Can Sparkles', 'Spraydose', 'Funkeln', 'Reinigung'],
  },
  {
    name: 'FaSprayCan',
    searchTerms: ['Spray Can', 'Spraydose', 'Farbe', 'Reinigung'],
  },
  {
    name: 'FaSquareArrowUpRight',
    searchTerms: ['Square Arrow Up Right', 'Pfeil', 'Quadrat', 'Richtung'],
  },
  {
    name: 'FaSquareCaretDown',
    searchTerms: [
      'Square Caret Down',
      'Pfeil nach unten',
      'Quadrat',
      'Navigation',
    ],
  },
  {
    name: 'FaSquareCaretLeft',
    searchTerms: [
      'Square Caret Left',
      'Pfeil nach links',
      'Quadrat',
      'Navigation',
    ],
  },
  {
    name: 'FaSquareCaretRight',
    searchTerms: [
      'Square Caret Right',
      'Pfeil nach rechts',
      'Quadrat',
      'Navigation',
    ],
  },
  {
    name: 'FaSquareCaretUp',
    searchTerms: [
      'Square Caret Up',
      'Pfeil nach oben',
      'Quadrat',
      'Navigation',
    ],
  },
  {
    name: 'FaSquareCheck',
    searchTerms: ['Square Check', 'Check', 'Quadrat', 'Bestätigung'],
  },
  {
    name: 'FaSquareEnvelope',
    searchTerms: ['Square Envelope', 'Briefumschlag', 'Nachricht', 'Quadrat'],
  },
  {
    name: 'FaSquareFull',
    searchTerms: ['Square Full', 'Volles Quadrat', 'Quadrat', 'Form'],
  },
  {
    name: 'FaSquareH',
    searchTerms: ['Square H', 'Krankenhaus', 'H', 'Quadrat'],
  },
  {
    name: 'FaSquareMinus',
    searchTerms: ['Square Minus', 'Minus', 'Quadrat', 'Entfernen'],
  },
  {
    name: 'FaSquareNfi',
    searchTerms: ['Square NFI', 'Quadrat', 'NFI', 'Symbol'],
  },
  {
    name: 'FaSquareParking',
    searchTerms: ['Square Parking', 'Parken', 'P', 'Quadrat'],
  },
  {
    name: 'FaSquarePen',
    searchTerms: ['Square Pen', 'Stift', 'Quadrat', 'Bearbeiten'],
  },
  {
    name: 'FaSquarePersonConfined',
    searchTerms: ['Square Person Confined', 'Person', 'Quadrat', 'Gefängnis'],
  },
  {
    name: 'FaSquarePhoneFlip',
    searchTerms: ['Square Phone Flip', 'Telefon', 'Quadrat', 'Technologie'],
  },
  {
    name: 'FaSquarePhone',
    searchTerms: ['Square Phone', 'Telefon', 'Quadrat', 'Technologie'],
  },
  {
    name: 'FaSquarePlus',
    searchTerms: ['Square Plus', 'Plus', 'Hinzufügen', 'Quadrat'],
  },
  {
    name: 'FaSquarePollHorizontal',
    searchTerms: ['Square Poll Horizontal', 'Umfrage', 'Horizontal', 'Quadrat'],
  },
  {
    name: 'FaSquarePollVertical',
    searchTerms: ['Square Poll Vertical', 'Umfrage', 'Vertikal', 'Quadrat'],
  },
  {
    name: 'FaSquareRootVariable',
    searchTerms: [
      'Square Root Variable',
      'Quadratwurzel',
      'Mathematik',
      'Formel',
    ],
  },
  {
    name: 'FaSquareRss',
    searchTerms: ['Square RSS', 'RSS', 'Quadrat', 'Feed'],
  },
  {
    name: 'FaSquareShareNodes',
    searchTerms: ['Square Share Nodes', 'Teilen', 'Quadrat', 'Netzwerk'],
  },
  {
    name: 'FaSquareUpRight',
    searchTerms: ['Square Up Right', 'Quadrat', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaSquareVirus',
    searchTerms: ['Square Virus', 'Virus', 'Quadrat', 'Gesundheit'],
  },
  {
    name: 'FaSquareXmark',
    searchTerms: ['Square Xmark', 'X', 'Fehler', 'Quadrat'],
  },
  {
    name: 'FaSquare',
    searchTerms: ['Square', 'Quadrat', 'Form', 'Geometrie'],
  },
  {
    name: 'FaStaffSnake',
    searchTerms: ['Staff Snake', 'Schlange', 'Stab', 'Medizin'],
  },
  {
    name: 'FaStairs',
    searchTerms: ['Stairs', 'Treppe', 'Gebäude', 'Aufstieg'],
  },
  {
    name: 'FaStamp',
    searchTerms: ['Stamp', 'Stempel', 'Dokument', 'Genehmigung'],
  },
  {
    name: 'FaStapler',
    searchTerms: ['Stapler', 'Tacker', 'Büro', 'Dokumente'],
  },
  {
    name: 'FaStarAndCrescent',
    searchTerms: [
      'Star And Crescent',
      'Stern und Halbmond',
      'Symbol',
      'Religion',
    ],
  },
  {
    name: 'FaStarHalfStroke',
    searchTerms: ['Star Half Stroke', 'Halber Stern', 'Bewertung', 'Symbol'],
  },
  {
    name: 'FaStarHalf',
    searchTerms: ['Star Half', 'Halber Stern', 'Bewertung', 'Symbol'],
  },
  {
    name: 'FaStarOfDavid',
    searchTerms: ['Star Of David', 'Davidstern', 'Judentum', 'Religion'],
  },
  {
    name: 'FaStarOfLife',
    searchTerms: ['Star Of Life', 'Stern des Lebens', 'Rettung', 'Medizin'],
  },
  {
    name: 'FaStar',
    searchTerms: ['Star', 'Stern', 'Symbol', 'Bewertung'],
  },
  {
    name: 'FaSterlingSign',
    searchTerms: ['Sterling Sign', 'Pfund Sterling', 'Währung', 'Geld'],
  },
  {
    name: 'FaStethoscope',
    searchTerms: ['Stethoscope', 'Stethoskop', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaStop',
    searchTerms: ['Stop', 'Anhalten', 'Multimedia', 'Kontrolle'],
  },
  {
    name: 'FaStopwatch20',
    searchTerms: ['Stopwatch 20', 'Stoppuhr', 'Zeit', 'Kontrolle'],
  },
  {
    name: 'FaStopwatch',
    searchTerms: ['Stopwatch', 'Stoppuhr', 'Zeit', 'Kontrolle'],
  },
  {
    name: 'FaStoreSlash',
    searchTerms: ['Store Slash', 'Laden geschlossen', 'Geschäft', 'Einkaufen'],
  },
  {
    name: 'FaStore',
    searchTerms: ['Store', 'Laden', 'Geschäft', 'Einkaufen'],
  },
  {
    name: 'FaStreetView',
    searchTerms: ['Street View', 'Straßenansicht', 'Karte', 'Navigation'],
  },
  {
    name: 'FaStrikethrough',
    searchTerms: ['Strikethrough', 'Durchgestrichen', 'Text', 'Formatierung'],
  },
  {
    name: 'FaStroopwafel',
    searchTerms: ['Stroopwafel', 'Keks', 'Süßigkeit', 'Essen'],
  },
  {
    name: 'FaSubscript',
    searchTerms: ['Subscript', 'Tiefgestellt', 'Text', 'Formatierung'],
  },
  {
    name: 'FaSuitcaseMedical',
    searchTerms: ['Suitcase Medical', 'Arztkoffer', 'Gesundheit', 'Medizin'],
  },
  {
    name: 'FaSuitcaseRolling',
    searchTerms: ['Suitcase Rolling', 'Rollkoffer', 'Reisen', 'Gepäck'],
  },
  {
    name: 'FaSuitcase',
    searchTerms: ['Suitcase', 'Koffer', 'Reise', 'Gepäck'],
  },
  {
    name: 'FaSunPlantWilt',
    searchTerms: ['Sun Plant Wilt', 'Sonne', 'Pflanze', 'Verwelken'],
  },
  {
    name: 'FaSun',
    searchTerms: ['Sun', 'Sonne', 'Wetter', 'Tag'],
  },
  {
    name: 'FaSuperscript',
    searchTerms: ['Superscript', 'Hochgestellt', 'Text', 'Formatierung'],
  },
  {
    name: 'FaSwatchbook',
    searchTerms: ['Swatchbook', 'Farbmusterbuch', 'Design', 'Farbe'],
  },
  {
    name: 'FaSynagogue',
    searchTerms: ['Synagogue', 'Synagoge', 'Judentum', 'Religion'],
  },
  {
    name: 'FaSyringe',
    searchTerms: ['Syringe', 'Spritze', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaT',
    searchTerms: ['T', 'Buchstabe T', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaTableCellsLarge',
    searchTerms: ['Table Cells Large', 'Tabelle', 'Große Zellen', 'Layout'],
  },
  {
    name: 'FaTableCells',
    searchTerms: ['Table Cells', 'Tabelle', 'Zellen', 'Layout'],
  },
  {
    name: 'FaTableColumns',
    searchTerms: ['Table Columns', 'Tabellenspalten', 'Layout', 'Daten'],
  },
  {
    name: 'FaTableList',
    searchTerms: ['Table List', 'Tabellenliste', 'Daten', 'Liste'],
  },
  {
    name: 'FaTableTennisPaddleBall',
    searchTerms: [
      'Table Tennis Paddle Ball',
      'Tischtennis',
      'Schläger',
      'Ball',
    ],
  },
  {
    name: 'FaTable',
    searchTerms: ['Table', 'Tabelle', 'Daten', 'Layout'],
  },
  {
    name: 'FaTabletButton',
    searchTerms: ['Tablet Button', 'Tablet', 'Technologie', 'Knopf'],
  },
  {
    name: 'FaTabletScreenButton',
    searchTerms: [
      'Tablet Screen Button',
      'Tablet',
      'Bildschirm',
      'Technologie',
    ],
  },
  {
    name: 'FaTablet',
    searchTerms: ['Tablet', 'Technologie', 'Mobilgerät', 'Bildschirm'],
  },
  {
    name: 'FaTablets',
    searchTerms: ['Tablets', 'Tabletten', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaTachographDigital',
    searchTerms: [
      'Tachograph Digital',
      'Digitaler Tachograph',
      'Fahrzeug',
      'Messung',
    ],
  },
  {
    name: 'FaTag',
    searchTerms: ['Tag', 'Etikett', 'Label', 'Preisschild'],
  },
  {
    name: 'FaTags',
    searchTerms: ['Tags', 'Etiketten', 'Labels', 'Preisschilder'],
  },
  {
    name: 'FaTape',
    searchTerms: ['Tape', 'Klebeband', 'Band', 'Werkzeug'],
  },
  {
    name: 'FaTarpDroplet',
    searchTerms: ['Tarp Droplet', 'Plane', 'Tropfen', 'Schutz'],
  },
  {
    name: 'FaTarp',
    searchTerms: ['Tarp', 'Plane', 'Abdeckung', 'Schutz'],
  },
  {
    name: 'FaTaxi',
    searchTerms: ['Taxi', 'Fahrzeug', 'Transport', 'Reise'],
  },
  {
    name: 'FaTeethOpen',
    searchTerms: ['Teeth Open', 'Offene Zähne', 'Mund', 'Zähne'],
  },
  {
    name: 'FaTeeth',
    searchTerms: ['Teeth', 'Zähne', 'Mund', 'Lächeln'],
  },
  {
    name: 'FaTemperatureArrowDown',
    searchTerms: ['Temperature Arrow Down', 'Temperatur', 'Abwärts', 'Pfeil'],
  },
  {
    name: 'FaTemperatureArrowUp',
    searchTerms: ['Temperature Arrow Up', 'Temperatur', 'Aufwärts', 'Pfeil'],
  },
  {
    name: 'FaTemperatureEmpty',
    searchTerms: [
      'Temperature Empty',
      'Leere Temperatur',
      'Thermometer',
      'Messung',
    ],
  },
  {
    name: 'FaTemperatureFull',
    searchTerms: [
      'Temperature Full',
      'Volle Temperatur',
      'Thermometer',
      'Messung',
    ],
  },
  {
    name: 'FaTemperatureHalf',
    searchTerms: [
      'Temperature Half',
      'Halbe Temperatur',
      'Thermometer',
      'Messung',
    ],
  },
  {
    name: 'FaTemperatureHigh',
    searchTerms: [
      'Temperature High',
      'Hohe Temperatur',
      'Wärme',
      'Thermometer',
    ],
  },
  {
    name: 'FaTemperatureLow',
    searchTerms: [
      'Temperature Low',
      'Niedrige Temperatur',
      'Kälte',
      'Thermometer',
    ],
  },
  {
    name: 'FaTemperatureQuarter',
    searchTerms: [
      'Temperature Quarter',
      'Viertel Temperatur',
      'Thermometer',
      'Messung',
    ],
  },
  {
    name: 'FaTemperatureThreeQuarters',
    searchTerms: [
      'Temperature Three Quarters',
      'Drei Viertel Temperatur',
      'Thermometer',
      'Messung',
    ],
  },
  {
    name: 'FaTengeSign',
    searchTerms: ['Tenge Sign', 'Tenge', 'Währung', 'Geld'],
  },
  {
    name: 'FaTentArrowDownToLine',
    searchTerms: ['Tent Arrow Down To Line', 'Zelt', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaTentArrowLeftRight',
    searchTerms: ['Tent Arrow Left Right', 'Zelt', 'Pfeile', 'Richtung'],
  },
  {
    name: 'FaTentArrowTurnLeft',
    searchTerms: [
      'Tent Arrow Turn Left',
      'Zelt',
      'Pfeil nach links',
      'Richtung',
    ],
  },
  {
    name: 'FaTentArrowsDown',
    searchTerms: ['Tent Arrows Down', 'Zelt', 'Pfeile nach unten', 'Richtung'],
  },
  {
    name: 'FaTent',
    searchTerms: ['Tent', 'Zelt', 'Camping', 'Natur'],
  },
  {
    name: 'FaTents',
    searchTerms: ['Tents', 'Zelte', 'Camping', 'Natur'],
  },
  {
    name: 'FaTerminal',
    searchTerms: ['Terminal', 'Kommandozeile', 'Technologie', 'Computer'],
  },
  {
    name: 'FaTextHeight',
    searchTerms: ['Text Height', 'Texthöhe', 'Formatierung', 'Schriftgröße'],
  },
  {
    name: 'FaTextSlash',
    searchTerms: [
      'Text Slash',
      'Durchgestrichener Text',
      'Text',
      'Formatierung',
    ],
  },
  {
    name: 'FaTextWidth',
    searchTerms: ['Text Width', 'Textbreite', 'Formatierung', 'Schriftgröße'],
  },
  {
    name: 'FaThermometer',
    searchTerms: ['Thermometer', 'Temperatur', 'Messung', 'Gesundheit'],
  },
  {
    name: 'FaThumbsDown',
    searchTerms: ['Thumbs Down', 'Daumen runter', 'Ablehnung', 'Symbol'],
  },
  {
    name: 'FaThumbsUp',
    searchTerms: ['Thumbs Up', 'Daumen hoch', 'Zustimmung', 'Symbol'],
  },
  {
    name: 'FaThumbtack',
    searchTerms: ['Thumbtack', 'Reißzwecke', 'Pin', 'Anheften'],
  },
  {
    name: 'FaTicketSimple',
    searchTerms: ['Ticket Simple', 'Ticket', 'Eintrittskarte', 'Event'],
  },
  {
    name: 'FaTicket',
    searchTerms: ['Ticket', 'Eintrittskarte', 'Event', 'Zugang'],
  },
  {
    name: 'FaTimeline',
    searchTerms: ['Timeline', 'Zeitachse', 'Verlauf', 'Historie'],
  },
  {
    name: 'FaToggleOff',
    searchTerms: ['Toggle Off', 'Schalter aus', 'Aus', 'Schalter'],
  },
  {
    name: 'FaToggleOn',
    searchTerms: ['Toggle On', 'Schalter ein', 'An', 'Schalter'],
  },
  {
    name: 'FaToiletPaperSlash',
    searchTerms: [
      'Toilet Paper Slash',
      'Toilettenpapier',
      'Durchgestrichen',
      'Hygiene',
    ],
  },
  {
    name: 'FaToiletPaper',
    searchTerms: ['Toilet Paper', 'Toilettenpapier', 'Hygiene', 'Papier'],
  },
  {
    name: 'FaToiletPortable',
    searchTerms: ['Toilet Portable', 'Tragbare Toilette', 'Sanitär', 'Hygiene'],
  },
  {
    name: 'FaToilet',
    searchTerms: ['Toilet', 'Toilette', 'Sanitär', 'Bad'],
  },
  {
    name: 'FaToiletsPortable',
    searchTerms: [
      'Toilets Portable',
      'Tragbare Toiletten',
      'Sanitär',
      'Hygiene',
    ],
  },
  {
    name: 'FaToolbox',
    searchTerms: ['Toolbox', 'Werkzeugkasten', 'Werkzeuge', 'Handwerk'],
  },
  {
    name: 'FaTooth',
    searchTerms: ['Tooth', 'Zahn', 'Mund', 'Zähne'],
  },
  {
    name: 'FaToriiGate',
    searchTerms: ['Torii Gate', 'Tor', 'Japan', 'Schrein'],
  },
  {
    name: 'FaTornado',
    searchTerms: ['Tornado', 'Wirbelsturm', 'Sturm', 'Naturkatastrophe'],
  },
  {
    name: 'FaTowerBroadcast',
    searchTerms: ['Tower Broadcast', 'Sendeturm', 'Funk', 'Kommunikation'],
  },
  {
    name: 'FaTowerCell',
    searchTerms: ['Tower Cell', 'Mobilfunkmast', 'Mobilnetz', 'Kommunikation'],
  },
  {
    name: 'FaTowerObservation',
    searchTerms: ['Tower Observation', 'Aussichtsturm', 'Beobachtung', 'Turm'],
  },
  {
    name: 'FaTractor',
    searchTerms: ['Tractor', 'Traktor', 'Landwirtschaft', 'Fahrzeug'],
  },
  {
    name: 'FaTrademark',
    searchTerms: ['Trademark', 'Markenzeichen', 'Recht', 'Schutz'],
  },
  {
    name: 'FaTrafficLight',
    searchTerms: ['Traffic Light', 'Ampel', 'Verkehr', 'Signal'],
  },
  {
    name: 'FaTrailer',
    searchTerms: ['Trailer', 'Anhänger', 'Transport', 'Fahrzeug'],
  },
  {
    name: 'FaTrainSubway',
    searchTerms: ['Train Subway', 'U-Bahn', 'Zug', 'Transport'],
  },
  {
    name: 'FaTrainTram',
    searchTerms: ['Train Tram', 'Straßenbahn', 'Zug', 'Transport'],
  },
  {
    name: 'FaTrain',
    searchTerms: ['Train', 'Zug', 'Transport', 'Fahrzeug'],
  },
  {
    name: 'FaTransgender',
    searchTerms: ['Transgender', 'Geschlechtsidentität', 'Symbol', 'Vielfalt'],
  },
  {
    name: 'FaTrashArrowUp',
    searchTerms: [
      'Trash Arrow Up',
      'Müll',
      'Pfeil nach oben',
      'Wiederherstellen',
    ],
  },
  {
    name: 'FaTrashCanArrowUp',
    searchTerms: [
      'Trash Can Arrow Up',
      'Mülleimer',
      'Pfeil nach oben',
      'Wiederherstellen',
    ],
  },
  {
    name: 'FaTrashCan',
    searchTerms: ['Trash Can', 'Mülleimer', 'Abfall', 'Müll'],
  },
  {
    name: 'FaTrash',
    searchTerms: ['Trash', 'Müll', 'Abfall', 'Entsorgen'],
  },
  {
    name: 'FaTreeCity',
    searchTerms: ['Tree City', 'Baum', 'Stadt', 'Umwelt'],
  },
  {
    name: 'FaTree',
    searchTerms: ['Tree', 'Baum', 'Natur', 'Pflanze'],
  },
  {
    name: 'FaTriangleExclamation',
    searchTerms: ['Triangle Exclamation', 'Dreieck', 'Warnung', 'Achtung'],
  },
  {
    name: 'FaTrophy',
    searchTerms: ['Trophy', 'Pokal', 'Gewinner', 'Sport'],
  },
  {
    name: 'FaTrowelBricks',
    searchTerms: ['Trowel Bricks', 'Kelle', 'Ziegel', 'Bau'],
  },
  {
    name: 'FaTrowel',
    searchTerms: ['Trowel', 'Kelle', 'Werkzeug', 'Bau'],
  },
  {
    name: 'FaTruckArrowRight',
    searchTerms: ['Truck Arrow Right', 'LKW', 'Pfeil', 'Transport'],
  },
  {
    name: 'FaTruckDroplet',
    searchTerms: ['Truck Droplet', 'LKW', 'Tropfen', 'Transport'],
  },
  {
    name: 'FaTruckFast',
    searchTerms: ['Truck Fast', 'Schneller LKW', 'Transport', 'Fahrzeug'],
  },
  {
    name: 'FaTruckFieldUn',
    searchTerms: ['Truck Field UN', 'UN', 'LKW', 'Feld'],
  },
  {
    name: 'FaTruckField',
    searchTerms: ['Truck Field', 'Feld', 'LKW', 'Landwirtschaft'],
  },
  {
    name: 'FaTruckFront',
    searchTerms: ['Truck Front', 'LKW', 'Transport', 'Fahrzeug'],
  },
  {
    name: 'FaTruckMedical',
    searchTerms: ['Truck Medical', 'Krankenwagen', 'Medizin', 'LKW'],
  },
  {
    name: 'FaTruckMonster',
    searchTerms: ['Truck Monster', 'Monster Truck', 'Fahrzeug', 'Rennen'],
  },
  {
    name: 'FaTruckMoving',
    searchTerms: ['Truck Moving', 'Umzugswagen', 'Transport', 'Fahrzeug'],
  },
  {
    name: 'FaTruckPickup',
    searchTerms: ['Truck Pickup', 'Pickup', 'Transport', 'Fahrzeug'],
  },
  {
    name: 'FaTruckPlane',
    searchTerms: ['Truck Plane', 'LKW', 'Flugzeug', 'Transport'],
  },
  {
    name: 'FaTruckRampBox',
    searchTerms: ['Truck Ramp Box', 'LKW', 'Rampe', 'Box'],
  },
  {
    name: 'FaTruck',
    searchTerms: ['Truck', 'LKW', 'Transport', 'Fahrzeug'],
  },
  {
    name: 'FaTty',
    searchTerms: ['TTY', 'Texttelefon', 'Kommunikation', 'Technologie'],
  },
  {
    name: 'FaTurkishLiraSign',
    searchTerms: ['Turkish Lira Sign', 'Türkische Lira', 'Währung', 'Geld'],
  },
  {
    name: 'FaTurnDown',
    searchTerms: ['Turn Down', 'Abwärts', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaTurnUp',
    searchTerms: ['Turn Up', 'Aufwärts', 'Pfeil', 'Richtung'],
  },
  {
    name: 'FaTv',
    searchTerms: ['TV', 'Fernseher', 'Medien', 'Technologie'],
  },
  {
    name: 'FaU',
    searchTerms: ['U', 'Buchstabe U', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaUmbrellaBeach',
    searchTerms: ['Umbrella Beach', 'Strandschirm', 'Urlaub', 'Strand'],
  },
  {
    name: 'FaUmbrella',
    searchTerms: ['Umbrella', 'Regenschirm', 'Schutz', 'Wetter'],
  },
  {
    name: 'FaUnderline',
    searchTerms: ['Underline', 'Unterstreichen', 'Text', 'Formatierung'],
  },
  {
    name: 'FaUniversalAccess',
    searchTerms: [
      'Universal Access',
      'Zugänglichkeit',
      'Barrierefreiheit',
      'Symbol',
    ],
  },
  {
    name: 'FaUnlockKeyhole',
    searchTerms: ['Unlock Keyhole', 'Schloss auf', 'Sicherheit', 'Schlüssel'],
  },
  {
    name: 'FaUnlock',
    searchTerms: ['Unlock', 'Entsperren', 'Schloss', 'Sicherheit'],
  },
  {
    name: 'FaUpDownLeftRight',
    searchTerms: ['Up Down Left Right', 'Pfeile', 'Richtungen', 'Bewegung'],
  },
  {
    name: 'FaUpDown',
    searchTerms: ['Up Down', 'Auf und ab', 'Pfeile', 'Bewegung'],
  },
  {
    name: 'FaUpLong',
    searchTerms: ['Up Long', 'Pfeil nach oben', 'Richtung', 'Bewegung'],
  },
  {
    name: 'FaUpRightAndDownLeftFromCenter',
    searchTerms: [
      'Up Right And Down Left From Center',
      'Zentrum',
      'Pfeile',
      'Richtung',
    ],
  },
  {
    name: 'FaUpRightFromSquare',
    searchTerms: [
      'Up Right From Square',
      'Nach rechts oben',
      'Pfeil',
      'Quadrat',
    ],
  },
  {
    name: 'FaUpload',
    searchTerms: ['Upload', 'Hochladen', 'Dateien', 'Technologie'],
  },
  {
    name: 'FaUserAstronaut',
    searchTerms: ['User Astronaut', 'Benutzer', 'Astronaut', 'Weltraum'],
  },
  {
    name: 'FaUserCheck',
    searchTerms: ['User Check', 'Benutzer', 'Bestätigung', 'Check'],
  },
  {
    name: 'FaUserClock',
    searchTerms: ['User Clock', 'Benutzer', 'Uhr', 'Zeit'],
  },
  {
    name: 'FaUserDoctor',
    searchTerms: ['User Doctor', 'Benutzer', 'Arzt', 'Gesundheit'],
  },
  {
    name: 'FaUserGear',
    searchTerms: ['User Gear', 'Benutzer', 'Ausrüstung', 'Einstellungen'],
  },
  {
    name: 'FaUserGraduate',
    searchTerms: ['User Graduate', 'Benutzer', 'Absolvent', 'Bildung'],
  },
  {
    name: 'FaUserGroup',
    searchTerms: ['User Group', 'Benutzergruppe', 'Gruppe', 'Menschen'],
  },
  {
    name: 'FaUserInjured',
    searchTerms: ['User Injured', 'Benutzer', 'Verletzt', 'Gesundheit'],
  },
  {
    name: 'FaUserLargeSlash',
    searchTerms: ['User Large Slash', 'Benutzer', 'Groß', 'Durchgestrichen'],
  },
  {
    name: 'FaUserLarge',
    searchTerms: ['User Large', 'Großer Benutzer', 'Person', 'Benutzer'],
  },
  {
    name: 'FaUserLock',
    searchTerms: ['User Lock', 'Benutzer', 'Schloss', 'Sicherheit'],
  },
  {
    name: 'FaUserMinus',
    searchTerms: ['User Minus', 'Benutzer entfernen', 'Person', 'Entfernen'],
  },
  {
    name: 'FaUserNinja',
    searchTerms: ['User Ninja', 'Benutzer', 'Ninja', 'Geheimnis'],
  },
  {
    name: 'FaUserNurse',
    searchTerms: ['User Nurse', 'Benutzer', 'Krankenschwester', 'Gesundheit'],
  },
  {
    name: 'FaUserPen',
    searchTerms: ['User Pen', 'Benutzer', 'Stift', 'Schreiben'],
  },
  {
    name: 'FaUserPlus',
    searchTerms: ['User Plus', 'Benutzer hinzufügen', 'Person', 'Hinzufügen'],
  },
  {
    name: 'FaUserSecret',
    searchTerms: ['User Secret', 'Geheimer Benutzer', 'Person', 'Sicherheit'],
  },
  {
    name: 'FaUserShield',
    searchTerms: ['User Shield', 'Benutzer', 'Schild', 'Sicherheit'],
  },
  {
    name: 'FaUserSlash',
    searchTerms: [
      'User Slash',
      'Benutzer durchgestrichen',
      'Person',
      'Entfernen',
    ],
  },
  {
    name: 'FaUserTag',
    searchTerms: ['User Tag', 'Benutzer', 'Tag', 'Kennzeichnung'],
  },
  {
    name: 'FaUserTie',
    searchTerms: ['User Tie', 'Benutzer', 'Krawatte', 'Person'],
  },
  {
    name: 'FaUserXmark',
    searchTerms: ['User Xmark', 'Benutzer löschen', 'Person', 'Fehler'],
  },
  {
    name: 'FaUser',
    searchTerms: ['User', 'Benutzer', 'Person', 'Account'],
  },
  {
    name: 'FaUsersBetweenLines',
    searchTerms: ['Users Between Lines', 'Benutzer', 'Linien', 'Gruppe'],
  },
  {
    name: 'FaUsersGear',
    searchTerms: ['Users Gear', 'Benutzer', 'Ausrüstung', 'Einstellungen'],
  },
  {
    name: 'FaUsersLine',
    searchTerms: ['Users Line', 'Benutzer', 'Linie', 'Gruppe'],
  },
  {
    name: 'FaUsersRays',
    searchTerms: ['Users Rays', 'Benutzer', 'Strahlen', 'Gemeinschaft'],
  },
  {
    name: 'FaUsersRectangle',
    searchTerms: ['Users Rectangle', 'Benutzer', 'Rechteck', 'Gruppe'],
  },
  {
    name: 'FaUsersSlash',
    searchTerms: ['Users Slash', 'Benutzer', 'Durchgestrichen', 'Gruppe'],
  },
  {
    name: 'FaUsersViewfinder',
    searchTerms: ['Users Viewfinder', 'Benutzer', 'Sucher', 'Gruppe'],
  },
  {
    name: 'FaUsers',
    searchTerms: ['Users', 'Benutzer', 'Gruppe', 'Gemeinschaft'],
  },
  {
    name: 'FaUtensils',
    searchTerms: ['Utensils', 'Besteck', 'Essen', 'Gabel'],
  },
  {
    name: 'FaV',
    searchTerms: ['V', 'Buchstabe V', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaVanShuttle',
    searchTerms: ['Van Shuttle', 'Transporter', 'Shuttle', 'Fahrzeug'],
  },
  {
    name: 'FaVault',
    searchTerms: ['Vault', 'Tresor', 'Sicherheit', 'Lagerung'],
  },
  {
    name: 'FaVectorSquare',
    searchTerms: ['Vector Square', 'Vektor', 'Quadrat', 'Geometrie'],
  },
  {
    name: 'FaVenusDouble',
    searchTerms: ['Venus Double', 'Venus', 'Weiblich', 'Symbol'],
  },
  {
    name: 'FaVenusMars',
    searchTerms: ['Venus Mars', 'Venus und Mars', 'Geschlecht', 'Symbol'],
  },
  {
    name: 'FaVenus',
    searchTerms: ['Venus', 'Weiblich', 'Symbol', 'Geschlecht'],
  },
  {
    name: 'FaVestPatches',
    searchTerms: ['Vest Patches', 'Weste', 'Flicken', 'Kleidung'],
  },
  {
    name: 'FaVest',
    searchTerms: ['Vest', 'Weste', 'Kleidung', 'Mode'],
  },
  {
    name: 'FaVialCircleCheck',
    searchTerms: ['Vial Circle Check', 'Phiole', 'Kreis', 'Check'],
  },
  {
    name: 'FaVialVirus',
    searchTerms: ['Vial Virus', 'Phiole', 'Virus', 'Medizin'],
  },
  {
    name: 'FaVial',
    searchTerms: ['Vial', 'Phiole', 'Medizin', 'Labor'],
  },
  {
    name: 'FaVials',
    searchTerms: ['Vials', 'Phiolen', 'Medizin', 'Labor'],
  },
  {
    name: 'FaVideoSlash',
    searchTerms: ['Video Slash', 'Video', 'Durchgestrichen', 'Medien'],
  },
  {
    name: 'FaVideo',
    searchTerms: ['Video', 'Medien', 'Film', 'Aufnahme'],
  },
  {
    name: 'FaVihara',
    searchTerms: ['Vihara', 'Kloster', 'Tempel', 'Religion'],
  },
  {
    name: 'FaVirusCovidSlash',
    searchTerms: ['Virus Covid Slash', 'Virus', 'Covid', 'Durchgestrichen'],
  },
  {
    name: 'FaVirusCovid',
    searchTerms: ['Virus Covid', 'Virus', 'Covid', 'Gesundheit'],
  },
  {
    name: 'FaVirusSlash',
    searchTerms: ['Virus Slash', 'Virus', 'Durchgestrichen', 'Gesundheit'],
  },
  {
    name: 'FaVirus',
    searchTerms: ['Virus', 'Erreger', 'Gesundheit', 'Medizin'],
  },
  {
    name: 'FaViruses',
    searchTerms: ['Viruses', 'Viren', 'Gesundheit', 'Medizin'],
  },
  {
    name: 'FaVoicemail',
    searchTerms: [
      'Voicemail',
      'Anrufbeantworter',
      'Nachricht',
      'Kommunikation',
    ],
  },
  {
    name: 'FaVolcano',
    searchTerms: ['Volcano', 'Vulkan', 'Naturkatastrophe', 'Lava'],
  },
  {
    name: 'FaVolleyball',
    searchTerms: ['Volleyball', 'Sport', 'Ball', 'Spiel'],
  },
  {
    name: 'FaVolumeHigh',
    searchTerms: ['Volume High', 'Lautstärke hoch', 'Audio', 'Laut'],
  },
  {
    name: 'FaVolumeLow',
    searchTerms: ['Volume Low', 'Lautstärke niedrig', 'Audio', 'Leise'],
  },
  {
    name: 'FaVolumeOff',
    searchTerms: ['Volume Off', 'Lautstärke aus', 'Audio', 'Stummschalten'],
  },
  {
    name: 'FaVolumeXmark',
    searchTerms: ['Volume Xmark', 'Lautstärke', 'X', 'Stumm'],
  },
  {
    name: 'FaVrCardboard',
    searchTerms: [
      'VR Cardboard',
      'Virtuelle Realität',
      'Technologie',
      'Karton',
    ],
  },
  {
    name: 'FaW',
    searchTerms: ['W', 'Buchstabe W', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaWalkieTalkie',
    searchTerms: ['Walkie Talkie', 'Funkgerät', 'Kommunikation', 'Gerät'],
  },
  {
    name: 'FaWallet',
    searchTerms: ['Wallet', 'Geldbörse', 'Portemonnaie', 'Geld'],
  },
  {
    name: 'FaWandMagicSparkles',
    searchTerms: ['Wand Magic Sparkles', 'Zauberstab', 'Magie', 'Funkeln'],
  },
  {
    name: 'FaWandMagic',
    searchTerms: ['Wand Magic', 'Zauberstab', 'Magie', 'Zaubern'],
  },
  {
    name: 'FaWandSparkles',
    searchTerms: ['Wand Sparkles', 'Zauberstab', 'Funkeln', 'Magie'],
  },
  {
    name: 'FaWarehouse',
    searchTerms: ['Warehouse', 'Lagerhaus', 'Gebäude', 'Lagerung'],
  },
  {
    name: 'FaWaterLadder',
    searchTerms: ['Water Ladder', 'Wasserleiter', 'Schwimmen', 'Leiter'],
  },
  {
    name: 'FaWater',
    searchTerms: ['Water', 'Wasser', 'Flüssigkeit', 'Natur'],
  },
  {
    name: 'FaWaveSquare',
    searchTerms: ['Wave Square', 'Wellenquadrat', 'Signal', 'Geometrie'],
  },
  {
    name: 'FaWeightHanging',
    searchTerms: ['Weight Hanging', 'Hängendes Gewicht', 'Gewicht', 'Kraft'],
  },
  {
    name: 'FaWeightScale',
    searchTerms: ['Weight Scale', 'Waage', 'Gewicht', 'Messung'],
  },
  {
    name: 'FaWheatAwnCircleExclamation',
    searchTerms: [
      'Wheat Awn Circle Exclamation',
      'Weizen',
      'Kreis',
      'Ausrufezeichen',
    ],
  },
  {
    name: 'FaWheatAwn',
    searchTerms: ['Wheat Awn', 'Weizen', 'Pflanze', 'Ernte'],
  },
  {
    name: 'FaWheelchairMove',
    searchTerms: ['Wheelchair Move', 'Rollstuhl', 'Bewegung', 'Mobilität'],
  },
  {
    name: 'FaWheelchair',
    searchTerms: ['Wheelchair', 'Rollstuhl', 'Mobilität', 'Gesundheit'],
  },
  {
    name: 'FaWhiskeyGlass',
    searchTerms: ['Whiskey Glass', 'Whiskeyglas', 'Getränk', 'Alkohol'],
  },
  {
    name: 'FaWifi',
    searchTerms: ['Wifi', 'Drahtlos', 'Internet', 'Signal'],
  },
  {
    name: 'FaWind',
    searchTerms: ['Wind', 'Luft', 'Wetter', 'Natur'],
  },
  {
    name: 'FaWindowMaximize',
    searchTerms: [
      'Window Maximize',
      'Fenster maximieren',
      'Anzeige',
      'Computer',
    ],
  },
  {
    name: 'FaWindowMinimize',
    searchTerms: [
      'Window Minimize',
      'Fenster minimieren',
      'Anzeige',
      'Computer',
    ],
  },
  {
    name: 'FaWindowRestore',
    searchTerms: [
      'Window Restore',
      'Fenster wiederherstellen',
      'Anzeige',
      'Computer',
    ],
  },
  {
    name: 'FaWineBottle',
    searchTerms: ['Wine Bottle', 'Weinflasche', 'Getränk', 'Alkohol'],
  },
  {
    name: 'FaWineGlassEmpty',
    searchTerms: ['Wine Glass Empty', 'Leeres Weinglas', 'Glas', 'Getränk'],
  },
  {
    name: 'FaWineGlass',
    searchTerms: ['Wine Glass', 'Weinglas', 'Getränk', 'Alkohol'],
  },
  {
    name: 'FaWonSign',
    searchTerms: ['Won Sign', 'Won', 'Währung', 'Geld'],
  },
  {
    name: 'FaWorm',
    searchTerms: ['Worm', 'Wurm', 'Tier', 'Natur'],
  },
  {
    name: 'FaWrench',
    searchTerms: ['Wrench', 'Schraubenschlüssel', 'Werkzeug', 'Handwerk'],
  },
  {
    name: 'FaXRay',
    searchTerms: ['X Ray', 'Röntgen', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaX',
    searchTerms: ['X', 'X', 'Symbol', 'Fehler'],
  },
  {
    name: 'FaXmark',
    searchTerms: ['Xmark', 'X', 'Symbol', 'Fehler'],
  },
  {
    name: 'FaXmarksLines',
    searchTerms: ['Xmarks Lines', 'X', 'Linien', 'Symbol'],
  },
  {
    name: 'FaY',
    searchTerms: ['Y', 'Buchstabe Y', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaYenSign',
    searchTerms: ['Yen Sign', 'Yen', 'Währung', 'Geld'],
  },
  {
    name: 'FaYinYang',
    searchTerms: ['Yin Yang', 'Yin und Yang', 'Balance', 'Symbol'],
  },
  {
    name: 'FaZ',
    searchTerms: ['Z', 'Buchstabe Z', 'Alphabet', 'Buchstabe'],
  },
  {
    name: 'FaRegAddressBook',
    searchTerms: ['Address Book', 'Adressbuch', 'Kontakte', 'Buch'],
  },
  {
    name: 'FaRegAddressCard',
    searchTerms: ['Address Card', 'Adresskarte', 'Kontakt', 'Visitenkarte'],
  },
  {
    name: 'FaRegBellSlash',
    searchTerms: [
      'Bell Slash',
      'Glocke',
      'Durchgestrichen',
      'Benachrichtigung',
    ],
  },
  {
    name: 'FaRegBell',
    searchTerms: ['Bell', 'Glocke', 'Benachrichtigung', 'Alarm'],
  },
  {
    name: 'FaRegBookmark',
    searchTerms: ['Bookmark', 'Lesezeichen', 'Speichern', 'Markieren'],
  },
  {
    name: 'FaRegBuilding',
    searchTerms: ['Building', 'Gebäude', 'Haus', 'Stadt'],
  },
  {
    name: 'FaRegCalendarCheck',
    searchTerms: ['Calendar Check', 'Kalender', 'Check', 'Datum'],
  },
  {
    name: 'FaRegCalendarDays',
    searchTerms: ['Calendar Days', 'Kalender', 'Tage', 'Datum'],
  },
  {
    name: 'FaRegCalendarMinus',
    searchTerms: ['Calendar Minus', 'Kalender', 'Minus', 'Datum'],
  },
  {
    name: 'FaRegCalendarPlus',
    searchTerms: ['Calendar Plus', 'Kalender', 'Plus', 'Datum'],
  },
  {
    name: 'FaRegCalendarXmark',
    searchTerms: ['Calendar Xmark', 'Kalender', 'X', 'Fehler'],
  },
  {
    name: 'FaRegCalendar',
    searchTerms: ['Calendar', 'Kalender', 'Datum', 'Zeit'],
  },
  {
    name: 'FaRegChartBar',
    searchTerms: ['Chart Bar', 'Balkendiagramm', 'Diagramm', 'Daten'],
  },
  {
    name: 'FaRegChessBishop',
    searchTerms: ['Chess Bishop', 'Schach', 'Läufer', 'Spiel'],
  },
  {
    name: 'FaRegChessKing',
    searchTerms: ['Chess King', 'Schach', 'König', 'Spiel'],
  },
  {
    name: 'FaRegChessKnight',
    searchTerms: ['Chess Knight', 'Schach', 'Springer', 'Spiel'],
  },
  {
    name: 'FaRegChessPawn',
    searchTerms: ['Chess Pawn', 'Schach', 'Bauer', 'Spiel'],
  },
  {
    name: 'FaRegChessQueen',
    searchTerms: ['Chess Queen', 'Schach', 'Dame', 'Spiel'],
  },
  {
    name: 'FaRegChessRook',
    searchTerms: ['Chess Rook', 'Schach', 'Turm', 'Spiel'],
  },
  {
    name: 'FaRegCircleCheck',
    searchTerms: ['Circle Check', 'Kreis', 'Check', 'Bestätigung'],
  },
  {
    name: 'FaRegCircleDot',
    searchTerms: ['Circle Dot', 'Kreis', 'Punkt', 'Symbol'],
  },
  {
    name: 'FaRegCircleDown',
    searchTerms: ['Circle Down', 'Kreis', 'Pfeil nach unten', 'Richtung'],
  },
  {
    name: 'FaRegCircleLeft',
    searchTerms: ['Circle Left', 'Kreis', 'Pfeil nach links', 'Richtung'],
  },
  {
    name: 'FaRegCirclePause',
    searchTerms: ['Circle Pause', 'Kreis', 'Pause', 'Medien'],
  },
  {
    name: 'FaRegCirclePlay',
    searchTerms: ['Circle Play', 'Kreis', 'Abspielen', 'Medien'],
  },
  {
    name: 'FaRegCircleQuestion',
    searchTerms: ['Circle Question', 'Kreis', 'Fragezeichen', 'Hilfe'],
  },
  {
    name: 'FaRegCircleRight',
    searchTerms: ['Circle Right', 'Kreis', 'Pfeil nach rechts', 'Richtung'],
  },
  {
    name: 'FaRegCircleStop',
    searchTerms: ['Circle Stop', 'Kreis', 'Stopp', 'Medien'],
  },
  {
    name: 'FaRegCircleUp',
    searchTerms: ['Circle Up', 'Kreis', 'Pfeil nach oben', 'Richtung'],
  },
  {
    name: 'FaRegCircleUser',
    searchTerms: ['Circle User', 'Kreis', 'Benutzer', 'Person'],
  },
  {
    name: 'FaRegCircleXmark',
    searchTerms: ['Circle Xmark', 'Kreis', 'X', 'Fehler'],
  },
  {
    name: 'FaRegCircle',
    searchTerms: ['Circle', 'Kreis', 'Form', 'Geometrie'],
  },
  {
    name: 'FaRegClipboard',
    searchTerms: ['Clipboard', 'Zwischenablage', 'Dokument', 'Notizen'],
  },
  {
    name: 'FaRegClock',
    searchTerms: ['Clock', 'Uhr', 'Zeit', 'Wecker'],
  },
  {
    name: 'FaRegClone',
    searchTerms: ['Clone', 'Klonen', 'Duplizieren', 'Kopie'],
  },
  {
    name: 'FaRegClosedCaptioning',
    searchTerms: ['Closed Captioning', 'Untertitel', 'Medien', 'Text'],
  },
  {
    name: 'FaRegCommentDots',
    searchTerms: ['Comment Dots', 'Kommentar', 'Punkte', 'Nachricht'],
  },
  {
    name: 'FaRegComment',
    searchTerms: ['Comment', 'Kommentar', 'Nachricht', 'Sprechen'],
  },
  {
    name: 'FaRegComments',
    searchTerms: ['Comments', 'Kommentare', 'Nachrichten', 'Sprechen'],
  },
  {
    name: 'FaRegCompass',
    searchTerms: ['Compass', 'Kompass', 'Richtung', 'Navigation'],
  },
  {
    name: 'FaRegCopy',
    searchTerms: ['Copy', 'Kopie', 'Duplikat', 'Dokument'],
  },
  {
    name: 'FaRegCopyright',
    searchTerms: ['Copyright', 'Urheberrecht', 'Recht', 'Schutz'],
  },
  {
    name: 'FaRegCreditCard',
    searchTerms: ['Credit Card', 'Kreditkarte', 'Bezahlung', 'Geld'],
  },
  {
    name: 'FaRegEnvelopeOpen',
    searchTerms: [
      'Envelope Open',
      'Geöffneter Umschlag',
      'Nachricht',
      'E-Mail',
    ],
  },
  {
    name: 'FaRegEnvelope',
    searchTerms: ['Envelope', 'Umschlag', 'Nachricht', 'E-Mail'],
  },
  {
    name: 'FaRegEyeSlash',
    searchTerms: ['Eye Slash', 'Auge', 'Durchgestrichen', 'Verbergen'],
  },
  {
    name: 'FaRegEye',
    searchTerms: ['Eye', 'Auge', 'Sehen', 'Betrachten'],
  },
  {
    name: 'FaRegFaceAngry',
    searchTerms: ['Face Angry', 'Wütendes Gesicht', 'Emotion', 'Wut'],
  },
  {
    name: 'FaRegFaceDizzy',
    searchTerms: ['Face Dizzy', 'Schwindliges Gesicht', 'Emotion', 'Schwindel'],
  },
  {
    name: 'FaRegFaceFlushed',
    searchTerms: [
      'Face Flushed',
      'Errötetes Gesicht',
      'Emotion',
      'Verlegenheit',
    ],
  },
  {
    name: 'FaRegFaceFrownOpen',
    searchTerms: ['Face Frown Open', 'Stirnrunzeln offen', 'Emotion', 'Trauer'],
  },
  {
    name: 'FaRegFaceFrown',
    searchTerms: ['Face Frown', 'Stirnrunzeln', 'Emotion', 'Trauer'],
  },
  {
    name: 'FaRegFaceGrimace',
    searchTerms: ['Face Grimace', 'Gesicht Grimasse', 'Emotion', 'Unbehagen'],
  },
  {
    name: 'FaRegFaceGrinBeamSweat',
    searchTerms: [
      'Face Grin Beam Sweat',
      'Schwitzendes Grinsen',
      'Emotion',
      'Lachen',
    ],
  },
  {
    name: 'FaRegFaceGrinBeam',
    searchTerms: ['Face Grin Beam', 'Breites Grinsen', 'Emotion', 'Glück'],
  },
  {
    name: 'FaRegFaceGrinHearts',
    searchTerms: ['Face Grin Hearts', 'Herzhaftes Grinsen', 'Emotion', 'Liebe'],
  },
  {
    name: 'FaRegFaceGrinSquintTears',
    searchTerms: [
      'Face Grin Squint Tears',
      'Grinsen mit Tränen',
      'Emotion',
      'Lachen',
    ],
  },
  {
    name: 'FaRegFaceGrinSquint',
    searchTerms: [
      'Face Grin Squint',
      'Zusammengekniffenes Grinsen',
      'Emotion',
      'Lachen',
    ],
  },
  {
    name: 'FaRegFaceGrinStars',
    searchTerms: ['Face Grin Stars', 'Grinsen mit Sternen', 'Emotion', 'Glück'],
  },
  {
    name: 'FaRegFaceGrinTears',
    searchTerms: ['Face Grin Tears', 'Grinsen mit Tränen', 'Emotion', 'Lachen'],
  },
  {
    name: 'FaRegFaceGrinTongueSquint',
    searchTerms: [
      'Face Grin Tongue Squint',
      'Zunge heraus und zusammengekniffene Augen',
      'Emotion',
      'Spaß',
    ],
  },
  {
    name: 'FaRegFaceGrinTongueWink',
    searchTerms: [
      'Face Grin Tongue Wink',
      'Zunge heraus und Zwinkern',
      'Emotion',
      'Spaß',
    ],
  },
  {
    name: 'FaRegFaceGrinTongue',
    searchTerms: ['Face Grin Tongue', 'Zunge heraus', 'Emotion', 'Spaß'],
  },
  {
    name: 'FaRegFaceGrinWide',
    searchTerms: ['Face Grin Wide', 'Breites Grinsen', 'Emotion', 'Glück'],
  },
  {
    name: 'FaRegFaceGrinWink',
    searchTerms: ['Face Grin Wink', 'Zwinkerndes Grinsen', 'Emotion', 'Spaß'],
  },
  {
    name: 'FaRegFaceGrin',
    searchTerms: ['Face Grin', 'Grinsen', 'Emotion', 'Glück'],
  },
  {
    name: 'FaRegFaceKissBeam',
    searchTerms: ['Face Kiss Beam', 'Kuss mit Strahlen', 'Emotion', 'Liebe'],
  },
  {
    name: 'FaRegFaceKissWinkHeart',
    searchTerms: [
      'Face Kiss Wink Heart',
      'Kuss mit Herz und Zwinkern',
      'Emotion',
      'Liebe',
    ],
  },
  {
    name: 'FaRegFaceKiss',
    searchTerms: ['Face Kiss', 'Kuss', 'Emotion', 'Liebe'],
  },
  {
    name: 'FaRegFaceLaughBeam',
    searchTerms: [
      'Face Laugh Beam',
      'Lachendes Gesicht mit Strahlen',
      'Emotion',
      'Lachen',
    ],
  },
  {
    name: 'FaRegFaceLaughSquint',
    searchTerms: [
      'Face Laugh Squint',
      'Lachendes Gesicht mit zusammengekniffenen Augen',
      'Emotion',
      'Lachen',
    ],
  },
  {
    name: 'FaRegFaceLaughWink',
    searchTerms: [
      'Face Laugh Wink',
      'Lachendes Gesicht mit Zwinkern',
      'Emotion',
      'Lachen',
    ],
  },
  {
    name: 'FaRegFaceLaugh',
    searchTerms: ['Face Laugh', 'Lachendes Gesicht', 'Emotion', 'Lachen'],
  },
  {
    name: 'FaRegFaceMehBlank',
    searchTerms: [
      'Face Meh Blank',
      'Ausdrucksloses Gesicht',
      'Emotion',
      'Gleichgültigkeit',
    ],
  },
  {
    name: 'FaRegFaceMeh',
    searchTerms: [
      'Face Meh',
      'Gleichgültiges Gesicht',
      'Emotion',
      'Gleichgültigkeit',
    ],
  },
  {
    name: 'FaRegFaceRollingEyes',
    searchTerms: ['Face Rolling Eyes', 'Augenrollen', 'Emotion', 'Sarkasmus'],
  },
  {
    name: 'FaRegFaceSadCry',
    searchTerms: [
      'Face Sad Cry',
      'Trauriges Gesicht mit Tränen',
      'Emotion',
      'Trauer',
    ],
  },
  {
    name: 'FaRegFaceSadTear',
    searchTerms: [
      'Face Sad Tear',
      'Trauriges Gesicht mit Tränen',
      'Emotion',
      'Trauer',
    ],
  },
  {
    name: 'FaRegFaceSmileBeam',
    searchTerms: [
      'Face Smile Beam',
      'Lächeln mit Strahlen',
      'Emotion',
      'Glück',
    ],
  },
  {
    name: 'FaRegFaceSmileWink',
    searchTerms: [
      'Face Smile Wink',
      'Lächeln mit Zwinkern',
      'Emotion',
      'Glück',
    ],
  },
  {
    name: 'FaRegFaceSmile',
    searchTerms: ['Face Smile', 'Lächeln', 'Emotion', 'Glück'],
  },
  {
    name: 'FaRegFaceSurprise',
    searchTerms: [
      'Face Surprise',
      'Überraschter Gesichtsausdruck',
      'Emotion',
      'Überraschung',
    ],
  },
  {
    name: 'FaRegFaceTired',
    searchTerms: ['Face Tired', 'Müdes Gesicht', 'Emotion', 'Erschöpfung'],
  },
  {
    name: 'FaRegFileAudio',
    searchTerms: ['File Audio', 'Audiodatei', 'Datei', 'Ton'],
  },
  {
    name: 'FaRegFileCode',
    searchTerms: ['File Code', 'Codierte Datei', 'Programmierung', 'Datei'],
  },
  {
    name: 'FaRegFileExcel',
    searchTerms: ['File Excel', 'Excel-Datei', 'Tabellenkalkulation', 'Datei'],
  },
  {
    name: 'FaRegFileImage',
    searchTerms: ['File Image', 'Bilddatei', 'Foto', 'Datei'],
  },
  {
    name: 'FaRegFileLines',
    searchTerms: ['File Lines', 'Dokumentdatei', 'Datei', 'Text'],
  },
  {
    name: 'FaRegFilePdf',
    searchTerms: ['File PDF', 'PDF-Datei', 'Dokument', 'Datei'],
  },
  {
    name: 'FaRegFilePowerpoint',
    searchTerms: [
      'File PowerPoint',
      'PowerPoint-Datei',
      'Präsentation',
      'Datei',
    ],
  },
  {
    name: 'FaRegFileVideo',
    searchTerms: ['File Video', 'Videodatei', 'Film', 'Datei'],
  },
  {
    name: 'FaRegFileWord',
    searchTerms: ['File Word', 'Word-Datei', 'Dokument', 'Text'],
  },
  {
    name: 'FaRegFileZipper',
    searchTerms: ['File Zipper', 'ZIP-Datei', 'Komprimierte Datei', 'Datei'],
  },
  {
    name: 'FaRegFile',
    searchTerms: ['File', 'Datei', 'Dokument', 'Daten'],
  },
  {
    name: 'FaRegFlag',
    searchTerms: ['Flag', 'Flagge', 'Symbol', 'Markierung'],
  },
  {
    name: 'FaRegFloppyDisk',
    searchTerms: ['Floppy Disk', 'Diskette', 'Speicherung', 'Daten'],
  },
  {
    name: 'FaRegFolderClosed',
    searchTerms: [
      'Folder Closed',
      'Geschlossener Ordner',
      'Dateien',
      'Dokumente',
    ],
  },
  {
    name: 'FaRegFolderOpen',
    searchTerms: ['Folder Open', 'Offener Ordner', 'Dateien', 'Dokumente'],
  },
  {
    name: 'FaRegFolder',
    searchTerms: ['Folder', 'Ordner', 'Dateien', 'Dokumente'],
  },
  {
    name: 'FaRegFontAwesome',
    searchTerms: ['Font Awesome', 'Icon', 'Schrift', 'Awesome'],
  },
  {
    name: 'FaRegFutbol',
    searchTerms: ['Futbol', 'Fußball', 'Sport', 'Ball'],
  },
  {
    name: 'FaRegGem',
    searchTerms: ['Gem', 'Edelstein', 'Schmuck', 'Wertvoll'],
  },
  {
    name: 'FaRegHandBackFist',
    searchTerms: ['Hand Back Fist', 'Hand mit Faust', 'Hand', 'Symbol'],
  },
  {
    name: 'FaRegHandLizard',
    searchTerms: ['Hand Lizard', 'Hand Eidechse', 'Hand', 'Symbol'],
  },
  {
    name: 'FaRegHandPeace',
    searchTerms: ['Hand Peace', 'Handzeichen Frieden', 'Hand', 'Frieden'],
  },
  {
    name: 'FaRegHandPointDown',
    searchTerms: [
      'Hand Point Down',
      'Hand zeigt nach unten',
      'Hand',
      'Richtung',
    ],
  },
  {
    name: 'FaRegHandPointLeft',
    searchTerms: [
      'Hand Point Left',
      'Hand zeigt nach links',
      'Hand',
      'Richtung',
    ],
  },
  {
    name: 'FaRegHandPointRight',
    searchTerms: [
      'Hand Point Right',
      'Hand zeigt nach rechts',
      'Hand',
      'Richtung',
    ],
  },
  {
    name: 'FaRegHandPointUp',
    searchTerms: ['Hand Point Up', 'Hand zeigt nach oben', 'Hand', 'Richtung'],
  },
  {
    name: 'FaRegHandPointer',
    searchTerms: ['Hand Pointer', 'Handzeiger', 'Mauszeiger', 'Hand'],
  },
  {
    name: 'FaRegHandScissors',
    searchTerms: ['Hand Scissors', 'Scherenhand', 'Hand', 'Symbol'],
  },
  {
    name: 'FaRegHandSpock',
    searchTerms: ['Hand Spock', 'Spock Handzeichen', 'Hand', 'Symbol'],
  },
  {
    name: 'FaRegHand',
    searchTerms: ['Hand', 'Hand', 'Geste', 'Symbol'],
  },
  {
    name: 'FaRegHandshake',
    searchTerms: ['Handshake', 'Handschlag', 'Vertrag', 'Abkommen'],
  },
  {
    name: 'FaRegHardDrive',
    searchTerms: ['Hard Drive', 'Festplatte', 'Speicher', 'Technologie'],
  },
  {
    name: 'FaRegHeart',
    searchTerms: ['Heart', 'Herz', 'Liebe', 'Symbol'],
  },
  {
    name: 'FaRegHospital',
    searchTerms: ['Hospital', 'Krankenhaus', 'Medizin', 'Gesundheit'],
  },
  {
    name: 'FaRegHourglassHalf',
    searchTerms: ['Hourglass Half', 'Sanduhr halb', 'Zeit', 'Symbol'],
  },
  {
    name: 'FaRegHourglass',
    searchTerms: ['Hourglass', 'Sanduhr', 'Zeit', 'Symbol'],
  },
  {
    name: 'FaRegIdBadge',
    searchTerms: ['ID Badge', 'Ausweis', 'Identifikation', 'Abzeichen'],
  },
  {
    name: 'FaRegIdCard',
    searchTerms: ['ID Card', 'Ausweiskarte', 'Identifikation', 'Karte'],
  },
  {
    name: 'FaRegImage',
    searchTerms: ['Image', 'Bild', 'Foto', 'Grafik'],
  },
  {
    name: 'FaRegImages',
    searchTerms: ['Images', 'Bilder', 'Fotos', 'Grafiken'],
  },
  {
    name: 'FaRegKeyboard',
    searchTerms: ['Keyboard', 'Tastatur', 'Schreiben', 'Eingabegerät'],
  },
  {
    name: 'FaRegLemon',
    searchTerms: ['Lemon', 'Zitrone', 'Frucht', 'Obst'],
  },
  {
    name: 'FaRegLifeRing',
    searchTerms: ['Life Ring', 'Rettungsring', 'Sicherheit', 'Rettung'],
  },
  {
    name: 'FaRegLightbulb',
    searchTerms: ['Lightbulb', 'Glühbirne', 'Idee', 'Licht'],
  },
  {
    name: 'FaRegMap',
    searchTerms: ['Map', 'Karte', 'Navigation', 'Richtung'],
  },
  {
    name: 'FaRegMessage',
    searchTerms: ['Message', 'Nachricht', 'Kommunikation', 'Sprechen'],
  },
  {
    name: 'FaRegMoneyBill1',
    searchTerms: ['Money Bill 1', 'Geldschein', 'Geld', 'Finanzen'],
  },
  {
    name: 'FaRegMoon',
    searchTerms: ['Moon', 'Mond', 'Nacht', 'Astronomie'],
  },
  {
    name: 'FaRegNewspaper',
    searchTerms: ['Newspaper', 'Zeitung', 'Nachrichten', 'Medien'],
  },
  {
    name: 'FaRegNoteSticky',
    searchTerms: ['Note Sticky', 'Notiz', 'Haftnotiz', 'Schreiben'],
  },
  {
    name: 'FaRegObjectGroup',
    searchTerms: ['Object Group', 'Objektgruppe', 'Gruppe', 'Layout'],
  },
  {
    name: 'FaRegObjectUngroup',
    searchTerms: ['Object Ungroup', 'Objekte trennen', 'Gruppe', 'Layout'],
  },
  {
    name: 'FaRegPaperPlane',
    searchTerms: ['Paper Plane', 'Papierflieger', 'Flugzeug', 'Nachricht'],
  },
  {
    name: 'FaRegPaste',
    searchTerms: ['Paste', 'Einfügen', 'Kopieren', 'Dokument'],
  },
  {
    name: 'FaRegPenToSquare',
    searchTerms: [
      'Pen to Square',
      'Stift auf Quadrat',
      'Bearbeiten',
      'Dokument',
    ],
  },
  {
    name: 'FaRegRectangleList',
    searchTerms: ['Rectangle List', 'Rechteckliste', 'Auflistung', 'Dokument'],
  },
  {
    name: 'FaRegRectangleXmark',
    searchTerms: ['Rectangle Xmark', 'Rechteck X', 'Schließen', 'Fehler'],
  },
  {
    name: 'FaRegRegistered',
    searchTerms: ['Registered', 'Eingetragen', 'Markenrecht', 'Schutz'],
  },
  {
    name: 'FaRegShareFromSquare',
    searchTerms: ['Share from Square', 'Teilen', 'Quadrat', 'Freigeben'],
  },
  {
    name: 'FaRegSnowflake',
    searchTerms: ['Snowflake', 'Schneeflocke', 'Winter', 'Kälte'],
  },
  {
    name: 'FaRegSquareCaretDown',
    searchTerms: [
      'Square Caret Down',
      'Quadrat Caret nach unten',
      'Richtung',
      'Pfeil',
    ],
  },
  {
    name: 'FaRegSquareCaretLeft',
    searchTerms: [
      'Square Caret Left',
      'Quadrat Caret nach links',
      'Richtung',
      'Pfeil',
    ],
  },
  {
    name: 'FaRegSquareCaretRight',
    searchTerms: [
      'Square Caret Right',
      'Quadrat Caret nach rechts',
      'Richtung',
      'Pfeil',
    ],
  },
  {
    name: 'FaRegSquareCaretUp',
    searchTerms: [
      'Square Caret Up',
      'Quadrat Caret nach oben',
      'Richtung',
      'Pfeil',
    ],
  },
  {
    name: 'FaRegSquareCheck',
    searchTerms: ['Square Check', 'Quadrat Check', 'Bestätigung', 'Häkchen'],
  },
  {
    name: 'FaRegSquareFull',
    searchTerms: ['Square Full', 'Volles Quadrat', 'Form', 'Geometrie'],
  },
  {
    name: 'FaRegSquareMinus',
    searchTerms: ['Square Minus', 'Quadrat Minus', 'Abziehen', 'Reduzieren'],
  },
  {
    name: 'FaRegSquarePlus',
    searchTerms: ['Square Plus', 'Quadrat Plus', 'Hinzufügen', 'Erhöhen'],
  },
  {
    name: 'FaRegSquare',
    searchTerms: ['Square', 'Quadrat', 'Form', 'Geometrie'],
  },
  {
    name: 'FaRegStarHalfStroke',
    searchTerms: [
      'Star Half Stroke',
      'Halber Stern mit Strich',
      'Bewertung',
      'Symbol',
    ],
  },
  {
    name: 'FaRegStarHalf',
    searchTerms: ['Star Half', 'Halber Stern', 'Bewertung', 'Symbol'],
  },
  {
    name: 'FaRegStar',
    searchTerms: ['Star', 'Stern', 'Bewertung', 'Symbol'],
  },
  {
    name: 'FaRegSun',
    searchTerms: ['Sun', 'Sonne', 'Wetter', 'Tag'],
  },
  {
    name: 'FaRegThumbsDown',
    searchTerms: ['Thumbs Down', 'Daumen runter', 'Ablehnung', 'Negativ'],
  },
  {
    name: 'FaRegThumbsUp',
    searchTerms: ['Thumbs Up', 'Daumen hoch', 'Zustimmung', 'Positiv'],
  },
  {
    name: 'FaRegTrashCan',
    searchTerms: ['Trash Can', 'Mülleimer', 'Abfall', 'Löschen'],
  },
  {
    name: 'FaRegUser',
    searchTerms: ['User', 'Benutzer', 'Person', 'Account'],
  },
  {
    name: 'FaRegWindowMaximize',
    searchTerms: [
      'Window Maximize',
      'Fenster maximieren',
      'Anzeige',
      'Vergrößern',
    ],
  },
  {
    name: 'FaRegWindowMinimize',
    searchTerms: [
      'Window Minimize',
      'Fenster minimieren',
      'Anzeige',
      'Verkleinern',
    ],
  },
  {
    name: 'FaRegWindowRestore',
    searchTerms: [
      'Window Restore',
      'Fenster wiederherstellen',
      'Anzeige',
      'Wiederherstellen',
    ],
  },
];

// Prompt: Kannst du aus folgenden FontAwesome Icons ein Mapping erstellen? Es soll in diesem Stil sein, hier ein Beispiel: Input: "export declare const FaSuperpowers: IconType;" Output: "{
//     name: 'FaSuperpowers',
//     searchTerms: ['Superpowers', 'Fähigkeiten', 'Kräfte', 'Helden'],
//   },"

export { iconList };
